require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/075fbe5213aec3d601f23091a4de25e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4'] = function fn_075fbe5213aec3d601f23091a4de25e4(ItemType, Type, ItemSKU, LotAction, _Lot, AdjustmentQuantity, UpdateDB, AssemblyName, BuildNumber) {
var lotAdjustmentData;


  if (LotAction == 'Inventory Received') {
    console.log('### Lot Action: Inventory Received ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: AdjustmentQuantity,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Item Initialized') {
    if (ItemType == 'Assembly') {
      console.log('### Item Initialized ###');
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Item Initialized ###');
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Item Initialized ###');
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Inventory Adjusted') {
    console.log('### Lot Action: Inventory Adjusted +/- ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: AdjustmentQuantity,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Lot Adjusted-DISABLED!') {
  } else if (LotAction == 'Build') {
    console.log('### Lot Action: Build ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: AdjustmentQuantity,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: AdjustmentQuantity,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: AdjustmentQuantity,[`QtyOnHand`]: AdjustmentQuantity,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: AdjustmentQuantity,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Reservation') {
    console.log('### Lot Action: Reservation ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Items Shipped') {
    console.log('### Lot Action: Items Shipped ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: AdjustmentQuantity,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: AdjustmentQuantity,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Reservation/Shipped') {
    console.log('### Lot Action: Reservation + Items Shipped ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Assembly Items Shipped') {
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: AdjustmentQuantity,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: AdjustmentQuantity,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: AdjustmentQuantity * -1,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: AdjustmentQuantity * -1,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity * -1,[`QtyReserved`]: AdjustmentQuantity * -1,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Item In Build') {
    console.log('### Item In Build Detected ###');
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: AssemblyName });
      }
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: -1 * AdjustmentQuantity,[`AssemblyName`]: [AssemblyName,' => B',BuildNumber].join('') });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: -1 * AdjustmentQuantity,[`AssemblyName`]: [AssemblyName,' => B ',BuildNumber].join('') });
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      if (Type == 'Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: [AssemblyName,' => B',BuildNumber].join('') });
      } else if (Type == 'No Lot Required') {
        lotAdjustmentData = ({ [`ItemType`]: ItemType,[`Type`]: Type,[`ItemSKU`]: ItemSKU,[`LotAction`]: LotAction,[`_Lot`]: _Lot,[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: AdjustmentQuantity,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: AdjustmentQuantity * -1,[`AssemblyName`]: [AssemblyName,' => B',BuildNumber].join('') });
      }
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
    }
  } else if (LotAction == 'Item In Build: Reservation/Shipped') {
    if (ItemType == 'Assembly') {
      console.log('### Assembly Detected ###');
      console.log('### NOTHING DONE ###');
    } else if (ItemType == 'Subassembly') {
      console.log('### Subassembly Detected ###');
      if (Type == 'Lot Required') {
      } else if (Type == 'No Lot Required') {
      }
    } else if (ItemType == 'Inventory Item') {
      console.log('### Inventory Item Detected ###');
      console.log('### NOTHING DONE ###');
    } else if (ItemType == 'Non-Inventory Item') {
      console.log('### Non-Inventory Item Detected ###');
      console.log('### NOTHING DONE ###');
    }
  }

return lotAdjustmentData
}

})
define('./functions/1435fbe7d0246cabf63e29b22d4bd3db/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db'] = async function fn_1435fbe7d0246cabf63e29b22d4bd3db(SearchField, DisplayInactive, SQLBuilderResults, BypassSQLBuilder, DisplayingPageOffset) {
var totalMatchingItemCount, returnedItems, activeProductsCount, pageData, inactiveProductsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Function: SQLBuilderResults ###');
  console.log(SQLBuilderResults);
  console.log('##################################################################');
  console.log('%c>> ' + 'SQLBuilderResults', 'color: #ef5350', SQLBuilderResults);
  if (SQLBuilderResults == 'ItemType IN ()') {
    return [];
  }
  if (SearchField != '') {
    returnedItems = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',SearchField,'%\' OR Bin LIKE \'%',SearchField,'%\' OR ItemSKU LIKE \'%',SearchField,'%\' OR Customer LIKE \'%',SearchField,'%\')',' AND (',SQLBuilderResults,')',' AND (',DisplayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: LoadItemsIntoRepeater | SearchField NOT EMPTY')));
    console.log('%c>> ' + '### SQL FILTER CONTENT ###', 'color: #f06292', returnedItems);
    return returnedItems;
  } else if (SearchField == '') {
    returnedItems = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',SearchField,'%\' OR Bin LIKE \'%',SearchField,'%\' OR ItemSKU LIKE \'%',SearchField,'%\' OR Customer LIKE \'%',SearchField,'%\')',' AND (',SQLBuilderResults,')',' AND (',DisplayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: LoadItemsIntoRepeater | SearchField = EMPTY')));
    console.log('%c>> ' + '### SQL FILTER CONTENT ###', 'color: #f06292', returnedItems);
    return returnedItems;
  } else if (SearchField == null) {
    returnedItems = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',SearchField,'%\' OR Bin LIKE \'%',SearchField,'%\' OR ItemSKU LIKE \'%',SearchField,'%\' OR Customer LIKE \'%',SearchField,'%\')',' AND (',SQLBuilderResults,')',' AND (',DisplayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: LoadItemsIntoRepeater | SearchField = NULL')));
    totalMatchingItemCount = (getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',SearchField,'%\' OR Bin LIKE \'%',SearchField,'%\' OR ItemSKU LIKE \'%',SearchField,'%\' OR Customer LIKE \'%',SearchField,'%\')',' AND (',SQLBuilderResults,')',' AND (',DisplayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setProperties('COUNT(Status) As ProductsCount').setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: LoadItemsIntoRepeater | SearchField = NULL')))[0]), 'ProductsCount'));
  }

return returnedItems
}

})
define('./functions/2bd132e2c401295ea0df9b5461165e27/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'] = async function fn_2bd132e2c401295ea0df9b5461165e27(displayInactive, searchValue, SQLBuilderResults, DisplayingPageOffset, perPage) {
var calculatedNumberOfPages, totalMatchingItemsCount, currentItems, customerPortalAccess, results, userTempStorage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'Function Call: ItemsPagingHandler', 'color: #ffee58', ({ [`displayInactive`]: displayInactive,[`searchValue`]: searchValue,[`SQLBuilderResults`]: SQLBuilderResults,[`DisplayingPageOffset`]: DisplayingPageOffset,[`perPage`]: perPage }));
  userTempStorage = (await Backendless.UserService.getCurrentUser(true));
  customerPortalAccess = (getObjectProperty(userTempStorage, 'CustomerPortalAccess'));
  if (getObjectProperty(userTempStorage, 'CustomerPortalOnly')) {
    totalMatchingItemsCount = (getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',searchValue,'%\' OR Bin LIKE \'%',searchValue,'%\' OR ItemSKU LIKE \'%',searchValue,'%\' OR Customer LIKE \'%',searchValue,'%\')',' AND (',SQLBuilderResults,')',' AND (',displayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')',' AND (SelectedCustomer = \'',customerPortalAccess,'\')'].join(''))).setProperties('COUNT(Status) As ProductsCount').setSortBy('ItemName ASC').setPageSize(1).setFileReferencePrefix('Function: ItemsPagingHandler | SearchField = NULL')))[0]), 'ProductsCount'));
    currentItems = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',searchValue,'%\' OR Bin LIKE \'%',searchValue,'%\' OR ItemSKU LIKE \'%',searchValue,'%\' OR Customer LIKE \'%',searchValue,'%\')',' AND (',SQLBuilderResults,')',' AND (',displayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')',' AND (SelectedCustomer = \'',customerPortalAccess,'\')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: ItemsPagingHandler | SearchField = NULL')));
  } else {
    currentItems = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',searchValue,'%\' OR Bin LIKE \'%',searchValue,'%\' OR ItemSKU LIKE \'%',searchValue,'%\' OR Customer LIKE \'%',searchValue,'%\')',' AND (',SQLBuilderResults,')',' AND (',displayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setOffset(DisplayingPageOffset).setFileReferencePrefix('Function: ItemsPagingHandler | SearchField = NULL')));
    totalMatchingItemsCount = (getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',searchValue,'%\' OR Bin LIKE \'%',searchValue,'%\' OR ItemSKU LIKE \'%',searchValue,'%\' OR Customer LIKE \'%',searchValue,'%\')',' AND (',SQLBuilderResults,')',' AND (',displayInactive == true ? 'Status = \'Inactive\'' : 'Status = \'Active\'',')'].join(''))).setProperties('COUNT(Status) As ProductsCount').setSortBy('ItemName ASC').setPageSize(1).setFileReferencePrefix('Function: ItemsPagingHandler | SearchField = NULL')))[0]), 'ProductsCount'));
  }
  calculatedNumberOfPages = Math.ceil(totalMatchingItemsCount / perPage);
  console.log('%c>> ' + 'Function Call: ItemsPagingHandler', 'color: #ffee58', ({ [`ItemsList`]: currentItems,[`TotalMatchingItemsCount`]: totalMatchingItemsCount,[`NumberOfPages`]: calculatedNumberOfPages }));

return ({ [`ItemsList`]: currentItems,[`TotalMatchingItemsCount`]: totalMatchingItemsCount,[`NumberOfPages`]: calculatedNumberOfPages })
}

})
define('./functions/2ce7c0b7d9ce3cdd1a4c6d1d6c0bebfe/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2ce7c0b7d9ce3cdd1a4c6d1d6c0bebfe'] = async function fn_2ce7c0b7d9ce3cdd1a4c6d1d6c0bebfe(pageData, ItemType) {
var listConstruct, item, allBinsList, i, binsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  allBinsList = [];
  var i_inc = 100;
  if (1 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }
  listConstruct = (await Promise.all(allBinsList.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'BinNumber')) });})));

return listConstruct
}

})
define('./functions/3195e83b2ec43b1473c66d77d0fe9fdd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'] = async function fn_3195e83b2ec43b1473c66d77d0fe9fdd(items) {
return (await (async function(items) {
	items = items.map(item => {
	  if (item === '\n') {
	    return React.createElement('br')
	  }
	  return item
	})

	return React.createElement('span', {}, ...items)
})(items))
}

})
define('./functions/438781d3580fc856c887c59cb5b3dfe9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_438781d3580fc856c887c59cb5b3dfe9'] = function fn_438781d3580fc856c887c59cb5b3dfe9(x) {

}

})
define('./functions/592da58bdb887e34feee6d5f9ae82ef5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_592da58bdb887e34feee6d5f9ae82ef5'] = function fn_592da58bdb887e34feee6d5f9ae82ef5(totalItems, perPage, pageCursor) {
function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}



return (roundDecimals((totalItems / perPage),0))
}

})
define('./functions/6a98faf911626d9b0c38f4c74f73972d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6a98faf911626d9b0c38f4c74f73972d'] = function fn_6a98faf911626d9b0c38f4c74f73972d() {
return 
}

})
define('./functions/80f5df059c5818d57f94d4f3c4ccbb8d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'] = async function fn_80f5df059c5818d57f94d4f3c4ccbb8d(pageData, ItemTypes, SQLBuilder, AutocompleteExclusionObjectID) {
var listConstruct, itemCount, item, options, mainItemsList, i, numberOfPages;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (true) {
    if (SQLBuilder != '') {
      itemCount = (Number((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['Status = \'Active\' AND ',SQLBuilder,''].join(''))).setProperties('Count(ItemName) AS ItemCount').setSortBy('ItemName').setPageSize(1).setFileReferencePrefix('### FUNCTION: LoadAutoCompleteOptions | ItemTypes is SET! ###')))[0]), 'ItemCount'))));
      numberOfPages = itemCount / 100;
      mainItemsList = [];
      var i_inc = 100;
      if (0 > itemCount) {
        i_inc = -i_inc;
      }
      for (i = 0; i_inc >= 0 ? i <= itemCount : i >= itemCount; i += i_inc) {
        if (AutocompleteExclusionObjectID != '') {
          mainItemsList = (mainItemsList.concat((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['Status = \'Active\' AND ',SQLBuilder,' AND objectId <> \'',AutocompleteExclusionObjectID,'\''].join(''))).setSortBy('ItemName').setPageSize(100).setOffset(i).setFileReferencePrefix('### FUNCTION: LoadAutoCompleteOptions | PAGING ###')))));
        } else {
          mainItemsList = (mainItemsList.concat((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['Status = \'Active\' AND ',SQLBuilder,''].join(''))).setSortBy('ItemName').setPageSize(100).setOffset(i).setFileReferencePrefix('### FUNCTION: LoadAutoCompleteOptions | PAGING ###')))));
        }
      }
      options = mainItemsList;
      listConstruct = (await Promise.all(options.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'ItemName')) });})));
      console.log('### FUNCTION: LoadAutocompleteOptions.listConstruct | ItemTypes is SET! ###');
      console.log(listConstruct);
    } else if (SQLBuilder == '') {
      itemCount = (Number((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Status = \'Active\' '))).setProperties('Count(ItemName) AS ItemCount').setSortBy('ItemName').setPageSize(1).setFileReferencePrefix('### FUNCTION: LoadAutoCompleteOptions | ItemTypes is NOT set ###')))[0]), 'ItemCount'))));
      numberOfPages = itemCount / 100;
      mainItemsList = [];
      var i_inc2 = 100;
      if (0 > itemCount) {
        i_inc2 = -i_inc2;
      }
      for (i = 0; i_inc2 >= 0 ? i <= itemCount : i >= itemCount; i += i_inc2) {
        mainItemsList = (mainItemsList.concat((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((String('Status = \'Active\''))).setSortBy('ItemName').setPageSize(100).setOffset(i).setFileReferencePrefix('### FUNCTION: LoadAutoCompleteOptions (ItemTypes = NOT SET | PAGING!) ###')))));
      }
      options = mainItemsList;
      listConstruct = (await Promise.all(options.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'ItemName')) });})));
      console.log('### FUNCTION: LoadAutocompleteOptions.listConstruct | ItemTypes is BLANK  ###');
      console.log(listConstruct);
    }
    pageData['TotalItemCount'] = itemCount;
  }

return listConstruct
}

})
define('./functions/858220770dd2cd5781ac7cc60be4f633/code.js', () => { 

BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633'] = async function fn_858220770dd2cd5781ac7cc60be4f633(BuildInputCacheObjectID, BuildBOM, LotNumber, QtyToBuild) {
var txResult, TX1, UpdateLot, findAssemblyRef, localTargetLotsOfLots, sourceLotsOfLots;


  TX1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = TX1;

    findAssemblyRef = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',BuildInputCacheObjectID,'\''].join(''))).setPageSize(1)).setOpResultId('FindMatchingAssembly'));
    console.log('#### ENTIRE REFERENCE ####');
    console.log(findAssemblyRef);
    localTargetLotsOfLots = (findAssemblyRef.resolveTo(0));
    console.log('### Local Target LotsOfLots ###');
    console.log(localTargetLotsOfLots);

  })();

  txResult = (await TX1.execute());

return txResult
}

})
define('./functions/8a5780448fe94c0c8d45ed833d64ec8b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'] = function fn_8a5780448fe94c0c8d45ed833d64ec8b(InventoryAction, ItemSKU, LotNumber, Quan) {
var return2, stamp;


  stamp = (new Date());
  if (InventoryAction == 'Inventory Received') {
    return2 = ['Received: (',Quan,') of Item: [',ItemSKU,']','\n','Into Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Inventory Adjusted') {
    return2 = ['Adjusted Inventory: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Build') {
    return2 = ['Built: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Reservation') {
    return2 = ['Inventory Reservation: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Items Shipped') {
    return2 = ['Items Shipped: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Reservation/Shipped') {
    return2 = ['Reservation/Shipped: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Assembly Items Shipped') {
    return2 = ['Assembly Items Shipped: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Inventory Adjusted') {
    return2 = ['Assembly Items Shipped: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Item In Build') {
    return2 = ['Item In Build: (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Item In Build: Reservation/Shipped') {
    return2 = ['Item In Build: Reservation/Shipped (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  } else if (InventoryAction == 'Item Initialized') {
    return2 = ['Item Initialized (',Quan,') of Item: [',ItemSKU,']','\n','Of Lot: [',LotNumber,'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join('');
  }

return return2
}

})
define('./functions/9a437e8f4e58252872a56d12cf7aa26d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9a437e8f4e58252872a56d12cf7aa26d'] = async function fn_9a437e8f4e58252872a56d12cf7aa26d(SearchField, DisplayInactive, SQLBuilderResults, BypassSQLBuilder) {
var returnedItems, result, user, userToken, password, username, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
  } else {
  }
  console.log('### Function: SQLBuilderResults ###');
  console.log(SQLBuilderResults);
  console.log('##################################################################');
  console.log('%c>> ' + 'SQLBuilderResults', 'color: #ef5350', SQLBuilderResults);
  if (SQLBuilderResults == 'ItemType IN ()') {
    return [];
  }
  if (SearchField != '') {
    returnedItems = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('UserToken')) })).setEncoding('utf8').send()), 'items'));
    console.log('%c>> ' + '### SQL FILTER CONTENT ###', 'color: #f06292', returnedItems);
    return returnedItems;
  } else if (SearchField == '') {
    returnedItems = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('UserToken')) })).setEncoding('utf8').send()), 'items'));
    console.log('%c>> ' + '### SQL FILTER CONTENT ###', 'color: #f06292', returnedItems);
    return returnedItems;
  } else if (SearchField == null) {
    returnedItems = (getObjectProperty((await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')).set(({ [`Authorization`]: ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('UserToken')) })).setEncoding('utf8').send()), 'items'));
    return returnedItems;
  }

return 
}

})
define('./functions/9e140061e49246ea0feace349c11dc26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9e140061e49246ea0feace349c11dc26'] = function fn_9e140061e49246ea0feace349c11dc26() {
var decision, item, selectedItem;

/**
 * Describe this function...
 */
async function ResetLock() {
}



return 
}

})
define('./functions/a063ed0d1c0764c1ef1977f838bd4dd3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'] = function fn_a063ed0d1c0764c1ef1977f838bd4dd3(pageData) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(pageData, 'SelectedRecord')) != '' && (getObjectProperty(pageData, 'AdjustQuantityOnHand')) != '0') {
    console.log('SelectedRecord = true');
    return true;
  } else {
    console.log('SelectedRecord = false');
    return false;
  }

return 
}

})
define('./functions/a9226edfdf2d5df47285bacb28b24afc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc'] = async function fn_a9226edfdf2d5df47285bacb28b24afc(objectId, LotID) {
var lotExists, LotItem, lotsList, resultsItem;


  resultsItem = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',LotID,'\''].join(''))).setPageSize(10)));
  console.log('### RESULTS ITEM ###');
  console.log(resultsItem);
  if (resultsItem.length > 0) {
    return true;
  } else {
    return false;
  }

return 
}

})
define('./functions/b9ba2194016bb7148a66b77804bdb589/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'] = async function fn_b9ba2194016bb7148a66b77804bdb589(ItemSKU, Lot_objectId, LotNumber) {
var return2;


  if (ItemSKU != null) {
    return2 = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',ItemSKU,'\''].join(''))).setProperties(['SUM (QtyReceived) as TotalQtyReceived ', 'SUM (QtyOnHand) as TotalQtyOnHand ', 'SUM (QtyInLots) as TotalQtyInLots', 'SUM (QtyInAssemblies) as TotalQtyInAssemblies', 'SUM (QtyReserved) as TotalQtyReserved', 'SUM (QtyShipped) as TotalQtyShipped', 'SUM (QtyAvailable) as TotalQtyAvailable']).setPageSize(100)))[0];
    console.log('### Func: RecalculateLotTotals: WE HAVE A SKU ###');
  } else if (Lot_objectId != null) {
    return2 = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_objectId = \'',Lot_objectId,'\''].join(''))).setProperties(['SUM (QtyReceived) as TotalQtyReceived ', 'SUM (QtyOnHand) as TotalQtyOnHand ', 'SUM (QtyInLots) as TotalQtyInLots', 'SUM (QtyInAssemblies) as TotalQtyInAssemblies', 'SUM (QtyReserved) as TotalQtyReserved', 'SUM (QtyShipped) as TotalQtyShipped', 'SUM (QtyAvailable) as TotalQtyAvailable']).setPageSize(100)))[0];
    console.log('### Func: RecalculateLotTotals: WE HAVE A Lot_objectId ###');
  } else if (LotNumber != null) {
    return2 = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',LotNumber,'\''].join(''))).setProperties(['SUM (QtyReceived) as TotalQtyReceived ', 'SUM (QtyOnHand) as TotalQtyOnHand ', 'SUM (QtyInLots) as TotalQtyInLots', 'SUM (QtyInAssemblies) as TotalQtyInAssemblies', 'SUM (QtyReserved) as TotalQtyReserved', 'SUM (QtyShipped) as TotalQtyShipped', 'SUM (QtyAvailable) as TotalQtyAvailable']).setPageSize(100)))[0];
    console.log('### Func: RecalculateLotTotals: WE HAVE A LotNumber ###');
  }

return return2
}

})
define('./functions/c2e3dff976fd4c1ef581428608612b72/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72'] = async function fn_c2e3dff976fd4c1ef581428608612b72(CustomerPortalAccess, SearchField, SelectedCustomer, SQLBuilderResults) {
  if (SQLBuilderResults == 'ItemType IN ()') {
    return [];
  }
  if (!(CustomerPortalAccess === null)) {
    if (SearchField != '') {
      return (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\' AND (ItemName LIKE \'%',SearchField,'%\' OR Bin LIKE \'%',SearchField,'%\' OR ItemSKU LIKE \'%',SearchField,'%\')',' AND (',SQLBuilderResults,')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setFileReferencePrefix('Function: LoadItemsIntoPortalRepeater | CustomerPortal = True, SearchField NOT EMPTY')));
    } else {
      return (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',SelectedCustomer,'\'',' AND (',SQLBuilderResults,')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setFileReferencePrefix('Function: LoadItemsIntoPortalRepeater | CustomerPortal = True |  SearchField = Empty')));
    }
  } else {
    return (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',SelectedCustomer,'\'',' AND (',SQLBuilderResults,')'].join(''))).setSortBy('ItemName ASC').setPageSize(50).setFileReferencePrefix('Function: LoadItemsIntoPortalRepeater | CustomerPortal NOT Set')));
  }

return 
}

})
define('./functions/d6b3febe14160053c0058b53a144c2b5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5'] = function fn_d6b3febe14160053c0058b53a144c2b5(SQLBuilderList) {
var constructedText, baseSQLEnd, filter, baseSQLStart;


  baseSQLStart = 'ItemType IN (';
  filter = SQLBuilderList.join(',');
  baseSQLEnd = ')';
  constructedText = [baseSQLStart,filter,baseSQLEnd].join('');
  console.log('%c>> ' + '### PAGE BUILDER SQL ###', 'color: #f06292', constructedText);

return constructedText
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['user'] = (
      await (async function(userIdentity){
        var userColumns = await Backendless.UserService.describeUserClass()
        var identityColumn = userColumns.find(column => column.identity)
        var whereClause = `${identityColumn.name} = '${userIdentity}'`
        var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
        var users = await Backendless.Data.of(Backendless.User).find(query)

        return users[0]
     })((___arguments.context.pageData['userIdentity']))
  );

  },  
/* handler:onEnter *//* content */
}));

define('./pages/404/components/3665111f5a5b9f8f4b064bbdf6ce7a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/DIV-Playground/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  console.log(generateUUID().short());

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/0e619b428d73ef0f5c9163a74a278617/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/f9a5c6bb4a37659a40d9939c2c53afbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca'))['selected'] = 'null';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  if (result) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    ___arguments.context.pageData['AssignEnabled'] = true;
    ___arguments.context.pageData['AssignPlusEnabled'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['AssignEnabled'] = false;
    ___arguments.context.pageData['AssignPlusEnabled'] = false;
  }
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/90e367b4f067ac5b85377b386be28b53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/d3bd969898549a22cb2382cde44812b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedRecord'] = '';
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/039d301f2eb51eb1b901b2ed18fbbe91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;


  ___arguments.context.pageData['NewSpecimenID'] = ___arguments.value;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;
  console.log(result);

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['border'] = '4';

  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')));
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/a00513ada6a71e7a7c0c29a983b996ca/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var rawProvidersList, item, ActiveProvidersList, j;


  rawProvidersList = (await Backendless.Data.of('Processing_Definitions').find(Backendless.DataQueryBuilder.create().setSortBy('ProviderName ASC').setPageSize(100)));

  return [({ [`key`]: '1',[`label`]: 'USWellness',[`data`]: 'USWhomekitorders',[`children`]: undefined }), ({ [`key`]: '2',[`label`]: 'LabSavvy',[`data`]: 'LabSavvy',[`children`]: undefined })]

  },
  /* handler:optionsLogic */
  /* handler:onSelect */
  ['onSelect'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments['selectedItem']);
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedTableName'] = (getObjectProperty(___arguments['selectedItem'], 'data'));
  ___arguments.context.pageData['SelectedProvider'] = (getObjectProperty(___arguments['selectedItem'], 'label'));
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;

  },
  /* handler:onSelect */
  /* handler:onUnselect */
  ['onUnselect'](___arguments) {
    var result;


  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedTableName'] = '';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';

  },
  /* handler:onUnselect */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/33dd734c62b7a0a58161c28a989b779c/bundle.js', [], () => ({
  /* content */
  /* handler:onTableNameAssignment */
  ['onTableNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))

  },
  /* handler:onTableNameAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var returnedCache, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.selectedRecord);
  ___arguments.context.pageData['SelectedRecord'] = ___arguments.selectedRecord;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  if (result) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    ___arguments.context.pageData['AssignEnabled'] = true;
    ___arguments.context.pageData['AssignPlusEnabled'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['AssignEnabled'] = false;
    ___arguments.context.pageData['AssignPlusEnabled'] = false;
  }
  if (await Backendless.Cache.contains((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')))) {
    returnedCache = (await Backendless.Cache.get((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId'))));
    ___arguments.context.pageData['StoredCache'] = returnedCache;
    ___arguments.context.pageData['UndoEnabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['UndoEnabled'] = false;
  }

  },
  /* handler:onRecordSelect */
  /* handler:onRecordsRequest */
  async ['onRecordsRequest'](___arguments) {
    var sortBy, tableName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.searchText);
  tableName = (getObjectProperty(___arguments.context.pageData, 'SelectedTableName'));
  sortBy = ___arguments.sortBy;
  if (!sortBy) {
    sortBy = 'created DESC';
  }

  return ({ [`count`]: (await Backendless.Data.of(tableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(___arguments.whereClause))),[`items`]: (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(___arguments.whereClause).setSortBy(sortBy).setPageSize(___arguments.pageSize).setOffset(___arguments.offset))) })

  },
  /* handler:onRecordsRequest */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/2f8aa707a909ef31a0abc0a4399a9c34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Selected Record: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'OrderID')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AssignEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTracking'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    console.log(tempObject);
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTrackingID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
  }
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject, storedCacheObjectID, storedCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = '';
    tempObject['InboundTracking'] = '';
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = '';
    tempObject['InboundTrackingID'] = '';
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTracking'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    console.log(tempObject);
    ___arguments.context.pageData['SelectedRecord'] = '';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTrackingID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca'))['selected'] = 'null';
  ___arguments.context.pageData['UndoEnabled'] = false;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f9a5c6bb4a37659a40d9939c2c53afbd')));
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AssignPlusEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject, storedCacheObjectID, storedCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
      tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
      tempObject['SpecimenID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'SpecimenID'));
      tempObject['InboundTracking'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'InboundTracking'));
      await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
      console.log(tempObject);
      await Backendless.Cache.remove(storedCacheObjectID);
      ___arguments.context.pageData['UndoEnabled'] = false;
      ___arguments.context.pageData['SelectedRecord'] = '';
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
      tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
      tempObject['kit_order_no'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'kit_order_no'));
      tempObject['InboundTrackingID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'InboundTrackingID'));
      await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
      await Backendless.Cache.remove(storedCacheObjectID);
      ___arguments.context.pageData['UndoEnabled'] = false;
      ___arguments.context.pageData['SelectedRecord'] = '';
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/1b85fdc7dfb2fe2e87b27b8d9bb1bf1e/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;


  ___arguments.context.pageData['NewInboundTracking'] = ___arguments.value;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;
  console.log(result);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Processing_Portal_Backup/components/589ad40bb865f2b3d2952b0222bd2f04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedProvider'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/S3_Playground/components/6ec7ec6895097258b21675e72b6daa1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(new Date());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/dcb90f2bebe701a6e9884b685b5af4cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((new Date()).valueOf());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/2478d6895e0decb8a2e83a4743580088/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(new Date((new Date())).getDate());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/2464a8ff3da3d515bf8899f2c369d98b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var startingTimestamp, currentDate;


  currentDate = (new Date());
  currentDate.setHours(0);
  currentDate.setMinutes(0);
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(1);
  startingTimestamp = (currentDate.valueOf());
  console.log(String('Starting Timestamp: ') + String(startingTimestamp));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/c6b8e32ca4e807981f68a948f11a0991/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var currentDate, endingTimestamp;


  currentDate = (new Date());
  currentDate.setHours(23);
  currentDate.setMinutes(59);
  currentDate.setSeconds(59);
  currentDate.setMilliseconds(999);
  endingTimestamp = (currentDate.valueOf());
  console.log(String('Ending Timestamp: ') + String(endingTimestamp));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/c7f8e569b5bf7448ee18fb6b4efd156c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateToday, digits, endingTimestamp, startingTimestamp, tempRecords, todayDay, todayFileName, twoDigitDay, twoDigitMonth, yesterdayDay, yesterdayFileName;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function GetTwoDigitMonth() {
  twoDigitMonth = (JSON.stringify((new Date(dateToday).getMonth() + 1)));
  digits = getValueLength(twoDigitMonth);
  console.log(['There are: ',digits,' digits in the current month'].join(''));
  if ((Number(digits)) == 1) {
    twoDigitMonth = String('0') + String(twoDigitMonth);
    return twoDigitMonth;
  } else {
    return twoDigitMonth;
  }
}

/**
 * Describe this function...
 */
async function GetTwoDigitDay() {
  twoDigitDay = (JSON.stringify((new Date(dateToday).getDate())));
  digits = getValueLength(twoDigitDay);
  console.log(['There are: ',digits,' digits in the current day'].join(''));
  if ((Number(digits)) == 1) {
    twoDigitDay = String('0') + String(twoDigitDay);
    return twoDigitDay;
  } else {
    return twoDigitDay;
  }
}


  dateToday = (new Date());
  todayDay = (new Date(dateToday).getDate());
  yesterdayDay = (new Date((new Date(dateToday.getTime() - (86400 * 1000)))).getDate());
  console.log(String('Today: ') + String(todayDay));
  console.log(String('Yesterday: ') + String(yesterdayDay));
  twoDigitMonth = await GetTwoDigitMonth();
  twoDigitDay = await GetTwoDigitDay();
  console.log(twoDigitMonth);
  console.log(twoDigitDay);
  todayFileName = ['USW_BILT_',(new Date(dateToday).getFullYear()),twoDigitMonth,twoDigitDay,'.csv'].join('');
  console.log(todayFileName);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/S3_Playground/components/8558776100efa4a84599bdf2dd88c9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateToday, dateYesterday, digits, todayDay, todayFileName, twoDigitDay, twoDigitMonth, yesterdayDay;

/**
 * Describe this function...
 */
async function SubtractADay() {
  dateYesterday = (new Date(dateToday.getTime() - (86400 * 1000)));
  return dateYesterday
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function GetTwoDigitMonth() {
  twoDigitMonth = (JSON.stringify((new Date(dateYesterday).getMonth() + 1)));
  digits = getValueLength(twoDigitMonth);
  console.log(['There are: ',digits,' digits in the current month'].join(''));
  if ((Number(digits)) == 1) {
    twoDigitMonth = String('0') + String(twoDigitMonth);
    return twoDigitMonth;
  } else {
    return twoDigitMonth;
  }
}

/**
 * Describe this function...
 */
async function GetTwoDigitDay() {
  twoDigitDay = (JSON.stringify((new Date(dateYesterday).getDate())));
  digits = getValueLength(twoDigitDay);
  console.log(['There are: ',digits,' digits in the current day'].join(''));
  if ((Number(digits)) == 1) {
    twoDigitDay = String('0') + String(twoDigitDay);
    return twoDigitDay;
  } else {
    return twoDigitDay;
  }
}


  dateToday = (new Date());
  todayDay = (new Date(dateToday).getDate());
  yesterdayDay = (new Date((new Date(dateToday.getTime() - (86400 * 1000)))).getDate());
  dateYesterday = await SubtractADay();
  console.log(String('Today: ') + String(todayDay));
  console.log(String('Yesterday: ') + String(yesterdayDay));
  twoDigitMonth = await GetTwoDigitMonth();
  twoDigitDay = await GetTwoDigitDay();
  console.log(twoDigitMonth);
  console.log(twoDigitDay);
  todayFileName = ['USW_BILT_',(new Date(dateYesterday).getFullYear()),twoDigitMonth,twoDigitDay,'.csv'].join('');
  console.log(todayFileName);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var tempData, currentUser;


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/admin/components/e592076c3c1956324293bfbb7376fa9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'SOSAuth_Access')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin/components/ac5147e856fc09051aa5f4324daad1b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempData, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempData = (await Backendless.Data.of('SOSAuth').find(Backendless.DataQueryBuilder.create().setWhereClause('objectId = \'2D2F6C68-3183-4EB9-8DFB-8163CCA1660C\'').setPageSize(1)))[0];
  console.log(tempData);
  ___arguments.context.pageData['access_token'] = (getObjectProperty(tempData, 'access_token'));
  ___arguments.context.pageData['refresh_token'] = (getObjectProperty(tempData, 'refresh_token'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/0d458011521fffbfebc4837faba4d39c/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    var tempData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['display_access_token'] = (getObjectProperty(___arguments.context.pageData, 'access_token'));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      ___arguments.context.pageData['display_access_token'] = '';

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/admin/components/dd899f67afe660750b5d54a7f8593602/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['display_refresh_token'] = (getObjectProperty(___arguments.context.pageData, 'refresh_token'));

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      ___arguments.context.pageData['display_refresh_token'] = '';

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/admin/components/c667fc63abd4df9b391a02ba2b3fce77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Existing Access Token Expires: ') + String(new Date((getObjectProperty(___arguments.context.pageData, 'current_access_token_expiration_date')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin/components/4f73f4357a538204c0e892f95659b83d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/48f5372f4f3a0c48fcb78a4c6448ca3e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowNewCredentialsBlock'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin/components/b468bed3e3dc7ed7f1432f68de54b92a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/9f3b380b99e3f07bc329400bcc4c7045/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://api.sosinventory.com/oauth2/authorize?response_type=code&client_id=') + String(getObjectProperty(___arguments.context.pageData, 'client_id'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/ad970eada19250126175d69b17582eac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['auth_code'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e399cae66beb4b54068191785dc19542')), 'value'));
  response = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.sosinventory.com/oauth2/token')).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded',[`Host`]: 'api.sosinventory.com' })).setEncoding('utf8').send((['grant_type=authorization_code','&client_id=',(getObjectProperty(___arguments.context.pageData, 'client_id')),'&client_secret=',(getObjectProperty(___arguments.context.pageData, 'client_secret')),'&code=',(getObjectProperty(___arguments.context.pageData, 'auth_code')),'&redirect_url',''].join(''))));
  ___arguments.context.pageData['NewAccessToken'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['access_token'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['display_access_token'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['NewRefreshToken'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['display_refresh_token'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['refresh_token'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['current_access_token_expiration_date'] = (new Date((new Date()).getTime() + (7775999 * 1000)));
  ___arguments.context.pageData['current_token_expiration_date'] = (new Date((new Date()).getTime() + (7775999 * 1000)));
  await Backendless.Data.of('SOSAuth').save( ({ [`objectId`]: '2D2F6C68-3183-4EB9-8DFB-8163CCA1660C',[`access_token`]: (getObjectProperty(response, 'access_token')),[`refresh_token`]: (getObjectProperty(response, 'refresh_token')),[`current_token_expiration_date`]: (getObjectProperty(___arguments.context.pageData, 'current_token_expiration_date')),[`current_access_token_expiration_date`]: (getObjectProperty(___arguments.context.pageData, 'current_access_token_expiration_date')) }) );
  ___arguments.context.pageData['ShowNewCredentialsBlock'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'auth_code_visible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin/components/e399cae66beb4b54068191785dc19542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['auth_code'] = ___arguments.value;
  if (getValueLength(___arguments.value) > 0) {
    ___arguments.context.pageData['auth_code_visible'] = true;
  } else {
    ___arguments.context.pageData['auth_code_visible'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/admin/components/de62fc32a8f75f07d687367daf1cb227/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.sosinventory.com/oauth2/token')).set(({ [`Content-Type`]: 'application/x-www-form-urlencoded',[`Host`]: 'api.sosinventory.com' })).setEncoding('utf8').send((['grant_type=refresh_token','&refresh_token=',(getObjectProperty(___arguments.context.pageData, 'refresh_token'))].join(''))));
  ___arguments.context.pageData['NewAccessToken'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['access_token'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['display_access_token'] = (getObjectProperty(response, 'access_token'));
  ___arguments.context.pageData['NewRefreshToken'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['display_refresh_token'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['refresh_token'] = (getObjectProperty(response, 'refresh_token'));
  ___arguments.context.pageData['current_token_expiration_minutes'] = (getObjectProperty(response, 'expires_in'));
  ___arguments.context.pageData['current_token_expiration_date'] = (new Date((new Date()).getTime() + (7775999 * 1000)));
  await Backendless.Data.of('SOSAuth').save( ({ [`objectId`]: '2D2F6C68-3183-4EB9-8DFB-8163CCA1660C',[`access_token`]: (getObjectProperty(response, 'access_token')),[`refresh_token`]: (getObjectProperty(response, 'refresh_token')),[`current_token_expiration_date`]: (getObjectProperty(___arguments.context.pageData, 'current_token_expiration_date')) }) );
  ___arguments.context.pageData['ShowNewCredentialsBlock'] = true;
  console.log(response);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/81626bbda762ba52e3a29768c7fccbbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin/components/631e625ca7b1a88cb2c7446fcbb892d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Existing Web Token Expires: ') + String(new Date((getObjectProperty(___arguments.context.pageData, 'current_token_expiration_date')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin/components/b8a8ae7191f69597fde60907dc2d471d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((new Date()) >= (getObjectProperty(___arguments.context.pageData, 'current_access_token_expiration_date'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin/components/33369546c7b6f4333b6878dd298313aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((new Date()) >= (getObjectProperty(___arguments.context.pageData, 'current_token_expiration_date'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin/components/85db1d71d0d67f3b1a866fd190138702/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('shipping_dash', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/change-password/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },
  /* handler:onEnter *//* content */
}));

define('./pages/change-password/components/58ecb77e91b7d9dd5c99075111c91c64/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['result'] = '';
  ___arguments.context.pageData['error'] = '';
  if ((getObjectProperty(___arguments.context.dataModel, 'password')) == (getObjectProperty(___arguments.context.dataModel, 'confirm_password'))) {
    try {
      ___arguments.context.pageData['result'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(Backendless.appPath),'/change_password/',(getObjectProperty(___arguments.context.pageData, 'token'))].join('')))).setEncoding('utf8').send(({ [`password`]: (getObjectProperty(___arguments.context.dataModel, 'password')) })));

    } catch (error) {
      ___arguments.context.pageData['error'] = ((typeof (getObjectProperty(error, 'message')) === 'string') ? (getObjectProperty(error, 'message')) : error);

    }
  } else {
    ___arguments.context.pageData['error'] = 'Passwords do not match';
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/change-password/components/9c0e75137e04bad6e50940e30ee54426/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/change-password/components/1e3bdf67c1f295ed344408cd7f1dba1d/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/customer-portal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser, OldestLotAndExpirationDate, results, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
  var item_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));
  for (var item_index in item_list) {
    item = item_list[item_index];
  }
}


  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72'](null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/customer-portal/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/customer-portal/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setSortBy('SafeToDelete ASC').setPageSize(25))));
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/customer-portal/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('33dd734c62b7a0a58161c28a989b779c');
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/customer-portal/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots & Expiration Dates';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['DisplayingBuildOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['DisplayingBuildOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'No Lot Required') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject, results, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, resetSearchResults, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = true;
  } else {
    decision = true;
  }


 return decision;
})
}


  results = await ClearSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, searchTerm, item;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = true;
  } else {
    decision = true;
  }


 return decision;
})
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    ___arguments.context.pageData['DBSearchResults'] = results;
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = null;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      console.log('Reset Triggered!!!');
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var list;


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var newQtyOnHand, newQtyReceived;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.QtyOnHand')) + ___arguments.value;
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.QtyReceived')) + ___arguments.value;
  ___arguments.context.pageData['newQtyOnHand'] = newQtyOnHand;
  ___arguments.context.pageData['newQtyReceived'] = newQtyReceived;
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79a9b5585668a9b88e58c9a8df180e18'))['content'] = (['Qty Received: ',newQtyReceived,' | Qty On Hand: ',newQtyOnHand].join(''));
  if (___arguments.value != 0) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, decision, newQtyOnHand, item, newQtyReceived, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      item['QtyReceived'] = newQtyReceived;
      item['QtyOnHand'] = newQtyOnHand;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
  ___arguments.context.pageData['NeedToSave'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, tempCache, QtyInAssembliesTotal, item, QtyInLotsTotal, QtyInAssembliesIterator, QtyInLotsIterator;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  QtyInLotsTotal = 0;
  QtyInLotsIterator = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
     QtyInLotsTotal = (typeof QtyInLotsTotal == 'number' ? QtyInLotsTotal : 0) + (getObjectProperty(item, 'QtyOnHand'));


   return true;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['QtyInLots'] = QtyInLotsTotal;
  QtyInLotsTotal = 0;
  QtyInAssembliesIterator = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
     QtyInLotsTotal = (typeof QtyInLotsTotal == 'number' ? QtyInLotsTotal : 0) + (getObjectProperty(item, 'QtyInAssemblies'));


   return true;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['QtyInAssemblies'] = QtyInAssembliesTotal;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/customer-portal/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'));
  } else {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/customer-portal/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['adjustmentQty'] = 0;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/customer-portal/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['DisplayingBuildOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials'))

  },
  /* handler:rowsDataLogic */
  /* content */
}))

define('./pages/customer-portal/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/customer-portal/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('33dd734c62b7a0a58161c28a989b779c');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if (true) {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, ''));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials')).concat(({ [`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1 })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials')), ({ [`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1 })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/customer-portal/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newListItems, results, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotEditMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';
  ___arguments.context.pageData['ShowDeleteButton'] = false;

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/customer-portal/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/customer-portal/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/customer-portal/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FormMode')) == 'Save') {
    await Backendless.Data.of('BILTProducts').save(___arguments.context.dataModel, true);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');
  } else if ((getObjectProperty(___arguments.context.pageData, 'FormMode')) == 'SaveAndNew') {
    await Backendless.Data.of('BILTProducts').save(___arguments.context.dataModel, true);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');
  }

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/customer-portal/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/customer-portal/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/customer-portal/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
      return (await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber ASC').setPageSize(100)))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/customer-portal/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  console.log('Getting current Build #: ');
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'))['background-color'] = '#990939';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'))['background-color'] = '#000000';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedCache, result, decision, item, stripOutSelectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.dataModel['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.dataModel;
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}


  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    stripOutSelectedItem = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedItem')) == true) {
        delete item['CurrentlySelectedItem'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
  }
  await Initialize_Item_Rows();
  ___arguments.context.pageData['ShowLots'] = false;
  ___arguments.context.pageData['SelectedRecord'] = (JSON.parse((JSON.stringify(___arguments.context.dataModel))));
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.dataModel;
  ___arguments.context.pageData['DisableEditButton'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['showDataGrid'] = false;
  if (Array.isArray((getObjectProperty(___arguments.context.dataModel, 'LotsOfLots')))) {
    console.log('Yup! We\'ve got an array!');
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    console.log('Nope! No array here!');
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	if (newHeight < 2375) {
  	  newHeight = 2375;
  	}
  	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.dataModel, 'objectId')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
       if ((getObjectProperty(item, 'CurrentlySelectedItem')) == true) {
        delete item['CurrentlySelectedItem'];
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    })));
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* content */
}))

define('./pages/customer-portal/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')),'\''].join(''))).setSortBy((String('ItemName ASC'))).setPageSize(25))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (___arguments.value.indexOf('*') + 1 > 0) {
    console.log('### We found a \'*\' in the value ###');
    changedSearchValue = ___arguments.value;
    changedSearchValue = changedSearchValue.slice(1, changedSearchValue.length);

    ;(function() {
      const callback = async () => {
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')),'\' AND (ItemName LIKE \'%',___arguments.value,'%\' OR Bin LIKE \'%',___arguments.value,'%\' OR ItemSKU LIKE \'%',___arguments.value,'%\')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    if (___arguments.value != '') {
      console.log('### We found a searchfield value ###');

      ;(function() {
        const callback = async () => {
            (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')),'\' AND (ItemName LIKE \'%',___arguments.value,'%\' OR Bin LIKE \'%',___arguments.value,'%\' OR ItemSKU LIKE \'%',___arguments.value,'%\')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else {
      console.log('### Nothing in the searchfield! ###');

      ;(function() {
        const callback = async () => {
            (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')),'\''].join(''))).setSortBy('ItemName ASC').setPageSize(25))));

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/customer-portal/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('### ITEM ITERATOR ###');
    console.log(item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('### Temp Lot Info ###');
    console.log(tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, tempStorage, item, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), -1, async (item) => {


   return 'ExpirationDate';
  }));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'QtyOnHand')) - (getObjectProperty(j, 'QtyInAssemblies')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      tempItemRowData['Lot'] = (String('Lot#: ') + String(getObjectProperty(j, 'LotNumber')));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/customer-portal/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], ''));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Value: ');
  console.log(___arguments['inputValue']);
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/customer-portal/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | BILD');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/21b85ee820acfa98b851f508f31fc5fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed4841c8b948a3d80f5a94880a48acfa'))['value'] = ((getObjectProperty(___arguments.context.pageData, 'TotalInBuild')) - ___arguments.value);

  },
  /* handler:onChange */
  /* handler:onMaxValueAssignment */
  ['onMaxValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TotalInBuild'))

  },
  /* handler:onMaxValueAssignment */
  /* content */
}))

define('./pages/customer-portal/components/ed4841c8b948a3d80f5a94880a48acfa/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxValueAssignment */
  ['onMaxValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TotalInBuild'))

  },
  /* handler:onMaxValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b85ee820acfa98b851f508f31fc5fe'))['value'] = ((getObjectProperty(___arguments.context.pageData, 'TotalInBuild')) - ___arguments.value);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/customer-portal/components/8e68a39b0f6f591838888578b5687308/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/7cfa4b68ad23914882a22a98d6e74c3c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectorLot1Data'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/customer-portal/components/58f82564dab97be53378b787fea8df78/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectorLot2Data'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/customer-portal/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/customer-portal/components/21285268c8187b38285823380a0530e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).submit() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      console.log(___arguments.context.dataModel);
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.dataModel, true);
  await Backendless.Counters.addAndGet('BuildNumberCounter', 1);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/customer-portal/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/customer-portal/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemName')),' | ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'ItemSKU'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/customer-portal/components/be324f1f24f84374c338fff851f8a6ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('BILT Solutions Client Portal: ') + String(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/customer-portal/components/13c616c812084fd8f4e8bb08ae1c532d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var firstItem, item, list, LotsData, sortedList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  LotsData = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots'));
  sortedList = (await asyncListSort(LotsData, 1, async (item) => {


   return 'ExpirationDate';
  }));
  firstItem = sortedList[0];
  console.log('### Sorted List ###');
  console.log(firstItem);

  return ([(getObjectProperty(firstItem, 'LotNumber')),' | ',((new Date((getObjectProperty(firstItem, 'ExpirationDate')))).toLocaleDateString())].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, ItemsList, rawResponse, returnedSQL, deletedItem, newList, ModifiedItem, authorizedCarts, results, currentUser, returnedBinsCount, pagingResponse, filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  authorizedCarts = await ReturnCarts();
  ___arguments.context.pageData['authorizedCarts'] = authorizedCarts;
  console.log('%c>> ' + 'pageData.authorizedCarts', 'color: #f06292', authorizedCarts);
  ___arguments.context.pageData['SelectedCartPayload'] = [];

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemInitActionResults, j, newLinkerObject, newListItems, NewLotNumber, newLotObject, result, results, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      itemInitActionResults = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(results, 'objectId')) }),[`LotAction`]: 'Item Initialized',[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`ACTIVE`]: true,[`ActionAutoNotes`]: ['Initialized Item [',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'] inside Lot [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] '].join(''),[`ActionDescription`]: '',[`LotActivityDate`]: (new Date()),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'disableBuildButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#032667';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['DisableEditButton'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['disableBuildButton'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['disableBuildButton'] = true;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, tempRepeaterList, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL VALUE CHANGED EVENT ###', 'color: #ffee58', ___arguments['dataObject']);
  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  convertedDataObject = ___arguments['dataObject'];
  if ((getObjectProperty(___arguments['dataObject'], 'LotAction')) == 'Item Initialized') {
    if ((getObjectProperty(___arguments['dataObject'], 'ACTIVE')) == false) {
      ___arguments['dataObject']['ACTIVE'] = true;
    }
  }
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU'))), null));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')), (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/6ea83c8639ba3ea8c22862485d835e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['HasProblems'] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')) == true) {
    return 'Mark item as fixed';
  } else {
    return 'Mark item as having issues!';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/cfd299883458265a92a8c231eda8a20f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ShowCart'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowCart')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/cf81ade8477916482eb81a62d2082aa7/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCart'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22d5d963acf823088e76aa73f108a308', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));
  console.log('Drawer: OnOpen Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/inventory-assemblies/components/865cc98e3e38458de22f7bf859feef01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d6889a6b5eb8318a8968dee881faf448/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'CreateNewOrderEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'_',(getObjectProperty(___arguments.context.pageData, 'NewOrderName'))].join(''),[`SelectedCustomer`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: (getObjectProperty(___arguments.context.pageData, 'NewOrderName')),[`SelectedCustomer`]: 'BILT',[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  }
  ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/69657329ebf9b9e8d8d8ba6b548836f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = true;
    ___arguments.context.pageData['NewOrderName'] = ___arguments.value;
  } else {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = false;
    ___arguments.context.pageData['NewOrderName'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/44c1a7187418c1bd73f84f08a09842e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, listConstruct, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')))) {
    return [({ [`groupLabel`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`children`]: (await Promise.all((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'CartID')),[`label`]: (getObjectProperty(item, 'CartName')) });}))) })];
  } else {
    return [];
  }

  },
  /* handler:optionsLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisableCartSelector'))

  },
  /* handler:disabledLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCartObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SelectedCart'] = ___arguments['inputValue'];
  selectedCartObject = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['CartID = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedCart')),'\''].join(''))).setPageSize(1)))[0];
  ___arguments.context.pageData['SelectedCartName'] = (getObjectProperty(selectedCartObject, 'CartName'));
  ___arguments.context.pageData['SelectedCartObjectId'] = (getObjectProperty(selectedCartObject, 'objectId'));
  ___arguments.context.pageData['SelectedCartPayload'] = (getObjectProperty(selectedCartObject, 'CartPayload'));
  console.log('%c>> ' + 'pageData.SelectedCart', 'color: null', ___arguments['inputValue']);
  console.log('%c>> ' + 'pageData.SelectedCartName', 'color: null', ___arguments['inputValue']);

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.pageData['SelectedCartName'] = '';
  ___arguments.context.pageData['SelectedCartPayload'] = [];
  ___arguments.context.pageData['SelectedCartObjectId'] = null;

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/2208db88c0c8e9a82168c0b87618241f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SelectedCartName')) === 'undefined')) {
    response = (await (async function(CartName) {
    	
    	if (confirm("Delete the selected shopping cart: " + CartName + " ?") == true) {
    	  return true;
    	} else {
    	  return false;
    	}
    })((getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))));
  }
  console.log('Response?');
  console.log(response);
  if (response) {
    await Backendless.Data.of('BILTCarts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')) );
    ___arguments.context.pageData['SelectedCartName'] = null;
    ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/9db26dc819a8d4fba84800fece188518/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, item, CustomerPortalAccess, customerCharacterLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100))), async (item) => {


     return decision;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/312b81a72a58af2348885e088ee83623/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/d928eef86158f33fda9875e8cce8fea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/5ad85908f575f5a836d84d085688f326/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'pageData.SelectedCartPayload', 'color: null', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/0bb42898042812f843dab20885e8bb78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/8058313f72dae8874168e348237810f5/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var selectedCartObject;


  console.log('Visibility Changed!!!');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/22d5d963acf823088e76aa73f108a308/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/80fe5f82c39b790b057a1dd8502494df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return (!inList)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inList, j, list, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 1 });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), tempObject);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/68381206390881c8383c9d55d7944828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return inList

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, tempObject, inList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 0 });
    ___arguments.context.pageData['SelectedCartPayload'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), async (item) => {
       if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(item, 'ItemSKU'))) {
        return false;
      } else {
        return true;
      }


     return item;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/df0bf8c87f4e57e8e007198bbf565bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')))) + 1);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/2808462816ef88a8a068d93820187e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')))) - 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) < 0) {
    ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = 0;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/c46998d93e6ae2681a4879d8bd7d1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('BILTCarts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')),[`CartPayload`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')) }), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/1688e2b8f5b8a36805dd7d085d08ab58/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies/components/a9d8589823c953a7e5bc8018160899de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), '');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')))) == 0) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/6da850a8623631f8978dbb983fc801a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = 0;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/a78898f8ca48cbe2e35be1513588f478/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('704848cd0658d077ad584ee2a318ce08');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a78898f8ca48cbe2e35be1513588f478'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a78898f8ca48cbe2e35be1513588f478'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/7896836db192e67882a8fdb89b68da95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('704848cd0658d077ad584ee2a318ce08');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/d7bf75ebc3e8dee896387ab84823b528/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var ordersData, userLookup, eachOrder, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### DEBUG ENABLED: SHOWING ALL USERS ###');
    console.log(allUsers);
  }
  ordersData = (await Backendless.Data.of('BILTOrders').find(Backendless.DataQueryBuilder.create().setSortBy('OrderNumber ASC').setPageSize(100)));
  for (var eachOrder_index in ordersData) {
    eachOrder = ordersData[eachOrder_index];
    eachOrder['OrderDate'] = ([(new Date((new Date((getObjectProperty(eachOrder, 'OrderDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachOrder, 'OrderDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachOrder, 'OrderDate'))))).getFullYear())].join(''));
    eachOrder['ShipDate'] = ([(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getFullYear())].join('') == '12/31/1969' ? '(NOT SET)' : [(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachOrder, 'ShipDate'))))).getFullYear())].join(''));
    eachOrder['TrackingNumber'] = (getObjectProperty(eachOrder, 'TrackingNumber'));
    eachOrder['_ownerId'] = (getObjectProperty(eachOrder, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachOrder, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachOrder['OrderCreatedBy'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return ordersData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedOrderInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED ORDER INFO ### (pageData.SelectedOrderInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('ab4a2d32f3383571e8e8ed584b6dc808');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/ab4a2d32f3383571e8e8ed584b6dc808/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachOrderItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (true) {
    root = [];
    addItemToList(root, ({ [`label`]: String('Order Info: (Selected Order)'),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Cart Name: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.CartName')),[`value`]: '#' }), ({ [`label`]: String('Order Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderNumber')),[`value`]: '#' }), ({ [`label`]: String('Order Status: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderStatus')),[`value`]: '#' }), ({ [`label`]: String('BILT Customer: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.BILTCustomer')),[`value`]: '#' }), ({ [`label`]: String('Order Date: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderDate')),[`value`]: '#' }), ({ [`label`]: String('Ship Date: ') + String((getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.ShipDate')) == '12/31/1969' ? '(NOT SET)' : (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.ShipDate'))),[`value`]: '#' }), ({ [`label`]: String('Tracking Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.TrackingNumber')),[`value`]: '#' }), ({ [`label`]: String('Order Address: ') + String([(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderAddress')),'\n',(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderCity')),'\n',(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderState')),'\n',(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderZip'))].join('')),[`value`]: '#' })] }));
    var eachOrderItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderPayload'));
    for (var eachOrderItem_index in eachOrderItem_list) {
      eachOrderItem = eachOrderItem_list[eachOrderItem_index];
      addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachOrderItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachOrderItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String('(Coming Soon)'),[`value`]: '#' }), ({ [`label`]: String('Qty: ') + String(getObjectProperty(eachOrderItem, 'OrderQty')),[`value`]: '#' })] }));
    }
    console.log('### LIST BUILDER ###');
    console.log(allItems);
    console.log('####### COMPLETED LIST #######');
    console.log(root);
  }

  return root

  },
  /* handler:treeItemsLogic */
  /* content */
}))

define('./pages/inventory-assemblies/components/49c803d1ec0862889e24fbdaa0c83546/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderAddress'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/4c5875ed926845255778cea87578aa0c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderCity'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/97720bd87fc80b2935b8a063c2682b4f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderState'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/9418f3f37f2f7d846472f488ff3858b8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.OrderZip'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies/components/86187378b41ae5f8c37827eb63d81ba3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo'))['OrderStatus'] = 'Cancelled!';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/4be83e784db83d7beb08031a60582a96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo'))['OrderStatus'] = 'Reserved';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/3f28bbce1e7660e8c4b364abb8db2c07/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies/components/3b78d635f8788c9d88a804cd1ecdbbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo'))['ShipDate'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.ShipDate')) == '(NOT SET)' ? null : (getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo.ShipDate')));
  await Backendless.Data.of('BILTOrders').save((getObjectProperty(___arguments.context.pageData, 'SelectedOrderInfo')), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var results, returnedSQL, deletedItem, newList, ModifiedItem, currentUser, returnedBinsCount, binsCount, item, allBinsList, listConstruct, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_9a437e8f4e58252872a56d12cf7aa26d']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  ___arguments.context.pageData['MODIFIED'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if (true) {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Assembly\',\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newListItems, newQtyReceived, newQtyOnHand, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
    console.log('### CREATE NEW INVENTORY ITEM LOT ###');
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), null, returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  console.log('Getting current Build #: ');
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, decision, item, otherUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', undefined);
  ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var changedSearchValue, results, returnedSQL, updatedValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/21b85ee820acfa98b851f508f31fc5fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed4841c8b948a3d80f5a94880a48acfa'))['value'] = ((getObjectProperty(___arguments.context.pageData, 'TotalInBuild')) - ___arguments.value);

  },
  /* handler:onChange */
  /* handler:onMaxValueAssignment */
  ['onMaxValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TotalInBuild'))

  },
  /* handler:onMaxValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ed4841c8b948a3d80f5a94880a48acfa/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxValueAssignment */
  ['onMaxValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TotalInBuild'))

  },
  /* handler:onMaxValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('21b85ee820acfa98b851f508f31fc5fe'))['value'] = ((getObjectProperty(___arguments.context.pageData, 'TotalInBuild')) - ___arguments.value);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8e68a39b0f6f591838888578b5687308/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7cfa4b68ad23914882a22a98d6e74c3c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectorLot1Data'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/58f82564dab97be53378b787fea8df78/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectorLot2Data'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/21285268c8187b38285823380a0530e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedItem, newGrandTotals, decision, lotTotalsResults, item, results, ProcessingChildItems, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newLinkerObject, CreateNewLinkerObject, tempObject, targetLotsOfLots, newLotToAdd, newLotObject, error, result, buildBOMItem, LotItem, phase1, phase2, LotsOfLotsItem, productItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [4:44:44 PM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function CallLotAdjustment() {
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ReferenceType')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, null));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  ___arguments.context.pageData['MODIFIED'] = true;
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  console.log('%c>> ' + '### TRANSACTIONS PROCESSING: EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 10) {
    phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), -1);
  } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 9 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 20) {
    phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(-1, 9);
    phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 9);
  } else {
    console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
  }
  var buildBOMItem_end = phase1.length;
  var buildBOMItem_inc = 1;
  if (1 > buildBOMItem_end) {
    buildBOMItem_inc = -buildBOMItem_inc;
  }
  for (buildBOMItem = 1; buildBOMItem_inc >= 0 ? buildBOMItem <= buildBOMItem_end : buildBOMItem >= buildBOMItem_end; buildBOMItem += buildBOMItem_inc) {
    for (var buildBOMItem_index in phase1) {
      buildBOMItem = phase1[buildBOMItem_index];
      LotItem = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    }
    ___arguments.context.pageData['Disable-Autocomplete'] = false;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index2 in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index2];
    LotItem = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItem, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    productItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(productItem, 'LotsOfLots')), async (LotsOfLotsItem) => {
       if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['ShowSpinner'] = true;
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #f06292', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #f06292', CreateNewLinkerObject);
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #26c6da', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
    console.log('### EXITING onClick EVENT ###');
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')),' | ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  await new Promise(r => setTimeout(r, 1000 || 0));
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var lotTotalsResults, item, updatedItem, newList, newGrandTotals, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
  resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var lotUpdatedResults, newGrandTotals, item, updatedItem, newList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'lotUpdatedResults', 'color: #f06292', lotUpdatedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lotsOfData, lotUpdatedResults, newGrandTotals, text, widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var result;


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://api.biltsolutions.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), null, (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_DEV_PB/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, user, userToken, password, username, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var allBinsList, binsCount, currentUser, deletedItem, i, item, listConstruct, ModifiedItem, newList, results, returnedBinsCount, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  ___arguments.context.pageData['MODIFIED'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if (true) {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Assembly\',\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newListItems, newQtyReceived, newQtyOnHand, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), null, returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, decision, item, otherUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', undefined);
  ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, updatedValue, returnedSQL, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), ___arguments.value, (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')),' | ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  await new Promise(r => setTimeout(r, 1000 || 0));
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var lotTotalsResults, item, updatedItem, newList, newGrandTotals, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, newQtyReceived, newQtyOnHand, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var lotUpdatedResults, newGrandTotals, item, updatedItem, newList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'lotUpdatedResults', 'color: #f06292', lotUpdatedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lotsOfData, lotUpdatedResults, newGrandTotals, text, widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = true;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var characterEnd, charactersStart, data, item, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var item_index in data) {
    item = data[item_index];
    item['ActivityDate'] = ([(new Date((new Date((getObjectProperty(item, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(item, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(item, 'LotActivityDate'))))).getFullYear())].join(''));
    charactersStart = (getObjectProperty(item, 'ActionAutoNotes')).indexOf('Lot: ') + 1;
    characterEnd = (getObjectProperty(item, 'ActionAutoNotes')).lastIndexOf(']') + 1;
    item['LotNumber'] = ((getObjectProperty(item, 'ActionAutoNotes')).slice(((charactersStart + 5) - 1), characterEnd));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var result;


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['MODIFIED'] = true;

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://api.biltsolutions.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var BOMResults, BOMTransactions, buildBOMItem, CreateNewLinkerObject, CreateNewLotResponse, decision, eachBuildBOMItem, error, i, item, list, LotItemReference, LotsOfLotsItem_FilterLoop, lotTotalsResults, newBILTLotActivity, newGrandTotals, newLinkerObject, newListItems, newLotActivityResponse, newLotObject, newLotToAdd, phase1, Phase1_BOM_ForEachLoop, Phase1_ListToProcess, Phase1_LotTotalsInputList, Phase1_productItemReference_List, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_Tx, Phase1_updateLotTotalsTransactions, phase2, Phase2_BOM_ForEachLoop, Phase2_productItemReference_List, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, phase3, Phase3_BOM_ForEachLoop, Phase3_productItemReference_List, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, phase4, Phase4_BOM_ForEachLoop, Phase4_productItemReference_List, Phase4_recalcTotalsResults, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, ProcessingChildItems, results, SKUObject, SKUResults, SKUTotalsResults, stamp, targetLotsOfLots, temp, tempList_Base, tempObject, tempProductItem, updatedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [7:02:06 PM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    Phase1_LotTotalsInputList = [];
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        Phase1_LotTotalsInputList = (addItemToList(Phase1_LotTotalsInputList, (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))))));
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    console.log('%c>> ' + '### VIEW Phase1_LotTotalsInputList ###', 'color: #ffee58', Phase1_LotTotalsInputList);
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #4caf50', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #4caf50', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    console.log('%c>> ' + '### Phase 1 | ENTIRE TRANSACTION LIST TO PROCESS ###', 'color: #ffee58', Phase1_ListToProcess);
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        console.log('%c>> ' + (['### Phase1_ListToProcess | LOT TOTALS RESPONSE ###','| Transaction List Index: ',i - 1].join('')), 'color: #f06292', Phase1_ListToProcess[(i - 1)]);
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'BuildBOM'))[(i - 1)]), 'Lot'))));
        SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(tempProductItem, 'ItemSKU')), null, null));
        console.log('%c>> ' + (['### pageData.BuildBOM | List Index: [',i - 1,'] ###'].join('')), 'color: #ffee58', (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'BuildBOM'))[(i - 1)]), 'Lot')));
        results = (await asyncListFilter((getObjectProperty((Phase1_ListToProcess[(i - 1)]), 'LotsOfLots')), async (item) => {
           if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'BuildBOM'))[(i - 1)]), 'Lot'))) {
            item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
            item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
            item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
            item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
            item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
            item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
            decision = true;
          } else {
            decision = true;
          }


         return decision;
        }));
        console.log('%c>> ' + (['### LotsOfLots TO SAVE | LOT DEBUG RESULTS ### Index: ',i - 1,''].join('')), 'color: #f06292', results);
        console.log('%c>> ' + (['### LotsOfLots TO SAVE | SKU DEBUG RESULTS ### Index: ',i - 1,''].join('')), 'color: #f06292', SKUTotalsResults);
        _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'BuildBOM'))[(i - 1)]), 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));
        console.log('%c>> ' + (['### recalcTotals LOT TOTALS RESPONSE ###','| Transaction List Index: ',i - 1].join('')), 'color: #f06292', lotTotalsResults);
        console.log('%c>> ' + (['### recalcTotals SKU TOTALS RESPONSE ###','| Transaction List Index: ',i - 1].join('')), 'color: #f06292', SKUTotalsResults);

      })();

    }
  }
  console.log('%c>> ' + '### UPDATE TX RESULTS ###', 'color: #ffee58', (await Phase1_Tx.execute()));
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function FreeParking() {
  newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
     if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
      LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
      LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  temp = ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) });
}


  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await Transactions_ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_06-30-26/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var allBinsList, binsCount, currentUser, deletedItem, i, item, listConstruct, ModifiedItem, newList, results, returnedBinsCount, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems, j, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if (true) {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Assembly\',\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newListItems, results, j, tempRepeaterList, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), null, returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, decision, item, otherUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', undefined);
  ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, updatedValue, returnedSQL, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), ___arguments.value, (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  await new Promise(r => setTimeout(r, 1000 || 0));
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var lotTotalsResults, item, updatedItem, newList, newGrandTotals, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, newQtyReceived, newQtyOnHand, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var lotUpdatedResults, newGrandTotals, item, updatedItem, newList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'lotUpdatedResults', 'color: #f06292', lotUpdatedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, result, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var convertedDataObject, j, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://api.biltsolutions.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemReference_List;

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemReference_List);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    console.log('%c>> ' + '### DEBUG: LotsOfLots ###', 'color: #ffee58', (getObjectProperty((BOM_productItemReference_List[0]), 'LotsOfLots')));
    results = (await asyncListFilter((getObjectProperty((BOM_productItemReference_List[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
       if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
        LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
        LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
        LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
        LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
        LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_07-01-26/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var allBinsList, binsCount, currentUser, deletedItem, i, item, listConstruct, ModifiedItem, newList, results, returnedBinsCount, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems, j, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newListItems, results, j, tempRepeaterList, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), null, returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value'))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, decision, item, otherUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, updatedValue, returnedSQL, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), ___arguments.value, (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var lotTotalsResults, item, updatedItem, newList, newGrandTotals, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, newQtyReceived, newQtyOnHand, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var lotUpdatedResults, newGrandTotals, item, updatedItem, newList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'lotUpdatedResults', 'color: #f06292', lotUpdatedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, result, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var convertedDataObject, j, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('https://api.biltsolutions.com/api/files') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL')))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var BOM_productItemList_Reference, BOMLotCalcTx, BOMLotCalcTxResults, BOMTransactions, CreateNewLinkerObject, CreateNewLotResponse, decision, eachBuildBOMItem, error, LotItemReference, LotsOfLotsItem, lotTotalsResults, newBILTLotActivity, newGrandTotals, newLinkerObject, newListItems, newLotActivityResponse, newLotObject, newLotToAdd, ProcessingChildItems, PushedBOMItem, pushedBuildBOMItem, response_CreateNewLotAction, response_CreateNewLotActionRelation, results, SKUTotalsResults, stamp, targetLotsOfLots, txResults, updatedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_LIVE_7-13-26_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var results, returnedSQL, deletedItem, newList, ModifiedItem, currentUser, returnedBinsCount, binsCount, item, allBinsList, listConstruct, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, newListItems, results, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, updatedValue, returnedSQL, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), ___arguments.value, (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, result, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var BOM_productItemList_Reference, BOMLotCalcTx, BOMLotCalcTxResults, BOMTransactions, CreateNewLinkerObject, CreateNewLotResponse, decision, eachBuildBOMItem, error, LotItemReference, LotsOfLotsItem, lotTotalsResults, newBILTLotActivity, newGrandTotals, newLinkerObject, newListItems, newLotActivityResponse, newLotObject, newLotToAdd, ProcessingChildItems, PushedBOMItem, pushedBuildBOMItem, response_CreateNewLotAction, response_CreateNewLotActionRelation, results, SKUTotalsResults, stamp, targetLotsOfLots, txResults, updatedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), true, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), false, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/31e86548f628162d612862d88051d478/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/62b833d8ed64ef7339c5841829295ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-14-26_EOD/components/63585de7c62e0228f479a5c1bab86e88/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#000000' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var results, returnedSQL, deletedItem, newList, ModifiedItem, currentUser, returnedBinsCount, binsCount, item, allBinsList, listConstruct, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

/**
 * Describe this function...
 */
async function GetLotsAndExpirationDates() {
}


  returnedBinsCount = await GetBinsCount();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), false));
  }
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter')))), null));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    console.log('### PROBLEM CODE: Set Repeater Data to: itemsRepeater ###');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, newListItems, results, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, updatedValue, returnedSQL, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  if (true) {
    if (___arguments.value.indexOf('*') + 1 == 1) {
    } else {
      changedSearchValue = ___arguments.value;
      ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
      returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

      ;(function() {
        const callback = async () => {
            if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
          results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), ___arguments.value, (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
        } else {
          results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
        }
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
        ___arguments.context.pageData['LoadedProducts'] = results;

        };

        const timerId = 'lazyTimer';
        const timerDelay = 500;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(100))));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['(ItemName LIKE \'%',changedSearchValue,'%\' OR Bin LIKE \'%',changedSearchValue,'%\' OR ItemSKU LIKE \'%',changedSearchValue,'%\' OR Customer LIKE \'%',changedSearchValue,'%\')',' AND (',returnedSQL,')'].join(''))).setSortBy('ItemName ASC').setPageSize(25))));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, result, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/6d88e0c4add83b8632d817482edb4d88/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/03037948c1b25848a1169d588ee89278/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (typeof (getObjectProperty(___arguments.context.pageData, 'exportFileName')) === 'string')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL'))));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(___arguments.context.pageData, 'PageFilterSQL')), null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['LoadedProducts'] = results;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var BOM_productItemList_Reference, BOMLotCalcTx, BOMLotCalcTxResults, BOMTransactions, CreateNewLinkerObject, CreateNewLotResponse, decision, eachBuildBOMItem, error, LotItemReference, LotsOfLotsItem, lotTotalsResults, newBILTLotActivity, newGrandTotals, newLinkerObject, newListItems, newLotActivityResponse, newLotObject, newLotToAdd, ProcessingChildItems, PushedBOMItem, pushedBuildBOMItem, response_CreateNewLotAction, response_CreateNewLotActionRelation, results, SKUTotalsResults, stamp, targetLotsOfLots, txResults, updatedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), true, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
  } else {
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), false, returnedSQL, null));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/31e86548f628162d612862d88051d478/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/62b833d8ed64ef7339c5841829295ad8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-15-26_BOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#000000' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem, currentUser, returnedBinsCount, pagingResponse, retrievedContactsRawResponse, activeProductsCount, inactiveProductsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), null));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, newListItems, results, newLotObject, error, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#75052B';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('^^^^^^^ New Code ^^^^^^^');

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, result, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  convertedDataObject = ___arguments['dataObject'];
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#680575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_07-18-26_BOD/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem, currentUser, returnedBinsCount, pagingResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemInitActionResults, j, newLinkerObject, newListItems, NewLotNumber, newLotObject, result, results, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      itemInitActionResults = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(results, 'objectId')) }),[`LotAction`]: 'Item Initialized',[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`ACTIVE`]: true,[`ActionAutoNotes`]: ['Initialized Item [',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'] inside Lot [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] '].join(''),[`ActionDescription`]: '',[`LotActivityDate`]: (new Date()),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'disableBuildButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#032667';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['DisableEditButton'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['disableBuildButton'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['disableBuildButton'] = true;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, tempRepeaterList, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL VALUE CHANGED EVENT ###', 'color: #ffee58', ___arguments['dataObject']);
  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  convertedDataObject = ___arguments['dataObject'];
  if ((getObjectProperty(___arguments['dataObject'], 'LotAction')) == 'Item Initialized') {
    if ((getObjectProperty(___arguments['dataObject'], 'ACTIVE')) == false) {
      ___arguments['dataObject']['ACTIVE'] = true;
    }
  }
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU'))), null));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')), (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_081626_BOD/components/6ea83c8639ba3ea8c22862485d835e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['HasProblems'] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')) == true) {
    return 'Mark item as fixed';
  } else {
    return 'Mark item as having issues!';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, ItemsList, rawResponse, returnedSQL, deletedItem, newList, ModifiedItem, authorizedCarts, results, currentUser, returnedBinsCount, pagingResponse, filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  authorizedCarts = await ReturnCarts();
  ___arguments.context.pageData['authorizedCarts'] = authorizedCarts;
  console.log('%c>> ' + 'pageData.authorizedCarts', 'color: #f06292', authorizedCarts);
  ___arguments.context.pageData['SelectedCartPayload'] = [];

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemInitActionResults, j, newLinkerObject, newListItems, NewLotNumber, newLotObject, result, results, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      itemInitActionResults = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(results, 'objectId')) }),[`LotAction`]: 'Item Initialized',[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`ACTIVE`]: true,[`ActionAutoNotes`]: ['Initialized Item [',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'] inside Lot [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] '].join(''),[`ActionDescription`]: '',[`LotActivityDate`]: (new Date()),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'disableBuildButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#032667';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['DisableEditButton'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['disableBuildButton'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['disableBuildButton'] = true;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, tempRepeaterList, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL VALUE CHANGED EVENT ###', 'color: #ffee58', ___arguments['dataObject']);
  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  convertedDataObject = ___arguments['dataObject'];
  if ((getObjectProperty(___arguments['dataObject'], 'LotAction')) == 'Item Initialized') {
    if ((getObjectProperty(___arguments['dataObject'], 'ACTIVE')) == false) {
      ___arguments['dataObject']['ACTIVE'] = true;
    }
  }
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU'))), null));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')), (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/6ea83c8639ba3ea8c22862485d835e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['HasProblems'] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')) == true) {
    return 'Mark item as fixed';
  } else {
    return 'Mark item as having issues!';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/cfd299883458265a92a8c231eda8a20f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ShowCart'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowCart')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/cf81ade8477916482eb81a62d2082aa7/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCart'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22d5d963acf823088e76aa73f108a308', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));
  console.log('Drawer: OnOpen Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/865cc98e3e38458de22f7bf859feef01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d6889a6b5eb8318a8968dee881faf448/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'CreateNewOrderEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'_',(getObjectProperty(___arguments.context.pageData, 'NewOrderName'))].join(''),[`SelectedCustomer`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: (getObjectProperty(___arguments.context.pageData, 'NewOrderName')),[`SelectedCustomer`]: 'BILT',[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  }
  ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/69657329ebf9b9e8d8d8ba6b548836f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = true;
    ___arguments.context.pageData['NewOrderName'] = ___arguments.value;
  } else {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = false;
    ___arguments.context.pageData['NewOrderName'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/44c1a7187418c1bd73f84f08a09842e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, listConstruct, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')))) {
    return [({ [`groupLabel`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`children`]: (await Promise.all((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'CartID')),[`label`]: (getObjectProperty(item, 'CartName')) });}))) })];
  } else {
    return [];
  }

  },
  /* handler:optionsLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisableCartSelector'))

  },
  /* handler:disabledLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCartObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SelectedCart'] = ___arguments['inputValue'];
  selectedCartObject = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['CartID = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedCart')),'\''].join(''))).setPageSize(1)))[0];
  ___arguments.context.pageData['SelectedCartName'] = (getObjectProperty(selectedCartObject, 'CartName'));
  ___arguments.context.pageData['SelectedCartObjectId'] = (getObjectProperty(selectedCartObject, 'objectId'));
  ___arguments.context.pageData['SelectedCartPayload'] = (getObjectProperty(selectedCartObject, 'CartPayload'));
  console.log('%c>> ' + 'pageData.SelectedCart', 'color: null', ___arguments['inputValue']);
  console.log('%c>> ' + 'pageData.SelectedCartName', 'color: null', ___arguments['inputValue']);

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.pageData['SelectedCartName'] = '';
  ___arguments.context.pageData['SelectedCartPayload'] = [];
  ___arguments.context.pageData['SelectedCartObjectId'] = null;

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2208db88c0c8e9a82168c0b87618241f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SelectedCartName')) === 'undefined')) {
    response = (await (async function(CartName) {
    	
    	if (confirm("Delete the selected shopping cart: " + CartName + " ?") == true) {
    	  return true;
    	} else {
    	  return false;
    	}
    })((getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))));
  }
  console.log('Response?');
  console.log(response);
  if (response) {
    await Backendless.Data.of('BILTCarts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')) );
    ___arguments.context.pageData['SelectedCartName'] = null;
    ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/9db26dc819a8d4fba84800fece188518/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, item, CustomerPortalAccess, customerCharacterLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100))), async (item) => {


     return decision;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/312b81a72a58af2348885e088ee83623/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/d928eef86158f33fda9875e8cce8fea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/5ad85908f575f5a836d84d085688f326/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'pageData.SelectedCartPayload', 'color: null', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/0bb42898042812f843dab20885e8bb78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/46a8a8a43e8841486bd84af83fe81218/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/8058313f72dae8874168e348237810f5/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var selectedCartObject;


  console.log('Visibility Changed!!!');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/22d5d963acf823088e76aa73f108a308/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/80fe5f82c39b790b057a1dd8502494df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return (!inList)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inList, j, list, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 1 });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), tempObject);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/68381206390881c8383c9d55d7944828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return inList

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, tempObject, inList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 0 });
    ___arguments.context.pageData['SelectedCartPayload'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), async (item) => {
       if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(item, 'ItemSKU'))) {
        return false;
      } else {
        return true;
      }


     return item;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/df0bf8c87f4e57e8e007198bbf565bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) + 1);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/2808462816ef88a8a068d93820187e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) - 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) < 0) {
    ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = 0;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-15-26_BOD/components/c46998d93e6ae2681a4879d8bd7d1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('BILTCarts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')),[`CartPayload`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')) }), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, ItemsList, rawResponse, returnedSQL, deletedItem, newList, ModifiedItem, authorizedCarts, results, currentUser, returnedBinsCount, pagingResponse, filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  authorizedCarts = await ReturnCarts();
  ___arguments.context.pageData['authorizedCarts'] = authorizedCarts;
  console.log('%c>> ' + 'pageData.authorizedCarts', 'color: #f06292', authorizedCarts);
  ___arguments.context.pageData['SelectedCartPayload'] = [];

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemInitActionResults, j, newLinkerObject, newListItems, NewLotNumber, newLotObject, result, results, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      itemInitActionResults = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(results, 'objectId')) }),[`LotAction`]: 'Item Initialized',[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`ACTIVE`]: true,[`ActionAutoNotes`]: ['Initialized Item [',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'] inside Lot [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] '].join(''),[`ActionDescription`]: '',[`LotActivityDate`]: (new Date()),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'disableBuildButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#032667';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['DisableEditButton'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['disableBuildButton'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['disableBuildButton'] = true;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, tempRepeaterList, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL VALUE CHANGED EVENT ###', 'color: #ffee58', ___arguments['dataObject']);
  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  convertedDataObject = ___arguments['dataObject'];
  if ((getObjectProperty(___arguments['dataObject'], 'LotAction')) == 'Item Initialized') {
    if ((getObjectProperty(___arguments['dataObject'], 'ACTIVE')) == false) {
      ___arguments['dataObject']['ACTIVE'] = true;
    }
  }
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU'))), null));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')), (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/6ea83c8639ba3ea8c22862485d835e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['HasProblems'] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')) == true) {
    return 'Mark item as fixed';
  } else {
    return 'Mark item as having issues!';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/cfd299883458265a92a8c231eda8a20f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ShowCart'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowCart')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/cf81ade8477916482eb81a62d2082aa7/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCart'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22d5d963acf823088e76aa73f108a308', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));
  console.log('Drawer: OnOpen Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/865cc98e3e38458de22f7bf859feef01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d6889a6b5eb8318a8968dee881faf448/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'CreateNewOrderEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'_',(getObjectProperty(___arguments.context.pageData, 'NewOrderName'))].join(''),[`SelectedCustomer`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: (getObjectProperty(___arguments.context.pageData, 'NewOrderName')),[`SelectedCustomer`]: 'BILT',[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  }
  ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/69657329ebf9b9e8d8d8ba6b548836f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = true;
    ___arguments.context.pageData['NewOrderName'] = ___arguments.value;
  } else {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = false;
    ___arguments.context.pageData['NewOrderName'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/44c1a7187418c1bd73f84f08a09842e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, listConstruct, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')))) {
    return [({ [`groupLabel`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`children`]: (await Promise.all((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'CartID')),[`label`]: (getObjectProperty(item, 'CartName')) });}))) })];
  } else {
    return [];
  }

  },
  /* handler:optionsLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisableCartSelector'))

  },
  /* handler:disabledLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCartObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SelectedCart'] = ___arguments['inputValue'];
  selectedCartObject = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['CartID = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedCart')),'\''].join(''))).setPageSize(1)))[0];
  ___arguments.context.pageData['SelectedCartName'] = (getObjectProperty(selectedCartObject, 'CartName'));
  ___arguments.context.pageData['SelectedCartObjectId'] = (getObjectProperty(selectedCartObject, 'objectId'));
  ___arguments.context.pageData['SelectedCartPayload'] = (getObjectProperty(selectedCartObject, 'CartPayload'));
  console.log('%c>> ' + 'pageData.SelectedCart', 'color: null', ___arguments['inputValue']);
  console.log('%c>> ' + 'pageData.SelectedCartName', 'color: null', ___arguments['inputValue']);

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.pageData['SelectedCartName'] = '';
  ___arguments.context.pageData['SelectedCartPayload'] = [];
  ___arguments.context.pageData['SelectedCartObjectId'] = null;

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2208db88c0c8e9a82168c0b87618241f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SelectedCartName')) === 'undefined')) {
    response = (await (async function(CartName) {
    	
    	if (confirm("Delete the selected shopping cart: " + CartName + " ?") == true) {
    	  return true;
    	} else {
    	  return false;
    	}
    })((getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))));
  }
  console.log('Response?');
  console.log(response);
  if (response) {
    await Backendless.Data.of('BILTCarts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')) );
    ___arguments.context.pageData['SelectedCartName'] = null;
    ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/9db26dc819a8d4fba84800fece188518/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, item, CustomerPortalAccess, customerCharacterLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100))), async (item) => {


     return decision;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/312b81a72a58af2348885e088ee83623/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/d928eef86158f33fda9875e8cce8fea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/5ad85908f575f5a836d84d085688f326/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'pageData.SelectedCartPayload', 'color: null', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/0bb42898042812f843dab20885e8bb78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/46a8a8a43e8841486bd84af83fe81218/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/8058313f72dae8874168e348237810f5/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var selectedCartObject;


  console.log('Visibility Changed!!!');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/22d5d963acf823088e76aa73f108a308/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/80fe5f82c39b790b057a1dd8502494df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return (!inList)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inList, j, list, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 1 });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), tempObject);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/68381206390881c8383c9d55d7944828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return inList

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, tempObject, inList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 0 });
    ___arguments.context.pageData['SelectedCartPayload'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), async (item) => {
       if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(item, 'ItemSKU'))) {
        return false;
      } else {
        return true;
      }


     return item;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/df0bf8c87f4e57e8e007198bbf565bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) + 1);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/2808462816ef88a8a068d93820187e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) - 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) < 0) {
    ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = 0;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_09-27-26_BOD/components/c46998d93e6ae2681a4879d8bd7d1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('BILTCarts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')),[`CartPayload`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')) }), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var binsCount, ItemsList, rawResponse, returnedSQL, deletedItem, newList, ModifiedItem, authorizedCarts, results, currentUser, returnedBinsCount, pagingResponse, filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetBinsCount() {
  binsCount = (getObjectProperty(((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setProperties('count(BinNumber) As BinCount').setPageSize(1)))[0]), 'BinCount'));
  return binsCount
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function SetupPaging() {
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  ___arguments.context.pageData['perPage'] = 50;
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  returnedBinsCount = await GetBinsCount();
  pagingResponse = await SetupPaging();
  ___arguments.context.pageData['PageFilter'] = ['\'Assembly\'', '\'Subassembly\'', '\'Inventory Item\'', '\'Non-Inventory Item\''];
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['PageFilterSQL'] = returnedSQL;
  ___arguments.context.pageData['currentBinsCount'] = returnedBinsCount;
  ___arguments.context.pageData['LotList'] = [];
  ___arguments.context.pageData['AdjustQuantityOnHand'] = '0';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  ___arguments.context.pageData['DisableEditButton'] = true;
  ___arguments.context.pageData['DisableNewButton'] = false;
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['BOMInactiveItemExists'] = false;
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(true));
  ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
  ___arguments.context.pageData['TrayMinimized'] = false;
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(___arguments.context.appData, 'currentUser.ACCESSLOCK'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ProductionMode'));
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), '', returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  authorizedCarts = await ReturnCarts();
  ___arguments.context.pageData['authorizedCarts'] = authorizedCarts;
  console.log('%c>> ' + 'pageData.authorizedCarts', 'color: #f06292', authorizedCarts);
  ___arguments.context.pageData['SelectedCartPayload'] = [];

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, result, modifiedObject, decision, item, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  result = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.QtyOnHand'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(result)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = 0;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, modifiedObject, startingQtyOnHand, startingQtyAvailable, tempChanges, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log('### BTN_UpdateRecord.Click ###');
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 3600);
  startingQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'));
  startingQtyAvailable = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['QtyOnHand_Stored'] = ((Number(startingQtyOnHand)) + (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')))));
  tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
      item['Changes'] = true;
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', tempChanges);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  console.log('^^^ BTN_UpdateRecord.Click ^^^');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
      return false;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var storedCache, storedCacheObjectID, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    delete storedCache['LotsOfLots'];
    await Backendless.Data.of('BILTProducts').save(storedCache, true);
    console.log(tempObject);
    await Backendless.Cache.remove(storedCacheObjectID);
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['SelectedRecord'] = storedCache;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2778f45ae9330b28dd431a1809ee34f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1788cbc89d1b912e091dc4d2dad624f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/bd7c9758047faee5a1583a1e3d880b97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f46b1fe8d178e17876784f0ce6feb0c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/71957c45b508c1687df8634a99124be8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyAvailable'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/01387018735aca683a4801f8c8313ce8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var newValue;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  newValue = (Number((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))));

  return ((Number((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'QtyAvailable')))) + newValue)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d4988bfa34539ecf9af81eb87718d688/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var numberToSet, modifiedObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  numberToSet = (Number(___arguments.value));
  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
  modifiedObject['ExistingQuantityOnHand'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['ValueChange'] = numberToSet;
  modifiedObject['QtyOnHand_Stored'] = ((getObjectProperty(modifiedObject, 'ExistingQuantityOnHand')) + (getObjectProperty(modifiedObject, 'ValueChange')));
  console.log('### ExistingQtyOnHand ###');
  console.log(getObjectProperty(modifiedObject, 'ExistingQuantityOnHand'));
  console.log('### Value Change +/- ###');
  console.log(___arguments.value);
  if (typeof numberToSet === 'number' && !isNaN(numberToSet)) {
    ___arguments.context.pageData['AdjustQuantityOnHand'] = numberToSet;
    if (((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')) === 'object')) && (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) != 0 && (typeof (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))))) {
      ___arguments.context.pageData['UpdateEnabled'] = true;
      ___arguments.context.pageData['NeedToSave'] = true;
    } else {
      ___arguments.context.pageData['UpdateEnabled'] = false;
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 109) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4988bfa34539ecf9af81eb87718d688'))['value'] = '';
  }

  },
  /* handler:onKeyDown */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/af02c91934d8a038ea7e65fe536e2b98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AdjustQuantityOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayMinimized')) != true) {
    return ['easeInAndOut', 'tray__normal'];
  } else {
    return ['easeInAndOut', 'tray__minimized'];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'HideBottomActions')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f3496a667ba81ca8d9b81af15dcb4408/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d6ded208e1ee87dadad87e58d9c86c51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    return 'Inventory';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    return 'Lots | Builds | Activity';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    return 'Assemblies - Bill Of Materials';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3e3880f59f0fdb681f88d41bd6df05c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Lots';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#4B11A3';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3e3880f59f0fdb681f88d41bd6df05c8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b11485383f2833c342a87bf16f48b818/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'Home';
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Free_Parking() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
      return true;
    } else {
    }
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b11485383f2833c342a87bf16f48b818'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8a449e887b2603780176f4d88be85968/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b75630b74608b31e09120758209800c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject;


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/29a499f8bd789e7a340d74181dfed12b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, result, results, returnedSQL, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'Lot Required';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#B1B3B2';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#8C093A';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/6988de984d1ccf395aaf87ade2085eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var resetSearchResults, results, decision, searchTerm, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ClearSearch() {
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')) == searchTerm) {
    decision = false;
  } else {
    decision = false;
  }


 return [];
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  resetSearchResults = await ResetSearch();
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', resetSearchResults);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1580518cfa163c6e3480ed8cdb82528'))['value'] = '';
  ___arguments.context.pageData['DBSearchTerm'] = null;
  ___arguments.context.pageData['DBSearchResults'] = resetSearchResults;
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Resetting the length of LotsRepeater to: ') + String(resetSearchResults.length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(resetSearchResults.length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e1580518cfa163c6e3480ed8cdb82528/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results, DBSearchTerm, decision, item, searchTerm;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function SearchLots(searchTerm) {
  DBSearchTerm = searchTerm.toLowerCase();
  return await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), async (item) => {
   if ((getObjectProperty(item, 'LotNumber')).toLowerCase().indexOf(DBSearchTerm) + 1 > 0) {
    decision = true;
  } else {
    decision = false;
  }


 return decision;
})
}

/**
 * Describe this function...
 */
async function ResetSearch() {
  return getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')
}


  stopSetTimeout('lazySearch');

  ;(function() {
    const callback = async () => {
        console.log('Doing onChange Search...');
    DBSearchTerm = ___arguments.value;
    ___arguments.context.pageData['DBSearchTerm'] = DBSearchTerm;
    results = await SearchLots(DBSearchTerm);
    ___arguments.context.pageData['DBSearchResults'] = results;
    console.log('##### DBSearchResults ###');
    console.log(results);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
    if (getValueLength(___arguments.value) == 0) {
      results = await ResetSearch();
      ___arguments.context.pageData['DBSearchTerm'] = null;
      ___arguments.context.pageData['DBSearchResults'] = results;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', results);
      console.log(String('Length = 0 | Resetting the length of LotsRepeater to: ') + String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length));
    }

    };

    const timerId = 'lazySearch';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d582e7e44598070135588b6a9252a398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) + 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3bd866dbd2b859b8618c4bd856e88af8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) > 1) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1);
    }
  } else {
    console.log('NOT A NUMBER ERROR IN CLICK + EVENT');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ad294be4b9b84fb423f83bb82ab8fbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.dataModel, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log(results);
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ShowLots')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Inventory Item') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      return true;
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      return true;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/db44e518fe5729943d3322df7bee25e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    return ((new Date((sortedListTimestamps[((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) - 1)]))).toLocaleDateString());
  } else {
    console.log('ERROR: We have a non-numeric value for the View identifier. Correcting...');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678'))['View'] = 1;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/4498feb8cf6e0da8a6585aa372489e38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### eachLotItem ###');
  console.log(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'));
  console.log('### Old Lot Data: SelectedRecord_Drawer.LotsOfLots ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots'));
  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4498feb8cf6e0da8a6585aa372489e38'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/6ef13c780ff80f284778b3480ca809d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ExpirationDate')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ac2595896e9d71c59de65ff877d7a018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReceived'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ec685062186151f386e6411f992815e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8a95da3864a80bb1c6caf088eae2b2ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')) === 'number' && !isNaN((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))) {
    return ([' (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'ReceivedDates')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/bf788dd89adb8e8d669e0058e35bc268/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4b8687364a894cd0cf83e588c420678')), 'View')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/4838d098a4c41c18579e86d84ec83f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['SYSTEM_LOT_BYPASS'] = false;
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/dbd8147eba98d98e352610125cc8a706/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/61e10371e4786aa2435c6ea85058c5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var modifiedObject, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  modifiedObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  modifiedObject['Type'] = 'No Lot Required';
  modifiedObject['QtyOnHand_Backup'] = (getObjectProperty(modifiedObject, 'QtyOnHand'));
  modifiedObject['QtyOnHand'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b75630b74608b31e09120758209800c3'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('29a499f8bd789e7a340d74181dfed12b'))['background-color'] = '#B1B3B2';
  await Backendless.Data.of('BILTProducts').save(modifiedObject, true);
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  ___arguments.context.pageData['SelectedRecord'] = modifiedObject;
  await (async function(objectId) {
  	const rows = document.querySelectorAll('.MuiTableRow-root')
  	
  	for (const row of rows) {
  	  const cells = row.querySelectorAll('td')
  	  
  	  for (const cell of cells) {
  	    if (cell.textContent.trim() === objectId) {
  	      row.classList.add('Mui-selected')
  	      
  	      break
  	    }
  	  }
  	}
  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7b68a1f85b18115a69029a399e2b1138');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/25175b685ae84da8950ff2b8fb082258/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff;


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  ___arguments.context.pageData['TargetedDataModel'] = ___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8');
  ___arguments.context.pageData['SelectedFetchedDataBlock'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['DisabledLotActionButton'] = true;
  ___arguments.context.pageData['DebugData'] = ({  });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/fee85abb2dd80805f3b880183bcca838/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b6a88d7167768ad7dbc8e1d84168d438/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, newQtyOnHand, newQtyReceived, stamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  stamp = (new Date());
  ___arguments.context.pageData['adjustmentQty'] = ___arguments.value;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')) === 'string') {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
    autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b']((getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  } else {
    ___arguments.context.pageData['newQtyOnHand'] = 0;
    ___arguments.context.pageData['newQtyReceived'] = 0;
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/763828589718ac486e387bb81364aa68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, tempRepeaterList, results, result, decision, item, newQtyReceived, newQtyOnHand, newListItems;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Legacy_Code() {
  newQtyOnHand = (getObjectProperty(___arguments.context.pageData, 'newQtyOnHand'));
  newQtyReceived = (getObjectProperty(___arguments.context.pageData, 'newQtyReceived'));
  ___arguments.context.pageData['NeedToSave'] = true;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Working_on_other_screen() {
  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0 })));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  }
}


  await Legacy_Code();
  console.log('### BTN_UpdateLotQty: Function Send Object ###');
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), true, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('%c>> ' + '### LOT ADJUSTMENT RETURN RESULTS ###', 'color: #f06292', results);
  result = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')) }),[`LotAction`]: (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyShipped`]: (getObjectProperty(results, 'QtyShipped')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`ACTIVE`]: true,[`ActionAutoNotes`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477')), 'value')),[`ActionDescription`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2688288d6f19aca8cff8453c8db661a8')), 'value')),[`LotActivityDate`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ff21e1187c4993e82528320827e992a8')), 'value')),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
  console.log('### Deep Save Result ###');
  console.log(result);
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  console.log('### TargetedDataModel ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'TargetedDataModel'));
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisabledLotActionButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a1585bf117e7747badfedd18b07847e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c40d146238e58e38dba81d2828ff45ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.LotAdjustmentData');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/969714588fa8bcf89d98c0d722e123d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var selectedItem, results, savedRecord, tempCache, lotCalc;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

/**
 * Describe this function...
 */
async function CalculateNewLotTotals() {
  console.log('### NewLotCalc Data ###');
  console.log(lotCalc);
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length == 0) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = null;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = null;
  }
  savedRecord = (await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true));
  console.log('%c>> ' + 'Saved Record: ', 'color: #f06292', savedRecord);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  await ResetLock();
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d8a8ada8c7041d65bfad3fc831f85828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLots'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var orderListByLotExpirationDates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'DBSearchTerm')) == null) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    orderListByLotExpirationDates = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), 1, async (item) => {


     return (getObjectProperty(item, 'ExpirationDate'));
    }));
    return orderListByLotExpirationDates;
  } else {
    console.log('Repeater Logic: We have a DBSearchTerm so search...');
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String((getObjectProperty(___arguments.context.pageData, 'DBSearchResults')).length) + String(' Lots'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
    return (getObjectProperty(___arguments.context.pageData, 'DBSearchResults'));
  }
  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')))) {
    console.log(String('Repeater Logic: Resetting the length of LotsRepeater to: ') + String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('22f8b86367f8d5416c75c76bedfe6382'))['content'] = (String('...'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/dbdff4384808aa0cc3080bc8e7f88a12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e31c22d87688da48c46e21d514f8af68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord.NeedToSaveCache');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/277c26d93ad8464708a81cec47f8b4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInAssemblies'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1be85957c45bccebcf88f138433600a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyAvailable'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7348fe6aa0c6baa80fe33908494993f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a4a652a59f18ee18d6cf2d0883b22488/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var results, newTotals;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['adjustmentQty'] = 0;
  console.log('### AdjustQuantitiesModal: onClose Event ###');
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_objectId = \'',(getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.Lot_objectId')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(results);
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, (getObjectProperty(results, 'Lot_objectId'))));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### SAVING newTotals to NewLotDataModel ###');
  console.log(newTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', results);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/47f8d348e1787188dcc84c6e238a2f38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7f1f325ebbc8264cce02fd06156a37b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
    ___arguments.context.pageData['DisplayingBuildOptions'] = false;
    ___arguments.context.pageData['HideBottomActions'] = false;
    ___arguments.context.pageData['TrayView'] = 'BOM';
    ___arguments.context.pageData['DisplayingOptions'] = true;
    ___arguments.context.pageData['BOMEnabled'] = true;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#054575';
      return false;
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f1f325ebbc8264cce02fd06156a37b8'))['background-color'] = '#B1B3B2';
      return true;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/130122efa87ae7685e780018e61839d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8'));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onCellValueChanged */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var tempBOM, newBOMList, InactiveItemsPresent, eachBOMItem, itemLookup, ENABLE_ACTIVE_CHECKER;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ENABLE_ACTIVE_CHECKER = true;
  InactiveItemsPresent = 0;
  if ((getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) == true) {
    console.log('%c>> ' + '############## BOMEnabled = TRUE ##############', 'color: #f06292', true);
    tempBOM = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
    newBOMList = [];
    if (ENABLE_ACTIVE_CHECKER) {
      for (var eachBOMItem_index in tempBOM) {
        eachBOMItem = tempBOM[eachBOMItem_index];
        itemLookup = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(eachBOMItem, 'Item')), ));
        console.log('%c>> ' + '############## itemLookup (From DB) ##############', 'color: #ffee58', itemLookup);
        if ((getObjectProperty(itemLookup, 'Status')) == 'Inactive') {
          eachBOMItem['Status'] = 'Inactive';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO INACTIVE ###', 'color: #f06292', eachBOMItem);
          InactiveItemsPresent = InactiveItemsPresent + 1;
        } else if ((getObjectProperty(itemLookup, 'Status')) == 'Active') {
          eachBOMItem['Status'] = 'Active';
          console.log('%c>> ' + '### UPDATED BOM ITEM TO ACTIVE ###', 'color: #f06292', eachBOMItem);
        }
        addItemToList(newBOMList, eachBOMItem);
      }
      if (InactiveItemsPresent > 0) {
        ___arguments.context.pageData['BOMInactiveItemExists'] = true;
      } else {
        ___arguments.context.pageData['BOMInactiveItemExists'] = false;
      }
      console.log('%c>> ' + '####### ENTIRE UPDATED BOM LIST #######', 'color: #f06292', newBOMList);
      return newBOMList;
    } else {
      return tempBOM;
    }
  } else {
    return tempBOM;
  }

  },
  /* handler:rowsDataLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a11a72988ad8b468c7e816988a368e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d2287f682d986f23e8cbbb855618d54f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempCache, selectedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}


  ___arguments.context.pageData['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  await ResetLock();
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache')) === 'object')) {
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSave'] = false;
    tempCache = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.NeedToSaveCache'))['NeedToSaveCache'] = null;
    console.log((await Backendless.Data.of('BILTProducts').save(tempCache, true)));
  } else {
    console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), true)));
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['disabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#027142';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d2287f682d986f23e8cbbb855618d54f'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e9a8ffd4759d79dba72a019896daa645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('pageData.SelectedRecord_Drawer');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9c38192218b7b5381f6c62ab80b23918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: false }), true)));
  ___arguments.context.pageData['SelectedRecord_Drawer.NeedToSave'] = false;
  ___arguments.context.pageData['NeedToSave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/73db233398b868ba75781198a2149ece/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8c18465866643f8c603766d89c38bd44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3f18fc7865cfce68e068f8f8bee8b038/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'DisplayingOptions')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Subassembly\',\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d'](___arguments.context.pageData, null, 'ItemType IN (\'Inventory Item\',\'Non-Inventory Item\')', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))));
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var checkIfItemExists, item, itemDeets;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('AddItemToBOM: ');
  console.log(___arguments['inputValue']);
  itemDeets = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)));
  ___arguments.context.pageData['AddItemToBOM'] = (itemDeets[0]);
  console.log('BOM Deets:');
  console.log(getObjectProperty(___arguments.context.pageData, 'AddItemToBOM'));
  console.log('Item Deets:');
  console.log(itemDeets);
  checkIfItemExists = (await asyncListFind((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('130122efa87ae7685e780018e61839d8')), async (item) => {
     if ((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM.objectId')) == (getObjectProperty(item, 'Item'))) {
      return true;
    } else {
      return false;
    }


   return ;
  }));
  if (!checkIfItemExists) {
    if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')))) {
      console.log('We HAVE an array!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')).concat(({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    } else {
      console.log('We do NOT have an array! So create an empty list first...');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = [];
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), ({ [`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Type')),[`ItemName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'ItemName')),[`Item`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'objectId')),[`Desc`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Description')),[`Qty`]: 1,[`Status`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'AddItemToBOM')), 'Status')) })));
    }
    ___arguments.context.pageData['itemExists'] = false;
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`NeedToSave`]: true }), true);
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['showDataGrid'] = true;
    ___arguments.context.pageData['NeedToSave'] = true;
  } else {
    ___arguments.context.pageData['itemExists'] = true;
  }

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'BOMEnabled')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Subassembly') {
      if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ae08fabe4888f248dded2b487558bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var step2, decision, step1, item, listItemToRemove;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  listItemToRemove = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('130122efa87ae7685e780018e61839d8'));
  step1 = listItemToRemove[0];
  console.log('step1: ');
  console.log(step1);
  step2 = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials')), async (item) => {
     if ((getObjectProperty(item, 'Item')) == (getObjectProperty(step1, 'Item'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('step2: ');
  console.log(step2);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['BillOfMaterials'] = step2;
  console.log('From pageData: ');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BillOfMaterials'));
  ___arguments.context.pageData['showDataGrid'] = false;
  ___arguments.context.pageData['showDataGrid'] = true;
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/57788328f2dd04ae93defa582fd4e6c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['NewLotNumber'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3398694dfca219f10d1828a9006845c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var sortedListTimestamps;


  return ((new Date(___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858'))).toLocaleDateString());

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9628c538e6186d388df85f6c791849c1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/82d7a5880d011b787ce84c0c1f18fcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var trimmedList, decision, item, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  trimmedList = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), async (item) => {
     if (item == ___arguments.context.getComponentDataStoreByUid('189a1d18b855893c3018715dbe986858')) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = trimmedList;
  sortedListTimestamps = trimmedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/588946c8a6a8b349af48310803e8b579/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var modifiedList, sortedListTimestamps;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')))) {
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = modifiedList;
    }
  } else {
    (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = [];
    if (((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')).valueOf()).includes((___arguments.value.valueOf()))) {
      ___arguments.context.pageData['duplicateReceivedDate'] = true;
    } else {
      ___arguments.context.pageData['duplicateReceivedDate'] = false;
      modifiedList = (addItemToList((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ReceivedDates')), ___arguments.value));
      sortedListTimestamps = modifiedList.slice().sort(listsGetSortCompare("NUMERIC", -1));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('14aa63e8d8e394e54c98bd38fc38a228', sortedListTimestamps);
      (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ReceivedDates'] = sortedListTimestamps;
    }
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0e22ad287ec82b074ea88e0c77e8b4be/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, itemInitActionResults, j, newLinkerObject, newListItems, NewLotNumber, newLotObject, result, results, tempRepeaterList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_Lot(NewLotNumber) {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }) ));

  } catch (error) {
    ___arguments.context.pageData['duplicateReceivedDate'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['ERROR: Lot: [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] already exists! Unable to create the new lot!'].join(''));
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    ___arguments.context.pageData['SelectedRecord.NeedToSave'] = true;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
    console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
    for (var j_index in tempRepeaterList) {
      j = tempRepeaterList[j_index];
      if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        j['MODIFIED'] = true;
      }
    }
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    if (!(Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots'))))) {
      console.log('SelectedRecord.LotsOfLots is NOT an array!!!');
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = [];
    }
    results = await Create_New_Lot((getObjectProperty(___arguments.context.pageData, 'NewLotNumber')));
    console.log('### Attempt Results ###');
    console.log(results);
    if ((getObjectProperty(results, 'error')) == '') {
      (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
      newListItems = (addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),[`ExpirationDate`]: ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed470c241ed803126488ed67e2586e08')), 'value')).valueOf()),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(results, 'objectId')) })));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', newListItems);
      console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
      itemInitActionResults = (await Backendless.Data.of('BILTLotActivity').deepSave( ({ [`_Lot`]: ({ [`objectId`]: (getObjectProperty(results, 'objectId')) }),[`LotAction`]: 'Item Initialized',[`QtyReceived`]: 0,[`QtyOnHand`]: 0,[`QtyInLots`]: 0,[`QtyInAssemblies`]: 0,[`QtyReserved`]: 0,[`QtyShipped`]: 0,[`QtyAvailable`]: 0,[`ACTIVE`]: true,[`ActionAutoNotes`]: ['Initialized Item [',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'] inside Lot [',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),'] '].join(''),[`ActionDescription`]: '',[`LotActivityDate`]: (new Date()),[`AssemblyName`]: (getObjectProperty(results, 'AssemblyName')) }) ));
      tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
      console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
      for (var j_index2 in tempRepeaterList) {
        j = tempRepeaterList[j_index2];
        if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
          j['MODIFIED'] = true;
        }
      }
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('a4a652a59f18ee18d6cf2d0883b22488');
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34681ba78dcf1e4c00c4088847eebbe8'))['content'] = (['The Lot: ',(getObjectProperty(___arguments.context.pageData, 'NewLotNumber')),' already exists!'].join(''));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7ae3e9897f78e2e88be80318cfa840df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedRecord, selectedRecordData, results, decision, item, confirmation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this lot?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    results = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')), async (item) => {
       if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
        decision = false;
      } else {
        decision = true;
      }


     return decision;
    }));
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
    (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['NeedToSave'] = true;
    selectedRecordData = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    updatedRecord = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(selectedRecordData, 'objectId')),[`NeedToSave`]: false,[`LotsOfLots`]: (getObjectProperty(selectedRecordData, 'LotsOfLots')) }), true));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(updatedRecord, 'LotsOfLots')));
    ___arguments.context.pageData['NeedToSave'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('9f183413142794ef09a88b28ec224018');
  } else {
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT_BYPASS')) == true) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/512816a82ea8ff5884addf022ef88aad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('Repeater Data:');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/356888b8e438918fb2487c8846fde92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['TrayView'] = 'Lots';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3918a108e3b2f3fcf1889d8ba4086aa4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/34681ba78dcf1e4c00c4088847eebbe8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'duplicateReceivedDate'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3ea8a55eeba80888a76f5c38e663680f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == false) {
    ___arguments.context.pageData['LotAdjustmentData'] = ({  });
    ___arguments.context.pageData['LotEditMode'] = 'New';
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('9f183413142794ef09a88b28ec224018');
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/dc56bf8ba6382698463aae12d5f8c6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return 'Lot Management - Edit Lot: ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return 'Lot Management - New Lot';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ed470c241ed803126488ed67e2586e08/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (typeof (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate')))) {
    return (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.ExpirationDate'));
  }

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData'))['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/22f8b86367f8d5416c75c76bedfe6382/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828')).length) + String(' Lots'))

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type')) == 'Lot Required') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/daa8d15ea2c87b988f651e63452acbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/18c885db48a8113804185c1b162846f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/58884957df288a18e2d184f875a8e911/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'New';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'DisableNewButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('58884957df288a18e2d184f875a8e911'))['background-color'] = '#054575';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f238c4885e6ec67844ab659f8d08ddf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['ExpirationDate'] = (___arguments.value.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c568c354dc180a689b77d27bad48aa88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, newAddedItemObject, selectedItem, newLotObject, error, newListItems, newLinkerObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ResetLock() {
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newAddedItemObject['LotsOfLots'] = ({  });
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`QtyShipped`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    ___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8')['LotsOfLots'] = [];
  }
  console.log('### BUTTON SAVE ACTION ###');
  ___arguments.context.pageData['FormMode'] = 'Save';
  ___arguments.context.pageData['DisableEditButton'] = true;
  console.log('### BUTTON SAVE: Upsert Object ###');
  newAddedItemObject = (await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true));
  console.log('### NEWLY ADDED BASE RECORD ###');
  console.log(newAddedItemObject);
  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'Type')) == 'No Lot Required') {
      console.log('### CREATE NEW INVENTORY ITEM LOT ###');
      results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')), newAddedItemObject);
    }
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, true));
  console.log('%c>> ' + '### Function: LoadItemsIntoRepeater ###', 'color: #f06292', results);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  await ResetLock();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8a85a858c05819c85f28175d50a8f6d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['FormMode'] = 'SaveAndNew';
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), true);
  results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f6611588021817235f47ddf82fb12cd8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/14621a84d96d09683a8841a91668e2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var confirmation, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  confirmation = (await (async function() {
  	var userPreference;
  	
  	if (confirm("Are you sure that you want to delete this inventory item?") == true) {
  	    userPreference = "Confirmed!";
  	} else {
  	    userPreference = "Cancelled!";
  	}
  	
  	return userPreference;
  })());
  if (confirmation == 'Confirmed!') {
    await Backendless.Data.of('BILTProducts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')) );
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, returnedSQL, null));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
    ___arguments.context.pageData['DeleteBypass'] = true;
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8067dd1bfba366c84268b1a83c1c74d9', undefined);
  } else {
    ___arguments.context.pageData['ShowDeleteButton'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowDeleteButton')));
  }

  },
  /* handler:onClick */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#D5EAFB';

  },
  /* handler:onMouseOut */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('14621a84d96d09683a8841a91668e2cc'))['color'] = '#E56852';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a0e808febc68bb6e5e0d3fd196680058/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'Edit') {
    return true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'LotEditMode')) == 'New') {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/de98a1fedf3861b897485948101830a6/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/59f8bbf8ae482f587c48a9e8476841f8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Home') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'visible';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'Lots') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'hidden';
  } else if ((getObjectProperty(___arguments.context.pageData, 'TrayView')) == 'BOM') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['visibility'] = 'hidden';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f3496a667ba81ca8d9b81af15dcb4408'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('de98a1fedf3861b897485948101830a6'))['height'] = '1px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['height'] = '400px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59f8bbf8ae482f587c48a9e8476841f8'))['overflow'] = 'visible';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    
  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f6611588021817235f47ddf82fb12cd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      console.log('### FORM SUBMIT ACTION: DISABLED!!! ###');

  },
  /* handler:onSubmit */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    ___arguments.context.dataModel['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId'));
    ___arguments.context.dataModel['ItemName'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemName'));
    ___arguments.context.dataModel['ItemSKU'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemSKU'));
    ___arguments.context.dataModel['Status'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Status'));
    ___arguments.context.dataModel['Bin'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Bin'));
    ___arguments.context.dataModel['ItemType'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType'));
    ___arguments.context.dataModel['Type'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Type'));
    ___arguments.context.dataModel['SelectedCustomer'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SelectedCustomer'));
    ___arguments.context.dataModel['CustomerItemID'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.CustomerItemID'));
    ___arguments.context.dataModel['Description'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Description'));
    ___arguments.context.dataModel['Lot'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Lot'));
    ___arguments.context.dataModel['Cost'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Cost'));
    ___arguments.context.dataModel['ExpirationDate'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ExpirationDate'));
    ___arguments.context.dataModel['Notes'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord.Notes'));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/50f9d9c917d70e58ec78732d2d681fc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['InventoryMode'] = 'Edit';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) === 'object')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'DisableEditButton')) == true) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#B1B3B2';
        return true;
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('50f9d9c917d70e58ec78732d2d681fc4'))['background-color'] = '#054575';
        return false;
      }
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/757bf08780c8e6b838b7b5feb106a1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'New') {
    return 'New Inventory Item';
  } else if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return 'Edit Inventory Item';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'type'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1f38a4d8b908d23283369ec8d19e6298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SKUError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/39fbfc782a6bffacfcfaa7e8c96a7e48/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var allBinsList, binsCount, i, item, listConstruct, returnedBinsCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  allBinsList = [];
  binsCount = (getObjectProperty(___arguments.context.pageData, 'currentBinsCount'));
  var i_inc = 100;
  if (0 > binsCount) {
    i_inc = -i_inc;
  }
  for (i = 0; i_inc >= 0 ? i <= binsCount : i >= binsCount; i += i_inc) {
    allBinsList = (allBinsList.concat((await Backendless.Data.of('BILTBins').find(Backendless.DataQueryBuilder.create().setSortBy('BinNumber').setPageSize(100).setOffset(i)))));
  }

  return allBinsList

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/53faf2f6415848021498dc887c4ddb68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisplayingBuildOptions'] = true;
  ___arguments.context.pageData['BuildNumberCounterCurrentValue'] = (await Backendless.Counters.get('BuildNumberCounter'));
  ___arguments.context.pageData['ShowCancelButton'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'disableBuildButton')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#B1B3B2';
      return true;
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('53faf2f6415848021498dc887c4ddb68'))['background-color'] = '#032667';
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/009f71a9507120a8dc88aabd87886407/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.pageData, 'TotalItemCount')) + String(' Items'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/fdd82658c5310d459d38358ef5984068/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Force setting the LotsRepeater contents...');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8a8ada8c7041d65bfad3fc831f85828', (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c278b80f8cf8c21819683ad899585c88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Home';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d2089154cfd34b228418e5a495b87218/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'Lots';
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['BOMEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/337804b89cc8e9a4549858578ec95de1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['HideBottomActions'] = false;
  ___arguments.context.pageData['TrayView'] = 'BOM';
  ___arguments.context.pageData['BOMEnabled'] = true;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('337804b89cc8e9a4549858578ec95de1'))['background-color'] = '#054575';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/621f81b8ed8ca50c4f6b35869e9e13e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onBeforeMount */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var tempList, currentRecordSelections, otherUser, decision, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Original_Code() {
  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Get_CurrentRecordSelections() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = [];
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  return currentRecordSelections
}

/**
 * Describe this function...
 */
async function Code_Causing_ENDLESS_Loops() {
  console.log('####### Func Get-CurrentRecordSelections #######');
  currentRecordSelections = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (Array.isArray(currentRecordSelections)) {
    if (currentRecordSelections.indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
}


  tempList = (getObjectProperty(___arguments.context.dataModel, 'SelectedByUsersList'));
  if (Array.isArray(tempList)) {
    if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
      return ({ [`background-color`]: '#990939' });
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'CurrentlySelectedItem')) == true) {
    return ({ [`background-color`]: '#990939' });
  } else {
    if (typeof (getObjectProperty(___arguments.context.dataModel, 'Status')) === 'string') {
      if ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Inactive') {
        return ({ [`background-color`]: '#777777' });
      } else {
        return ({ [`background-color`]: '#000000' });
      }
    }
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[(getObjectProperty(___arguments.context.dataModel, 'objectId'))] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8067dd1bfba366c84268b1a83c1c74d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var otherUser, decision, item, selectedItem, otherUsers, currentCount, listCount, tempChanges, result, temp, newUsersList, tempList, Mode, newTotals, results;

/**
 * Describe this function...
 */
async function ResetSearch() {
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reference__Check_For_Other_User() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

/**
 * Describe this function...
 */
async function ResetLock_SaveRecord(Mode) {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  if (Mode == 'Save') {
    if (otherUsers.length == 0) {
      temp = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));
      console.log('### newUsersList ###');
      console.log(newUsersList);
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['Lot_objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Lot_objectId'));
      temp['NeedToSave'] = false;
      ___arguments.context.pageData['NeedToSave'] = false;
      delete temp['ExistingQuantityOnHand'];
      delete temp['ValueChange'];
      delete temp['CurrentlySelectedItem'];
      console.log('### DEEP SAVE: Drawer Close Event ###');
      await Backendless.Data.of('BILTProducts').deepSave( temp );
    } else {
    }
  } else {
    if (otherUsers.length == 0) {
      console.log('### WE\'RE THE ONLY ONES EDITING THIS RECORD ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['is_SafeToEdit'] = true;
      temp['LastLockBy'] = '';
      temp['SelectedByUsersList'] = [];
      temp['Changes'] = false;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    } else {
      console.log('### ANOTHER USER EDITING: REMOVE SELECTEDBYUSERS ENTRY ###');
      temp = ({  });
      tempList = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.SelectedByUsersList'));
      if (Array.isArray(tempList)) {
        if (tempList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 > 0) {
          newUsersList = (await asyncListFilter(tempList, async (item) => {
             if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
              decision = false;
            } else {
              decision = true;
            }


           return decision;
          }));
        }
      }
      temp['objectId'] = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'));
      temp['SelectedByUsersList'] = newUsersList;
      await Backendless.Data.of('BILTProducts').save(temp, true);
    }
  }
}

/**
 * Describe this function...
 */
async function Local_RecalculateTotals() {
  results = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(results, 'ItemSKU')), null, null));
  if (newTotals == ({  })) {
  } else {
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand`]: (getObjectProperty(newTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newTotals, 'TotalQtyAvailable')) }), true);
  }
  console.log('### CALCULATED TOTALS ###');
  console.log(newTotals);
}


  ___arguments.context.pageData['BOMEnabled'] = false;
  ___arguments.context.pageData['DisplayingOptions'] = false;
  ___arguments.context.pageData['DisableEditButton'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'NeedToSave')) == true) {
    result = (await (async function(modifiedData) {
    	var userPreference;
    	
    	if (modifiedData) {
    	
    	  if (confirm("Save your changes? [Enter] to save or [Esc] to cancel") == true) {
    	    userPreference = "Save Requested";
    	  } else {
    	    userPreference = "Save Cancelled!";
    	  }
    	// console.log(userPreference)
    	return userPreference
    	  
    	}

    })((getObjectProperty(___arguments.context.pageData, 'UpdateEnabled'))));
    if (result == 'Save Requested') {
      console.log('Save Data Requested');
      tempChanges = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
         if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId'))) {
          item['NeedToSave'] = true;
          item['QtyOnHand'] = ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ExistingQuantityOnHand')) + (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ValueChange')));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
      ___arguments.context.pageData['SelectedRecord'] = tempChanges;
      console.log('### TEMP CHANGES ###');
      console.log(tempChanges);
      await ResetLock_SaveRecord('Save');
    } else {
      console.log('Save Cancelled!');
      await ResetLock_SaveRecord('Bypass');
    }
  }
  currentCount = 0;
  listCount = (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')), async (item) => {
     if ((getObjectProperty(item, 'NeedToSave')) == true) {
      currentCount = currentCount + 1;
    }


   return currentCount;
  }));
  console.log('### REMOVE HARD LOCK ###');
  if ((getObjectProperty(___arguments.context.pageData, 'isItemSelected')) == true) {
    selectedItem = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemID'));
    otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
       if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (otherUsers.length == 0) {
      await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    } else {
    }
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock_SaveRecord('Remove Lock');
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['disableBuildButton'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
  ___arguments.context.pageData['UpdatedEnabled'] = false;
  ___arguments.context.pageData['DBSearchTerm'] = null;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();
  ___arguments.context.pageData['SelectedRecord'] = null;

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'OpenDrawer'))

  },
  /* handler:isOpenLogic */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('%c>> ' + '### THE DRAWER onVisibilityChange event has fired! ###', 'color: #ffee58', true);

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2067cfaa57186ad87a9898b85338cfc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = '';
  ___arguments.context.pageData['changedSearchValue'] = '';
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5c78a54c1345e91a95089218e9a5db89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results, updatedValue, changedSearchValue;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('lazyTimer');
  changedSearchValue = ___arguments.value;
  ___arguments.context.pageData['changedSearchValue'] = changedSearchValue;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));

  ;(function() {
    const callback = async () => {
        rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), ___arguments.value, returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;

    };

    const timerId = 'lazyTimer';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/57c8c6db03c80d18e8f8cc3823b8d588/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildNumber'] = (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'));

  return (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b11deb6ffb5fc6287f71c1fde9c881c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var LotRequiredCount, tempBuildList, item, currentItem, Loterator, tempLotInfoList, LotCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST WORKING CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  tempBuildList = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  LotRequiredCount = 0;
  for (var item_index in tempBuildList) {
    item = tempBuildList[item_index];
    console.log('%c>> ' + (String('Iterator | Individual Item Raw Data | For: ') + String(getObjectProperty(item, 'ItemSKU'))), 'color: #f06292', item);
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    tempLotInfoList = (getObjectProperty(currentItem, 'LotsOfLots'));
    LotCount = 1;
    console.log('%c>> ' + (String('Lots For ItemSKU: ') + String(getObjectProperty(currentItem, 'ItemSKU'))), 'color: #f06292', tempLotInfoList);
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    item['ItemType'] = (getObjectProperty(currentItem, 'ItemType'));
    item['ItemSKU'] = (getObjectProperty(currentItem, 'ItemSKU'));
    item['Lot'] = (String('NO LOT') + String(''));
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
    item['QtyOnHand_Stored'] = (getObjectProperty(item, 'QtyOnHand_Stored'));
    if ((getObjectProperty(item, 'Type')) == 'Lot Required' || (getObjectProperty(item, 'Type')) == 'No Lot Required') {
      LotRequiredCount = LotRequiredCount + 1;
    }
  }
  ___arguments.context.pageData['BuildInputList'] = tempBuildList;
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = LotRequiredCount;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d8f847c3bd484258790d8ee2cdc78ffe/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var tempItemRowData, j, matchFoundBool, item, tempStorage, currentItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function debug() {
}

/**
 * Describe this function...
 */
async function Update_Inputs() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputListWorking'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  ___arguments.context.pageData['QtyToBuild'] = (Number((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('19d848bd0198057bdf689d2825d8e208')), 'value'))));
  console.log('### BUILD INPUT LIST CONTENTS ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  var item_list = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    currentItem = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(item, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    item['ItemName'] = (getObjectProperty(currentItem, 'ItemName'));
    item['QtyAvailable'] = (getObjectProperty(currentItem, 'QtyAvailable'));
    item['QtyEach'] = (getObjectProperty(item, 'Qty'));
    console.log('### CURRENT ITEM CONTENTS ###');
    console.log(currentItem);
    item['TotalInBuild'] = ((getObjectProperty(item, 'Qty')) * (getObjectProperty(___arguments.context.pageData, 'QtyToBuild')));
  }
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
}


  console.log('### Cell Params ###');
  console.log(___arguments['cellParams']);
  await debug();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['TotalInBuild'] = (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'));
  tempStorage = (getObjectProperty(___arguments['cellParams'], 'data.Item'));
  ___arguments.context.pageData['SelectedItemLotInfo'] = (await asyncListSort((getObjectProperty(((await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',tempStorage,'\''].join(''))).setPageSize(1)))[0]), 'LotsOfLots')), 1, async (item) => {


   return (getObjectProperty(item, 'ExpirationDate'));
  }));
  console.log('### SORTED LIST ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  matchFoundBool = false;
  var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    console.log('### LotInfo Iterator ###');
    console.log(j);
    if ((getObjectProperty(j, 'QtyAvailable')) >= (getObjectProperty(___arguments['cellParams'], 'data.TotalInBuild'))) {
      tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
      console.log('### TEMP ITEM ROW DATA ###');
      console.log(tempItemRowData);
      matchFoundBool = true;
      if ((getObjectProperty(___arguments['cellParams'], 'data.Lot')) == 'NO LOT') {
        ___arguments.context.pageData['MissingLotRequiredCount'] = ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) - 1);
      }
      tempItemRowData['Lot'] = (getObjectProperty(j, 'LotNumber'));
      (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
      console.log('### List Processed! | Matching Lot Found ###');
      break;
    }
  }
  if (matchFoundBool != true) {
    tempItemRowData = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)];
    tempItemRowData['Lot'] = (String('Lot#: ERROR!') + String(''));
    (getObjectProperty(___arguments.context.pageData, 'BuildInputList'))[(((getObjectProperty(___arguments['cellParams'], 'node.rowIndex')) + 1) - 1)] = tempItemRowData;
  }
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['BuildInputList'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/02c837387b180a58c6e8c698a5421d0b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('9118095205f91bcf81d8c8c879374d48');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/be6dddef2617d6feed76e118d46be698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Contents of Build BOM (pageData.BuildBOM)');
  ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildBOM'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/849835c82f980fe88f283c535bc35068/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var OptionsSQL, results, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete')) != true) {
    if ((getObjectProperty(___arguments.context.pageData, 'DisplayingBuildOptions')) == true) {
      if (true) {
        results = (await BackendlessUI.Functions.Custom['fn_80f5df059c5818d57f94d4f3c4ccbb8d']([(getObjectProperty(___arguments.context.pageData, 'TotalItemCount'))], null, 'ItemType IN (\'Assembly\', \'Subassembly\')'));
      }
    }
  }

  return results

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### BAM -- CHANGE EVENT HAS FIRED ### | Changed Value: ');
  console.log(___arguments['inputValue']);
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  if (true) {
    rawData = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',___arguments['inputValue'],'\''].join(''))).setPageSize(1)))[0];
    ___arguments.context.pageData['BuildInputCacheObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cbe8049511a8d40d505c50b91a73d199'))['content'] = (getObjectProperty(rawData, 'ItemName'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8'))['content'] = (getObjectProperty(rawData, 'Type'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ItemSKU'] = (getObjectProperty(rawData, 'ItemSKU'));
    ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyObjectID'] = (getObjectProperty(rawData, 'objectId'));
    ___arguments.context.pageData['NewBuildObjectID'] = ___arguments['inputValue'];
  }
  ___arguments.context.pageData['BuildInputCache'] = (getObjectProperty(rawData, 'BillOfMaterials'));

  },
  /* handler:onChange */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:disabledLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f4f861ab3ba7e15487683931d978ad18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('Cache | Working | Build');
  console.log('pageData.BuildInputCache | pageData.BuildInputListWorking | pageData.BuildInputList');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCache'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputListWorking'));
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  console.log('### pageData.BuildInputCacheObjectID ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/621307d5f4f84e1853d8605faff87423/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (JSON.stringify((getObjectProperty(___arguments.context.pageData, 'SelectedItemLotInfo'))))

  },
  /* handler:onValueAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9118095205f91bcf81d8c8c879374d48/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
    var tempObject, targetLotsOfLots, results, newLotToAdd;

  },
  /* handler:onSubmit */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8574086629f3817889ed206613b1a038/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (getObjectProperty(___arguments.context.pageData, 'BuildInputList'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['ReferenceType'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content'));
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1a4da068e93ddf4e09c63e1814886278/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemName')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1a4da068e93ddf4e09c63e1814886278'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a7587a25c278333847024ca737a83228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var freshFetch, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  freshFetch = (await Backendless.Data.of('BILTProducts').findById((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.objectId')), ));
  console.log('### FRESH FETCH ###');
  console.log(freshFetch);
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['_SafeToDelete'] = (getObjectProperty(freshFetch, 'SafeToDelete'));

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly'))) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord._SafeToDelete')) == true) {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.SafeToDelete')) == true) {
      if (!(getObjectProperty(___arguments.context.pageData, 'SelectedRecord.LotsOfLots')).length) {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Delete this item?', null, null, null, null, null, null, null, null]));
      } else {
        return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['In order to delete an item:', '\n', '► You must delete all lots from the item (GlobalAdmins Only)', '\n', '► After doing this...', null, null, null, null]));
      }
    } else {
      return false;
    }
  } else {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['To delete an item that has inventory: ', '\n', '► Assign zero to the master inventory count or build totals', '\n', '► After totals are zero, uncheck all entries for the lot activities screen', '\n', '► Delete the now zeroed-out lot(s) from the item', '\n', '► Save all changes']));
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2a18f6c82ac8815faf58889739e83a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = true;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a688fd534355ecdccf38a5c831756508/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var rawData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e8160728cd5ed6252378a4df98f33e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Assembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/80c8cae60881d96969f88be8d4f9a1df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var results;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (true) {
    stopSetTimeout('lazyTimer');

    ;(function() {
      const callback = async () => {
          results = (await BackendlessUI.Functions.Custom['fn_a9226edfdf2d5df47285bacb28b24afc']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), ___arguments.value));
      console.log('%c>> ' + '# LotNumber.onChange Event #', 'color: #f06292', results);
      if (results == true) {
        ___arguments.context.pageData['LotExists'] = true;
        console.log('### LOT EXISTS!!! ###');
      } else {
        ___arguments.context.pageData['LotExists'] = false;
        console.log('### Lot does NOT exist ###');
      }

      };

      const timerId = 'lazyTimer';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e758d258b1bb7ae81d38ae386fea74b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9ba8f5a8bed1ba98949716b3ec511f43/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'LotExists'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b03843d85ca89c78dfb955180391a3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) != 0) {
    ___arguments.context.pageData['DisableSaveButton'] = true;
    return true;
  } else {
    ___arguments.context.pageData['DisableSaveButton'] = false;
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### MissingLotRequiredCount ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ee1870615388f1b84c28332b2b3e8805/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) != true) {
    console.log('### REPEATER DATA ITEM ###');
    console.log(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));
    ___arguments.context.pageData['InventoryMode'] = 'Edit';
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['EditTriggered'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('59f8dd0b1a48f268abb8821507780fe8');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ef5868af8068df682cd8dd68b668dea4/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var results;



  return results

  },
  /* handler:optionsLogic */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0b1889be72c245c8ea35d0b80b48d6e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var otherUser, decision, item, unsafeSetResult, result, temp, var1, newList, tempUsersList, tempStorage, addedValue, record;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Check_For_Other_Users() {
  console.log('####### Func Check For Other User #######');
  otherUser = [];
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'))).get()), async (item) => {
     if (item == (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = false;
    } else {
      decision = true;
    }


   return decision;
  }));
  console.log('####### Func Check For Other User Result: #######');
  console.log(otherUser);
  if (otherUser.length > 0) {
    ___arguments.context.pageData['itemLocked'] = true;
    ___arguments.context.pageData['otherUser'] = (otherUser[0]);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
    console.log(otherUser);
  } else {
    ___arguments.context.pageData['itemLocked'] = false;
    ___arguments.context.pageData['otherUser'] = '';
    console.log('### NOBODY ELSE IS EDITING THIS PRODUCT ###');
    console.log(otherUser);
  }
  return otherUser
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_NEW(record) {
  console.log('### Func SetProductToUnsafe-NEW ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    console.log('### SET OWNER RECORD SELECTIONS ###');
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).addValue((getObjectProperty(tempStorage, 'objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}

/**
 * Describe this function...
 */
async function Initialize_Item_Rows() {
  ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['CurrentlySelectedItemID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
  ___arguments.context.pageData['CurrentlySelectedItemData'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
  ___arguments.context.pageData['CurrentlySelectedItem'] = true;
  ___arguments.context.pageData['isItemSelected'] = true;
}

/**
 * Describe this function...
 */
async function ResetLock() {
  console.log('### Func ResetLock ###');
  otherUser = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData.objectId'))).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    } else {
      decision = false;
    }


   return decision;
  }));
  if (otherUser.length == 0) {
    temp = (getObjectProperty(___arguments.context.pageData, 'CurrentlySelectedItemData'));
    await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(temp, 'objectId')),[`is_SafeToEdit`]: true,[`LastLockBy`]: '' }), true);
    console.log('### WE HAVE ANOTHER USER EDITING THIS PRODUCT!!! ###');
  } else {
  }
}

/**
 * Describe this function...
 */
async function SetProductToUnsafe_ORIGINAL(record) {
  console.log('### Func SetProductToUnsafe ###');
  tempStorage = record;
  result = await Check_For_Other_Users();
  if (result.length == 0) {
    console.log('### Length of OtherUser');
    console.log(result);
    addedValue = (await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).addValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    await Backendless.Hive('BILT_Product_Locks').SetStore((getObjectProperty(tempStorage, 'objectId'))).expireAfter(3600);
    temp = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    tempUsersList = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedByUsersList'));
    if (!(tempUsersList === null)) {
      if (tempUsersList.indexOf(getObjectProperty(___arguments.context.appData, 'currentUser.objectId')) + 1 == 0) {
        var1 = (addItemToList(tempUsersList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
      }
    } else {
      newList = [];
      var1 = (addItemToList(newList, (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))));
    }
    temp['is_SafeToEdit'] = false;
    temp['LastLockBy'] = (getObjectProperty(___arguments.context.appData, 'currentUser.name'));
    temp['SelectedByUsersList'] = var1;
    await Backendless.Data.of('BILTProducts').save(temp, true);
    console.log('### Func SetProductToUnsafe Result: ###');
    console.log(temp);
  }
}


  console.log('### Other User: ###');
  console.log(result);
  await Initialize_Item_Rows();
  if (true) {
    ___arguments.context.pageData['SelectedRecord'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['SelectedRecord_Drawer'] = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    ___arguments.context.pageData['DisableEditButton'] = false;
    ___arguments.context.pageData['AdjustQuantityOnHand'] = 0;
    ___arguments.context.pageData['showDataGrid'] = false;
    ___arguments.context.pageData['disableBuildButton'] = true;
    await (async function() {
    	const elements = document.getElementsByClassName('mainItemsBlock');
    	const currentHeight = elements[0].clientHeight; // Get the current height
    	newHeight = currentHeight
    	
    	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
    	if (newHeight < 2000) {
    	  newHeight = 2000;
    	}
    	elements[0].style.minHeight = newHeight + 'px'; // Set the new height
    	// alert('The current height is: '+ currentHeight);

    })();
    (function (component) { component.el.scrollIntoView() })((getObjectProperty(___arguments.context.pageData, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId')))));
    ___arguments.context.pageData['OpenDrawer'] = true;
  }
  result = await Check_For_Other_Users();
  if (Array.isArray((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LotsOfLots')))) {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  } else {
    ___arguments.context.pageData['ShowLots'] = true;
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c4b8687364a894cd0cf83e588c420678', ({ [`View`]: 1 }));
  }
  unsafeSetResult = await SetProductToUnsafe_ORIGINAL(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d4e74c524879470f0a480b988858d189/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemType')),' | ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'Type'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/421c58c800481e48a53827b2ce983968/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### FORM DATA ###');
  console.log(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9755594a4502872e35c86767ee78a0b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var returnedSQL, changedSearchValue, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  changedSearchValue = (getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  console.log('### CHANGED SEARCH VALUE ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'changedSearchValue'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (changedSearchValue != null) {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  } else {
    if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL)));
    } else {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))))));
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/eb9848180d7810659b78ef4b7c28df13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e55b670f7d287388fcc8c02870585638/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Non-Inventory Item') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3ed8b925c8b8a60871c1a998bca42b05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'itemLocked'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) == null) {
  } else if ((getObjectProperty(___arguments.context.pageData, 'otherUser')) != '') {
    response = (getObjectProperty((await Backendless.Data.of('Users').findById((getObjectProperty(___arguments.context.pageData, 'otherUser')), )), 'name'));
    if (getValueLength(response) > 0) {
      return (['User: ',response,' is editing this record.'].join(''));
    }
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a24959f8af7fae87ae946f58eaec9198/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'is_SafeToEdit')) == false) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var decision, item, selectedItem, selectedItemData, otherUsers, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ResetLock() {
  otherUsers = (await asyncListFilter((await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).get()), async (item) => {
     if (item != (getObjectProperty(___arguments.context.appData, 'currentUser.objectId'))) {
      decision = true;
    }


   return decision;
  }));
  if (otherUsers.length == 0) {
    temp = selectedItemData;
    temp['is_SafeToEdit'] = true;
    temp['LastLockBy'] = '';
    await Backendless.Data.of('BILTProducts').save(temp, true);
  } else {
  }
}


  if (true) {
    selectedItem = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'objectId'));
    selectedItemData = ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8');
    await Backendless.Hive('BILT_Product_Locks').SetStore(selectedItem).deleteValue((getObjectProperty(___arguments.context.appData, 'currentUser.objectId')));
    ___arguments.context.pageData['itemLocked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'DeleteBypass')) != true) {
      await ResetLock();
    }
  }
  ___arguments.context.pageData['isItemSelected'] = false;
  ___arguments.context.pageData['OpenDrawer'] = false;
  ___arguments.context.pageData['DeleteBypass'] = false;
  await (async function() {
  	const elements = document.getElementsByClassName('mainItemsBlock');
  	const currentHeight = elements[0].clientHeight; // Get the current height
  	newHeight = currentHeight
  	
  	// newHeight = currentHeight * (1 + percentageIncrease / 100); // Calculate new height
  	
  	elements[0].style.minHeight = 'auto'; // Set the new height
  	// alert('The current height is: '+ currentHeight);

  })();

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Locked by: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'LastLockBy')))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ae18cf988e782b17aae8ea88db68856b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'NeedToSave'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')['NeedToSave'] = false;
  await Backendless.Data.of('BILTProducts').save(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7d781ed537378a6893383c18a5d832fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### pageData: ###');
  console.log(___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/84e8c3bf6dbd254d32a15e58d65372ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord_Drawer ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/fdf81ae8dd33439a9fc8ecf593587a78/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord: ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/aa38d9bd26b8bea2b944fe7dd9c8e888/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### REPEATER DATA ###');
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/01b8b5564bcbb1489324e1f668ccc338/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c9de1df8d4f593050a25cc88a708d0c8'));
  if (results !== null && !Array.isArray(results) && (typeof results === 'object')) {
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(results, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(results, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(results, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(results, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(results, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(results, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(results, 'QtyAvailable'))]));
  } else {
    return 'NO DATA FOR THIS LOT';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### NewLotDataModel ###');
  console.log(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var error, lotTotalsResults, newGrandTotals, updatedItem, resultsFromUpdatingLotsOfLots_LotTotals, results, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  results = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = results;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = results;
}


  try {
    lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
    console.log('### New Lot Data: (results) ###');
    console.log(lotTotalsResults);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotTotalsResults);
    resultsFromUpdatingLotsOfLots_LotTotals = await UpdateLotsOfLots_LotTotals();
    newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotTotalsResults, 'ItemSKU')), null, null));
    console.log('### CALCULATED GRAND TOTALS ###');
    console.log(newGrandTotals);
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(newGrandTotals, 'QtyOnHand'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(newGrandTotals, 'QtyInLots'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'QtyInAssemblies'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(newGrandTotals, 'QtyReserved'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyShipped'] = (getObjectProperty(newGrandTotals, 'QtyShipped'));
    ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(newGrandTotals, 'QtyAvailable'));
    return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotTotalsResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotTotalsResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotTotalsResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotTotalsResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotTotalsResults, 'QtyReserved')), '\n', 'QtyShipped: ► ', (getObjectProperty(lotTotalsResults, 'QtyShipped')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotTotalsResults, 'QtyAvailable'))]));

  } catch (error) {
    console.log('%c>> ' + 'Minor Error: No lot activity yet for this record. ', 'color: #ffee58', error);

  }

  },
  /* handler:onMouseOver */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/eb984db1bf38588bb891f5425fb6b658/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var autoNotes, stamp, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  stamp = (new Date());
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = '';
  autoNotes = (await BackendlessUI.Functions.Custom['fn_8a5780448fe94c0c8d45ed833d64ec8b'](___arguments.value, (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')), (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('35e8f89e66b87c7a904f82617298d477'))['value'] = autoNotes;
  if ((typeof ___arguments.value === 'string') && (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')) != 0) {
    ___arguments.context.pageData['DisabledLotActionButton'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#027142';
  } else {
    ___arguments.context.pageData['DisabledLotActionButton'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('763828589718ac486e387bb81364aa68'))['background-color'] = '#B1B3B2';
  }
  ___arguments.context.pageData['SelectedLotAction'] = ___arguments.value;
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty'))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5c8297f84948640514287588d627bbec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedLotAction')), null, (getObjectProperty(___arguments.context.pageData, 'adjustmentQty')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')))));
  console.log('### LOT ADJUSTMENT RESULTS ###');
  console.log(results);
  ___arguments.context.pageData['DebugData'] = results;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9684354972e84c982ff38378d5e88348/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReceived: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReceived')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2c2aa00841985a482b1d0623ded89594/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyOnHand: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyOnHand')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/493863683c2882b3a298d1864e521128/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInLots: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInLots')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/eb761b8451c4fa89c9b8efc81f185238/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyInAssemblies: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyInAssemblies')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1153cfa1d33956ce90588a09b68a7d08/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyReserved: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyReserved')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/22f8d04e2f939394e4acbc88d448ddd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyAvailable: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyAvailable')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3ab891a75ec11778b696bbb2fc98eda8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowLotActivity'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      console.log('### BAM!!! The visibility has changed! ###');

  },
  /* handler:onVisibilityChange */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var item, lotUpdatedResults, newGrandTotals, newList, updatedItem, upsertedResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CodeForReference_FromMouseOverEvent() {
  lotUpdatedResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### NewLotDataModel ###');
  console.log(lotUpdatedResults);
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyOnHand'] = (getObjectProperty(lotUpdatedResults, 'QtyOnHand'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInLots'] = (getObjectProperty(lotUpdatedResults, 'QtyInLots'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyInAssemblies'] = (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyReserved'] = (getObjectProperty(lotUpdatedResults, 'QtyReserved'));
  ___arguments.context.pageData['SelectedRecord_Drawer.QtyAvailable'] = (getObjectProperty(lotUpdatedResults, 'QtyAvailable'));
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(lotUpdatedResults, 'ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
  }
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', lotUpdatedResults);
  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['QtyReceived: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReceived')), '\n', 'QtyOnHand: ► ', (getObjectProperty(lotUpdatedResults, 'QtyOnHand')), '\n', 'QtyInLots: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInLots')), '\n', 'QtyInAssemblies: ► ', (getObjectProperty(lotUpdatedResults, 'QtyInAssemblies')), '\n', 'QtyReserved: ► ', (getObjectProperty(lotUpdatedResults, 'QtyReserved')), '\n', 'QtyAvailable: ► ', (getObjectProperty(lotUpdatedResults, 'QtyAvailable'))]));
}


  console.log('### Modal-ShowLotActivity onClose Event ###');
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), null, null));
  if (newGrandTotals == ({  })) {
  } else {
    console.log('### Update Item Ticker Tape Totals ###');
    upsertedResults = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('### NEW CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  console.log('%c>> ' + 'upsertedResults | Modal onClose Event', 'color: #ffee58', upsertedResults);

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1b38f49697d8c7acdef89678b3281b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var widthDiff, lotsOfData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['LotAdjustmentData'] = ({  });
  ___arguments.context.pageData['LotAdjustmentData'] = ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc');
  ___arguments.context.pageData['editingLotNumber'] = (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'));
  ___arguments.context.pageData['LotEditMode'] = 'Edit';
  console.log('%c>> ' + 'Set editingLotNumber to: ', 'color: #ffee58', (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber')));
  ___arguments.context.pageData['ShowLotActivity'] = true;
  ___arguments.context.pageData['LotActivityModalData'] = ({ [`ItemSKU`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`SelectedLotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),[`Lot_objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c9de1df8d4f593050a25cc88a708d0c8'), 'Lot_objectId')),[`LotsOfData`]: lotsOfData,[`Item_objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) });
  widthDiff = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientWidth', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ad294be4b9b84fb423f83bb82ab8fbcc')))) - 246;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7df69f0852e88ec82f756168290846c8'))['left'] = (String(widthDiff / 2) + String('px'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2fbf54662ef87fc89ff8db1650682481/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowLotActivity'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3ab891a75ec11778b696bbb2fc98eda8');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/318883c85e38e7f86d3cc1082783eb88/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', (getObjectProperty(___arguments.context.pageData, 'LotActivityModalData')));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5e33822907f3202802dc420bda2873c8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var data, addFriendlyDates, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### Fetching Lots: Data Grid [Rows Data Logic] ###');
  data = (await Backendless.Data.of('BILTLotActivity').find(Backendless.DataQueryBuilder.create().setWhereClause((['_Lot.objectId in (\'',(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData.Lot_objectId')),'\')'].join(''))).setSortBy('LotActivityDate DESC').setPageSize(100)));
  for (var j_index in data) {
    j = data[j_index];
    j['ActivityDate'] = ([(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(j, 'LotActivityDate'))))).getFullYear())].join(''));
  }
  console.log('### Data: ###');
  console.log(data);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('318883c85e38e7f86d3cc1082783eb88', data);

  return data

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    var j, tempRepeaterList, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  result = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getSelectedRows() })('5e33822907f3202802dc420bda2873c8'));
  console.log('### SELECTED ROW ###');
  console.log(result);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellClick */
  /* handler:onCellValueChanged */
  async ['onCellValueChanged'](___arguments) {
    var j, tempRepeaterList, convertedDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + '### CELL VALUE CHANGED EVENT ###', 'color: #ffee58', ___arguments['dataObject']);
  console.log('%c>> ' + '### CELL PARAMS ###', 'color: #ffee58', ___arguments['cellParams']);
  convertedDataObject = ___arguments['dataObject'];
  if ((getObjectProperty(___arguments['dataObject'], 'LotAction')) == 'Item Initialized') {
    if ((getObjectProperty(___arguments['dataObject'], 'ACTIVE')) == false) {
      ___arguments['dataObject']['ACTIVE'] = true;
    }
  }
  convertedDataObject['QtyReceived'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReceived'))));
  convertedDataObject['QtyOnHand'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyOnHand'))));
  convertedDataObject['QtyInLots'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInLots'))));
  convertedDataObject['QtyInAssemblies'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyInAssemblies'))));
  convertedDataObject['QtyReserved'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyReserved'))));
  convertedDataObject['QtyShipped'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyShipped'))));
  convertedDataObject['QtyAvailable'] = (Number((getObjectProperty(___arguments['dataObject'], 'QtyAvailable'))));
  convertedDataObject['LotActivityDate'] = (getObjectProperty(___arguments['dataObject'], 'ActivityDate'));
  await Backendless.Data.of('BILTLotActivity').save(convertedDataObject, true);
  tempRepeaterList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d8a8ada8c7041d65bfad3fc831f85828'));
  console.log('%c>> ' + '### Lots Repeater Data ###', 'color: #ffee58', tempRepeaterList);
  for (var j_index in tempRepeaterList) {
    j = tempRepeaterList[j_index];
    if ((getObjectProperty(j, 'LotNumber')) == (getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.LotNumber'))) {
      j['MODIFIED'] = true;
    }
  }

  },
  /* handler:onCellValueChanged */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5e88726841484a6e494868c85698b461/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  console.log('### Block-LotActivityModalData ###');
  console.log(___arguments.context.getComponentDataStoreByUid('318883c85e38e7f86d3cc1082783eb88'));
  console.log('### Modal-ShowLotActivity - modalContent Data Model ###');
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a44a273860c38418e3581a5a8fd8fe3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyInLots'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f9a5b778ee0845b86b531db8b0d8d2a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyReserved'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9768556709633a05012517972218dc38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'QtyOnHand'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/6192e478df047898daa85a5559837bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyInLots'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ef88e964ecc6570867c1d17b3a0c98f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    return 'Inventory Item: ';
  } else {
    return 'LOT#:';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/3423a662511d7b48ea2f00b809417408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.LotActivityModalData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'LotActivityModalData'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/eb95a4e8903a52b741f7565d95c8b6ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	const textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb95a4e8903a52b741f7565d95c8b6ab'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2418f5397758628833683d08a2b86097/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function GenerateCorrectedLot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Deep Save ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));

  } catch (error) {
    console.log(error);

  }
  return newLinkerObject
}


  console.log('### CREATE NEW LOT AND CORRECT LINKAGES ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await GenerateCorrectedLot((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/00783d3d1c196f78eea8b878814156f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, newLinkerObject, newLotObject, error, newListItems, newAddedItemObject, NewLotNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Create_New_SYSTEM_Lot(NewLotNumber, newAddedItemObject) {
  try {
    console.log('### BUTTON ACTION: Create new lot placeholder in BILTProducts ###');
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`SYSTEM_LOT`]: true,[`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')) }),[`Lot_Number`]: NewLotNumber,[`Description`]: String('Inventory Action For: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')) }) ));
    newAddedItemObject['LotsOfLots'] = [];
    newListItems = (addItemToList((getObjectProperty(newAddedItemObject, 'LotsOfLots')), ({ [`LotNumber`]: NewLotNumber,[`ExpirationDate`]: (new Date(2145934800000)),[`ReceivedDates`]: [],[`QtyOnHand`]: 0,[`QtyReceived`]: 0,[`QtyInAssemblies`]: 0,[`Lot_objectId`]: (getObjectProperty(newLotObject, 'objectId')),[`SYSTEM_LOT`]: true })));
    console.log('### BUTTON ACTION: Link item in BILTProducts to "new" Lot ###');
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(newAddedItemObject, 'objectId')),[`LotsOfLots`]: [newListItems[0]] }) ));
    console.log('### BUTTON ACTION: Deep Save ###');
    console.log(error);

  } catch (error) {

  }
  return newLinkerObject
}


  console.log('### CREATE NEW INVENTORY ITEM LOT ###');
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    console.log(results);
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.Type')) == 'No Lot Required') {
    results = await Create_New_SYSTEM_Lot((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')));
    ___arguments.context.pageData['NeedToSave'] = true;
    console.log(results);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.appData, 'PRODUCTIONMODE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5348f8b8b98c61841352f58824b8d342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newGrandTotals, updatedItem, returnUpdateLotsOfLots, resultsLotTotals, tempCache, decision, item, newQtyReceived, newQtyOnHand;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ReferenceCode() {
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['NeedToSave'] = false;
  console.log((await Backendless.Data.of('BILTProducts').save((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), true)));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('969714588fa8bcf89d98c0d722e123d8'))['background-color'] = '#B1B3B2';
  ___arguments.context.pageData['NeedToSave'] = false;
  resultsLotTotals = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), null, null, null));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', resultsLotTotals);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function UpdateLotsOfLots_LotTotals() {
  resultsLotTotals = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.LotsOfLots')), async (item) => {
     if ((getObjectProperty(item, 'LotNumber')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber'))) {
      item['QtyReceived'] = (getObjectProperty(resultsLotTotals, 'QtyReceived'));
      item['QtyOnHand'] = (getObjectProperty(resultsLotTotals, 'QtyOnHand'));
      item['QtyInLots'] = (getObjectProperty(resultsLotTotals, 'QtyInLots'));
      item['QtyInAssemblies'] = (getObjectProperty(resultsLotTotals, 'QtyInAssemblies'));
      item['QtyReserved'] = (getObjectProperty(resultsLotTotals, 'QtyReserved'));
      item['QtyShipped'] = (getObjectProperty(resultsLotTotals, 'QtyShipped'));
      item['QtyAvailable'] = (getObjectProperty(resultsLotTotals, 'QtyAvailable'));
      decision = true;
    } else {
      decision = true;
    }


   return decision;
  }));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = resultsLotTotals;
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'))['LotsOfLots'] = resultsLotTotals;
  ___arguments.context.pageData['NeedToSave'] = true;
}


  resultsLotTotals = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: DB Fetch (results) ###');
  console.log(resultsLotTotals);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('c9de1df8d4f593050a25cc88a708d0c8', resultsLotTotals);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(resultsLotTotals, 'ItemSKU')), null, null));
  returnUpdateLotsOfLots = await UpdateLotsOfLots_LotTotals();
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(newGrandTotals, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyOnHand_Stored'] = (getObjectProperty(newGrandTotals, 'TotalQtyOnHand'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInLots'] = (getObjectProperty(newGrandTotals, 'TotalQtyInLots'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyAvailable'] = (getObjectProperty(newGrandTotals, 'TotalQtyAvailable'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyInAssemblies'] = (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyReserved'] = (getObjectProperty(newGrandTotals, 'TotalQtyReserved'));
  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['QtyShipped'] = (getObjectProperty(newGrandTotals, 'TotalQtyShipped'));
  ___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc')['MODIFIED'] = false;
  ___arguments.context.pageData['MODIFIED'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7df69f0852e88ec82f756168290846c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'MODIFIED')) == true || (getObjectProperty(___arguments.context.pageData, 'MODIFIED')) == true) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/fac891fe27d80d8b4ebadc43be0404c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### pageData.SelectedRecord ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b9e887f8edb888de49d89f68e9615c68/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) !== null && !Array.isArray((await Backendless.UserService.getCurrentUser(false))) && (typeof (await Backendless.UserService.getCurrentUser(false)) === 'object')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) === 'string') {
      return (String(getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')) + String(' Customer Portal'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2a18d94866f791282b53d891a52e0651/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) == 'Cellbri') {
    return 'https://api.biltsolutions.com/api/files/web/system/images/Cellbri_Logo.jpg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/cd8b8e9867683af9232871d83d18b069/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Disable-Autocomplete'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1b78b1d8145898683a6dec3629a83856/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b8960e6f99f8eef164a878685a3b8028/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var fileName, outputCSV_URL, stampNow;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exportFileName'] = null;
  Backendless.setCurrentUserToken(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')));
  console.log('%c>> ' + 'Logged In Portal User: ', 'color: #f06292', (await Backendless.UserService.getCurrentUser(false)));
  stampNow = (new Date());
  fileName = [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','_export_',(new Date(stampNow).getMonth() + 1),'-',(new Date(stampNow).getDate()),'-',(new Date(stampNow).getFullYear()),'_',(new Date(stampNow).getMilliseconds()),'.csv'].join('');
  outputCSV_URL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['/exports/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','/',fileName].join('')),'tableName': 'BILTProducts','tableOptions': ({ [`where`]: ['SelectedCustomer = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')) : 'BILT','\''].join(''),[`properties`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'],[`relations`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['ItemName', 'ItemSKU', 'ItemType', 'Type', 'QtyOnHand', 'QtyInLots', 'QtyInAssemblies', 'QtyReserved', 'QtyAvailable', 'ExpirationDate'] }) }));
  console.log('%c>> ' + 'The URL for the exported CSV file is: ', 'color: #f06292', outputCSV_URL);
  ___arguments.context.pageData['downloadCSV_URL'] = outputCSV_URL;
  ___arguments.context.pageData['exportFileName'] = fileName;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/af78263291574508ce08e5985f189cc2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/bc2cee8894b8f3185858aa9359c4ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b3c9b7661188183814229ac31df75603/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d0e8f8e231ea4b1964af4d8a096fe758/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ShowSpinner')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'actionGram'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b588c1f821fe1f481fd8cb581618659f/bundle.js', [], () => ({
  /* content */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'InventoryMode')) == 'Edit') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return ['SKUError'];
  } else {
    return [];
  }

  },
  /* handler:onClassListAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  results = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6611588021817235f47ddf82fb12cd8'), 'ItemSKU')),'\''].join(''))).setPageSize(1)));
  if (results.length > 0) {
    ___arguments.context.pageData['SKUError'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', true);
  } else {
    ___arguments.context.pageData['SKUError'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e9825de8d07fcf58947898ae8db5228e', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b47ab3e11d38cd5d23b75be8a9a22e29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Modal-ViewBuilds'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b47ab3e11d38cd5d23b75be8a9a22e29'))['background-color'] = '#032667';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/937d9db9da382a19e409059887c87a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Modal-ViewBuilds'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['SelectedBuildInfo'] = null;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/dc286049b54831082c188e1253e874a8/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var buildData, userLookup, eachBuild, DEBUG_, decision, eachUser, allUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  DEBUG_ = false;
  allUsers = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (DEBUG_) {
    console.log('### ALL USERS ###');
    console.log(allUsers);
  }
  buildData = (await Backendless.Data.of('BILTBuilds').find(Backendless.DataQueryBuilder.create().setSortBy('BuildNumber Desc').setPageSize(100)));
  for (var eachBuild_index in buildData) {
    eachBuild = buildData[eachBuild_index];
    eachBuild['BuildDateTime'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildDateTime'))))).getFullYear())].join(''));
    eachBuild['BuildExpirationDate'] = ([(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getMonth() + 1),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getDate()),'/',(new Date((new Date((getObjectProperty(eachBuild, 'BuildExpirationDate'))))).getFullYear())].join(''));
    eachBuild['_ownerId'] = (getObjectProperty(eachBuild, 'ownerId'));
    userLookup = (await asyncListFilter(allUsers, async (eachUser) => {
       if ((getObjectProperty(eachUser, 'objectId')) == (getObjectProperty(eachBuild, 'ownerId'))) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    if (DEBUG_) {
      console.log('### USER LOOKUP ###');
      console.log(userLookup);
    }
    eachBuild['Owner'] = (getObjectProperty((userLookup[0]), 'name'));
  }

  return buildData

  },
  /* handler:rowsDataLogic */
  /* handler:onCellClick */
  async ['onCellClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('### SELECTED ROW ###');
  console.log(___arguments['cellParams']);
  ___arguments.context.pageData['SelectedBuildInfo'] = (getObjectProperty(___arguments['cellParams'], 'data'));
  console.log('### SELECTED BUILD INFO ### (pageData.SelectedBuildInfo)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data'));
  ___arguments.context.pageData['SelectedBuildLotsData'] = (getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  console.log('### SELECTED BUILD LOTS DATA ### (pageData.SelectedBuildLotsData)');
  console.log(getObjectProperty(___arguments['cellParams'], 'data.LotsData'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openAll() })('16cb7631b402a10aa632f0c80add167f');

  },
  /* handler:onCellClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/16cb7631b402a10aa632f0c80add167f/bundle.js', [], () => ({
  /* content */
  /* handler:treeItemsLogic */
  ['treeItemsLogic'](___arguments) {
    var root, allItems, eachBuildItem, AssemblyName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('### CORRECT JSON ###');
  AssemblyName = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.AssemblyName'));
  root = [];
  addItemToList(root, ({ [`label`]: String('Assembly Info: ') + String(AssemblyName),[`value`]: 'Assembly Info',[`children`]: [({ [`label`]: String('Build Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.BuildNumber')),[`value`]: '#' }), ({ [`label`]: String('Lot Number: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.LotNumber')),[`value`]: '#' }), ({ [`label`]: String('Build Quantity: ') + String(getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo.QtyToBuild')),[`value`]: '#' })] }));
  var eachBuildItem_list = (getObjectProperty(___arguments.context.pageData, 'SelectedBuildLotsData'));
  for (var eachBuildItem_index in eachBuildItem_list) {
    eachBuildItem = eachBuildItem_list[eachBuildItem_index];
    addItemToList(root, ({ [`label`]: String('SKU: ') + String(getObjectProperty(eachBuildItem, 'ItemSKU')),[`value`]: 'Test',[`children`]: [({ [`label`]: String('Item Name: ') + String(getObjectProperty(eachBuildItem, 'ItemName')),[`value`]: '#' }), ({ [`label`]: String('Lot: ') + String(getObjectProperty(eachBuildItem, 'Lot')),[`value`]: '#' }), ({ [`label`]: ['Qty: ',(getObjectProperty(eachBuildItem, 'Qty')),' | Total In Build: ',(getObjectProperty(eachBuildItem, 'TotalInBuild'))].join(''),[`value`]: '#' })] }));
  }
  console.log('### LIST BUILDER ###');
  console.log(allItems);
  console.log('####### COMPLETED LIST #######');
  console.log(root);

  return root

  },
  /* handler:treeItemsLogic */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log('### CLICK EVENT ###');
  console.log('Label: ');
  console.log(___arguments['label']);
  console.log('Value: ');
  console.log(___arguments['value']);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'SelectedBuildInfo')) === 'object'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/4f48319a8be1f928e2682a964f38145c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('937d9db9da382a19e409059887c87a28');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ab78d82e61891e6886a8a2e78319adf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = true;
  } else {
    ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(true));
  if (getObjectProperty(currentUser, 'GlobalAdmin!')) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9f183413142794ef09a88b28ec224018/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['LotAdjustmentData.SYSTEM_LOT_BYPASS'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/eb38a1f878a2e406df48d2f8f4e16552/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/509837b66078b8e8f76863984eb5e152/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'LotAdjustmentData.SYSTEM_LOT')) == true) {
    return ({ [`min-width`]: '75%' });
  } else {
    return ({ [`min-width`]: '100%' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/19d848bd0198057bdf689d2825d8e208/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['BuildInputList'] = null;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ___arguments.context.pageData['MissingLotRequiredCount'] = -1;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/4d5842c8d688a2180a2d12288078932d/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Assembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Assembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Assembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d5842c8d688a2180a2d12288078932d'))['background-color'] = '#680575';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e435b6784ff8c4485e38cb3878886ac8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, returnedSQL, rawResponse;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Subassembly\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Subassembly\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Subassembly\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e435b6784ff8c4485e38cb3878886ac8'))['background-color'] = '#044B92';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7e58e812a49836286a886c8820786538/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7e58e812a49836286a886c8820786538'))['background-color'] = '#046563';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d8e63b0aaa215d8e82a302a8f56a0ea8/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\'')) {
    (getObjectProperty(___arguments.context.pageData, 'PageFilter')).splice((((getObjectProperty(___arguments.context.pageData, 'PageFilter')).indexOf('\'Non-Inventory Item\'') + 1) - 1), 1);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#32383F';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onDelete */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!((getObjectProperty(___arguments.context.pageData, 'PageFilter')).includes('\'Non-Inventory Item\''))) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'PageFilter')), '\'Non-Inventory Item\'');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8e63b0aaa215d8e82a302a8f56a0ea8'))['background-color'] = '#000000';
  }
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/cfbf82b82a0300e827482428b1282708/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord.ItemType')) == 'Subassembly') {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a117940a99e886cce5f7be282a02dfce/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'apartment';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'house siding';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'work outline';
  } else {
    return 'directions run';
  }

  },
  /* handler:onIconAssignment */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Assembly') {
    return 'This item is an Assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Subassembly') {
    return 'This item is a Sub-assembly';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f15a73fc80d1379c81047dfe249b6cb1'), 'ItemType')) == 'Inventory Item') {
    return 'This item is an Inventory Item';
  } else {
    return 'This item is an Non-Inventory Item';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/fe4d2d680a91b5f85fe25caec5d85e38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#5A0209';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f158b1d841586c754f58725d88c4c8a8'))['background-color'] = '#000000';
  ___arguments.context.pageData['changedSearchValue'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'SelectedCustomer'));
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('45087e7a25b852df58884c7836981338')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e62464f43ed3b7f75358d769c36210c4/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == null) {
    return ({ [`background-color`]: '#32383F' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) != '') {
    return ({ [`background-color`]: '#5A0209' });
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')) == 0) {
    return ({ [`background-color`]: '#32383F' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0747c1ca38580f08e818a7bad1240b68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'BOMInactiveItemExists'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b3ff83a8500f4ec6ed6873a8fbe8b698/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ___arguments.context.pageData['BOMEnabled'] = true;
  ___arguments.context.pageData['DisplayingOptions'] = true;

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c6486c37b7f886680ae84838f0d80fc9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.BOMUnlocked')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7fc8fd48a5b6eab8c22821587ef11f28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var exportBTNVisible;


  exportBTNVisible = false;
  if (exportBTNVisible) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, password, result, user, username, userToken;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://biltsolutions.webmojo.app/api/collections/Users/auth-with-password')).setEncoding('utf8').send(({ [`identity`]: username,[`password`]: password })));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
}

/**
 * Describe this function...
 */
async function Post_Changes() {
  result = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://biltsolutions.webmojo.app/api/collections/BILTProducts/records')))).set(({ [`Authorization`]: userToken,[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8')));
}


  username = 'mike@hyperpixels.net';
  password = 'MAK3520Jlm!!!';
  await login();
  if (user) {
    console.log(user);
    ___arguments.context.appData['currentUser'] = user;
    localStorage.setItem('UserToken', JSON.stringify((getObjectProperty(user, 'token'))));
    userToken = (getObjectProperty(user, 'token'));
    result = await Post_Changes();
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e9825de8d07fcf58947898ae8db5228e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SKUError')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7fa8b5187e987258845f0bf892e8d794/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newLotObject, error, newLinkerObject, tempObject, targetLotsOfLots, results, newLotToAdd, BOMResults, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, CreateNewLinkerObject, updatedItem, newGrandTotals, decision, lotTotalsResults, item, ProcessingChildItems, buildBOMItem, LotsOfLotsItem_FilterLoop, Phase1_productItemReference_List, LotItemReference, BOMTransactions, newBILTLotActivity, eachBuildBOMItem, Phase4_recalcTotalsResults, i, Phase4_TransactionsLength, Phase4_updateLotTotalsTransactions, Phase1_BOM_ForEachLoop, Phase4_productItemReference_List, tempList_Base, Phase4_BOM_ForEachLoop, phase4, Phase3_recalcTotalsResults, Phase3_TransactionsLength, Phase3_updateLotTotalsTransactions, Phase3_productItemReference_List, Phase3_BOM_ForEachLoop, phase3, Phase2_recalcTotalsResults, Phase2_TransactionsLength, Phase2_updateLotTotalsTransactions, Phase2_productItemReference_List, Phase2_BOM_ForEachLoop, phase2, Phase1_Tx, tempProductItem, Phase1_ListToProcess, Phase1_recalcTotalsResults, Phase1_TransactionsLength, Phase1_updateLotTotalsTransactions, phase1;

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#027142';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = false;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['background-color'] = '#B1B3B2';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function Form_Submit_Action() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateNewLinkerObject2() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

/**
 * Describe this function...
 */
async function RecalculateLotTotals_Local(ProcessingChildItems) {
  console.log('%c>> ' + 'Saved pageData.Form-Build_SavedData', 'color: #26a69a', (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData')));
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  console.log('### New Lot Data: (results) ###');
  console.log(lotTotalsResults);
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
  console.log('%c>> [10:22:56 AM]: ' + '### UPDATED GRAND TOTALS ###', 'color: #f06292', updatedItem);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  console.log('%c>> ' + '### EXISTING pageData BUILD BOM ###', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')));
  var buildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var buildBOMItem_index in buildBOMItem_list) {
    buildBOMItem = buildBOMItem_list[buildBOMItem_index];
    LotItemReference = (await Backendless.Data.of('BILTLots').find(Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(buildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)))[0];
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(buildBOMItem, 'ItemType')), (getObjectProperty(buildBOMItem, 'Type')), (getObjectProperty(buildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(buildBOMItem, 'objectId')), (getObjectProperty(buildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(LotItemReference, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(buildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(buildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(buildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    console.log('%c>> ' + '### CREATE (BILTLotActivity) NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #f06292', results);
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### New Lot Activity Response From DB ###', 'color: #3f51b5', newLotActivityResponse);
    Phase1_productItemReference_List = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(buildBOMItem, 'Item')),'\''].join(''))).setPageSize(1)))[0];
    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(buildBOMItem, 'Lot'))));
    console.log('######### DEBUG | LotTotalsResults #########');
    console.log(lotTotalsResults);
    newListItems = (await asyncListFilter((getObjectProperty(Phase1_productItemReference_List, 'LotsOfLots')), async (LotsOfLotsItem_FilterLoop) => {
       if ((getObjectProperty(LotsOfLotsItem_FilterLoop, 'LotNumber')) == (getObjectProperty(buildBOMItem, 'Lot'))) {
        LotsOfLotsItem_FilterLoop['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
        LotsOfLotsItem_FilterLoop['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
        decision = true;
      } else {
        decision = true;
      }


     return decision;
    }));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #f06292', newListItems);
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(buildBOMItem, 'Item')),[`LotsOfLots`]: newListItems }), true)));
    console.log('%c>> ' + '### NEW LOT ACTIVITY ###', 'color: #42a5f5', newLotActivityResponse);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['Form-Build_SavedData'] = buildBOMItem;
    ___arguments.context.pageData['CurrentlyProcessingItem'] = buildBOMItem;
    await RecalculateLotTotals_Local(true);
  }
  ___arguments.context.pageData['Disable-Autocomplete'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');
}

/**
 * Describe this function...
 */
async function Transactions_ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  var eachBuildBOMItem_list = (getObjectProperty(___arguments.context.pageData, 'BuildBOM'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('%c>> ' + '### Each buildBOMItem Results ###', 'color: #26c6da', eachBuildBOMItem);
    await ( async () => {
      const _uow = BOMTransactions;

      console.log('%c>> ' + '### FIND OPERATION WILL SEARCH FOR LOT ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'Lot')));
      ___arguments.context.pageData['actionGram'] = 'Processing... Updating each item in BOM';
      LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(eachBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));
      console.log('%c>> ' + '### eachBuildBOMItem.Item ###', 'color: #26c6da', (getObjectProperty(eachBuildBOMItem, 'objectId')));
      results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(eachBuildBOMItem, 'ItemType')), (getObjectProperty(eachBuildBOMItem, 'Type')), (getObjectProperty(eachBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(eachBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'))));
      console.log('%c>> ' + '### LotAdjustment Return ###', 'color: #26c6da', results);
      stamp = (new Date());
      results['LotActivityDate'] = stamp;
      delete results['ItemSKU'];
      delete results['ItemType'];
      delete results['Type'];
      delete results['ExtraData'];
      results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
      console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR THIS ITEM IN BUILD ###', 'color: #26c6da', results);
      ___arguments.context.pageData['actionGram'] = 'Processing... Creating BILTLotActivity entries for each item...';
      newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));
      console.log('%c>> ' + '### DEBUG!!! | TRYING TO SET RELATION... ###', 'color: #26c6da', [(newBILTLotActivity.resolveTo('objectId'))]);
      _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

    })();

  }
  BOMResults = (await BOMTransactions.execute());
  console.log('%c>> ' + '### TRANSACTION RESULTS ###', 'color: #f06292', BOMResults);
  if (BOMResults.isSuccess()) {
    try {
      results = await RecalculateBOMLotTotals();

    } catch (error) {
      console.log(error);

    }
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function RecalculateBOMLotTotals() {
  phase1 = false;
  phase2 = false;
  phase3 = false;
  phase4 = false;
  if (true) {
    if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 6) {
      phase1 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 0);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 5 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 11) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 5);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 10 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 16) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 10);
    } else if ((getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length > 15 && (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length < 21) {
      phase1 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(0, 5);
      phase2 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(5, 10);
      phase3 = (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).slice(10, 15);
      phase4 = subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'BuildBOM')), 15);
    } else {
      console.log('%c>> ' + '### ERROR: TOO MANY ITEMS IN THE BOM ### ACTUAL BOM ITEM QUANTITY: ', 'color: #f06292', (getObjectProperty(___arguments.context.pageData, 'BuildBOM')).length);
      return ({ [`error`]: 'To many items in BOM.  Unable to process the build. Maximum number of BOM items is 20.' });
    }
  }
  if (phase1 != false) {
    Phase1_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_TransactionsLength = phase1.length;
    for (var Phase1_BOM_ForEachLoop_index in phase1) {
      Phase1_BOM_ForEachLoop = phase1[Phase1_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase1_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase1_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase1_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase1_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase1_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase1_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase1_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];

      })();

    }
    Phase1_recalcTotalsResults = (await Phase1_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 1 | Transactions Results ###', 'color: #ffee58', (Phase1_recalcTotalsResults.getResults()));
    console.log('%c>> ' + '### Phase 1 | Number of Transactions ###', 'color: #ffee58', Phase1_TransactionsLength);
    Phase1_Tx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase1_ListToProcess = [];
    var i_inc = 1;
    if (1 > Phase1_TransactionsLength) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= Phase1_TransactionsLength : i >= Phase1_TransactionsLength; i += i_inc) {
      addItemToList(Phase1_ListToProcess, ((getObjectProperty((Phase1_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]));
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', Phase1_ListToProcess);
      await ( async () => {
        const _uow = Phase1_Tx;

        tempProductItem = Phase1_ListToProcess[(i - 1)];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
  }
  if (phase2 != false) {
    Phase2_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase2_TransactionsLength = phase2.length;
    for (var Phase2_BOM_ForEachLoop_index in phase2) {
      Phase2_BOM_ForEachLoop = phase2[Phase2_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase2_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase2_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase2_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase2_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase2_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase2_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase2_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase2_recalcTotalsResults = (await Phase2_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 2 | Transactions Results ###', 'color: #ffee58', Phase2_recalcTotalsResults);
    var i_inc2 = 1;
    if (1 > Phase2_TransactionsLength) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= Phase2_TransactionsLength : i >= Phase2_TransactionsLength; i += i_inc2) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase2_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase3 != false) {
    Phase3_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase3_TransactionsLength = phase3.length;
    for (var Phase3_BOM_ForEachLoop_index in phase3) {
      Phase3_BOM_ForEachLoop = phase3[Phase3_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase3_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase3_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase3_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase3_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase3_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase3_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase3_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase3_recalcTotalsResults = (await Phase3_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 3 | Transactions Results ###', 'color: #ffee58', Phase3_recalcTotalsResults);
    var i_inc3 = 1;
    if (1 > Phase3_TransactionsLength) {
      i_inc3 = -i_inc3;
    }
    for (i = 1; i_inc3 >= 0 ? i <= Phase3_TransactionsLength : i >= Phase3_TransactionsLength; i += i_inc3) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase3_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
  if (phase4 != false) {
    Phase4_updateLotTotalsTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    Phase4_TransactionsLength = phase4.length;
    for (var Phase4_BOM_ForEachLoop_index in phase4) {
      Phase4_BOM_ForEachLoop = phase4[Phase4_BOM_ForEachLoop_index];
      await ( async () => {
        const _uow = Phase4_updateLotTotalsTransactions;

        console.log('%c>> ' + '### BOMRecalcItem Output ###', 'color: #26c6da', Phase4_BOM_ForEachLoop);
        console.log('%c>> ' + '### BOMRecalcItem (Item (objectId)) Output ###', 'color: #26c6da', (getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')));
        ___arguments.context.pageData['actionGram'] = 'Processing... Finding BOM Product item to update...';
        Phase1_productItemReference_List = (_uow.find('BILTProducts', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Phase4_BOM_ForEachLoop, 'Item')),'\''].join(''))).setPageSize(1)));
        console.log('%c>> ' + '### Recalc Totals: Find: productItem Reference objectId ###', 'color: #26c6da', (Phase4_productItemReference_List.resolveTo(0, 'objectId')));
        lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(Phase4_BOM_ForEachLoop, 'Lot'))));
        console.log('%c>> ' + '### recalcTotals RESPONSE ###', 'color: #f06292', lotTotalsResults);
        tempList_Base = (Phase4_productItemReference_List.resolveTo());
        console.log('%c>> ' + '###### DEBUG: tempList Base ######', 'color: #f06292', tempList_Base);
        console.log('%c>> ' + '### DEBUG: tempList (Property: LotsOfLots) ###', 'color: #f06292', (Phase4_productItemReference_List.resolveTo(0, 'LotsOfLots')));
        newListItems = [];
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM items lot totals...';
        ___arguments.context.pageData['actionGram'] = 'Processing... Updating BOM ItemSKU inventory totals...';

      })();

    }
    Phase4_recalcTotalsResults = (await Phase4_updateLotTotalsTransactions.execute());
    console.log('%c>> ' + '### Phase 4 | Transactions Results ###', 'color: #ffee58', Phase4_recalcTotalsResults);
    var i_inc4 = 1;
    if (1 > Phase4_TransactionsLength) {
      i_inc4 = -i_inc4;
    }
    for (i = 1; i_inc4 >= 0 ? i <= Phase4_TransactionsLength : i >= Phase4_TransactionsLength; i += i_inc4) {
      console.log('%c>> ' + '### Phase 1 | Product1 | Index 0 LotsOfLots Contents ###', 'color: #ffee58', (getObjectProperty(((getObjectProperty((Phase4_recalcTotalsResults.getResults()), (['findBILTProducts',i,'.result'].join(''))))[0]), 'LotsOfLots')));
    }
  }
}

/**
 * Describe this function...
 */
async function CodeToAdd() {
}


  await DisableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['actionGram'] = 'Processing.';
  console.log('############## MOVED FORM SUBMIT ACTION ##############');
  await Form_Submit_Action();
  ___arguments.context.pageData['actionGram'] = 'Processing..';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  console.log('%c>> ' + 'Response-CreateNewAssemblyLot', 'color: #42a5f5', CreateNewLotResponse);
  CreateNewLinkerObject = await CreateNewLinkerObject2();
  console.log('%c>> ' + 'Response-CreateNewLinkerObject (ref: to BILTLots)', 'color: #42a5f5', CreateNewLinkerObject);
  ___arguments.context.pageData['actionGram'] = 'Processing...';
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('### STARTING: CREATE NEW LOT ACTION FOR BUILD ###');
    ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
    results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')))));
    console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
    stamp = (new Date());
    results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
    results['LotActivityDate'] = stamp;
    delete results['ItemSKU'];
    delete results['ItemType'];
    delete results['Type'];
    delete results['ExtraData'];
    results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
    if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
      newLinkerObject['LotsOfLots'] = [];
    }
    newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
    console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
    ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
    console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
    ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
    newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
    console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
    await RecalculateLotTotals_Local(false);
    ___arguments.context.pageData['Form-Build_SavedData'] = ({  });
    ___arguments.context.pageData['BuildBOM'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
    BOMResults = await ProcessBOMItems();
  } else {
  }
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7fa8b5187e987258845f0bf892e8d794'))['disabled'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e5565e88ffa863a85686d20886441204/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCancelButton'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0c435ff90425360448a842b88248ecfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['LotsOfLots'] = [];
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/17ac68113ea81dd96d6a6548ef68f81d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var targetLotsOfLots, results, newLotToAdd, newLotObject, error, newLinkerObject, newLotActivityResponse, newListItems, CreateNewLotResponse, stamp, newGrandTotals, updatedItem, decision, lotTotalsResults, LotsOfLotsItem, ProcessingChildItems, CreateNewLinkerObject, BOMLotCalcTxResults, txResults, BOMLotCalcTx, eachBuildBOMItem, BOMTransactions, response_CreateNewLotActionRelation, response_CreateNewLotAction, newBILTLotActivity, pushedBuildBOMItem, LotItemReference, SKUTotalsResults, PushedBOMItem, BOM_productItemList_Reference;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function CreateNewBuild() {
  console.log('### FORM SUBMIT ACTION ###');
  console.log(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['AssemblyName'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotsData'] = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['BuildDateTime'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['TargetLotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildNumber')));
  await Backendless.Data.of('BILTBuilds').save(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), true);
  newLotToAdd = ({ [`originalObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ExpirationDate')),[`QtyReceived`]: undefined,[`QtyOnHand`]: undefined,[`QtyInAssemblies`]: undefined });
  results = (await BackendlessUI.Functions.Custom['fn_858220770dd2cd5781ac7cc60be4f633']((getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')), (getObjectProperty(___arguments.context.pageData, 'BuildBOM')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild'))));
  if (results.isSuccess()) {
    targetLotsOfLots = (getObjectProperty(((getObjectProperty(results, 'results.FindMatchingAssembly.result'))[0]), 'LotsOfLots'));
    console.log('### FORMSUBMITACTION: Transaction Results ###');
    console.log(results);
    console.log('### FindMatchingAssembly.result (LotsOfLots) ###');
    console.log(targetLotsOfLots);
  }
}

/**
 * Describe this function...
 */
async function CreateNewAssemblyLot() {
  try {
    newLotObject = (await Backendless.Data.of('BILTLots').deepSave( ({ [`_LinkedItem`]: ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }),[`Lot_Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`Expiration Date`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')),[`Description`]: String('Lot For: ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')) }) ));
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLotObject['error'] = error;
    console.log(error);

  } finally {
    newLotObject['error'] = '';

  }
  return newLotObject
}

/**
 * Describe this function...
 */
async function CreateNewLinkerObjectFunc() {
  try {
    newLinkerObject = (await Backendless.Data.of('BILTProducts').deepSave( ({ [`_Lots`]: [({ [`objectId`]: (getObjectProperty(newLotObject, 'objectId')) })],[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'AssemblyObjectID')) }) ));

  } catch (error) {
    newLinkerObject['error'] = error;
    console.log(error);

  } finally {
    newLinkerObject['error'] = '';

  }
  return newLinkerObject
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function CreateBuildLotAction() {
  console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #ffee58', 'Executing Function...');
  ___arguments.context.pageData['ExtraData'] = ({ [`BuildDateTime`]: (new Date()),[`AssemblyName`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')),[`AssemblyObjectID`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputCacheObjectID')),[`Ref_Type`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee1821f50e184208c5183fe76d783ad8')), 'content')),[`LotsData`]: (getObjectProperty(___arguments.context.pageData, 'BuildInputList')) });
  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']('Assembly', (getObjectProperty(___arguments.context.pageData, 'ExtraData.Ref_Type')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')), 'Build', (getObjectProperty(CreateNewLotResponse, 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')), null, (String('(Me) ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU'))), null));
  console.log('%c>> ' + '### CREATE NEW LOT ACTION FOR BUILD ###', 'color: #42a5f5', results);
  stamp = (new Date());
  results['_Lot'] = ({ [`objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) });
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'QtyToBuild')),') of Item: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'ItemSKU')),'] Of Lot: [',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  if ((getObjectProperty(newLinkerObject, 'LotsOfLots')) === null) {
    newLinkerObject['LotsOfLots'] = [];
  }
  newListItems = (addItemToList((getObjectProperty(newLinkerObject, 'LotsOfLots')), ({ [`LotNumber`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'LotNumber')),[`ExpirationDate`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48'), 'BuildExpirationDate')).valueOf()),[`ReceivedDates`]: [stamp],[`QtyOnHand`]: (getObjectProperty(results, 'QtyOnHand')),[`QtyReceived`]: (getObjectProperty(results, 'QtyReceived')),[`QtyInLots`]: (getObjectProperty(results, 'QtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(results, 'QtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(results, 'QtyReserved')),[`QtyAvailable`]: (getObjectProperty(results, 'QtyAvailable')),[`Lot_objectId`]: (getObjectProperty(CreateNewLotResponse, 'objectId')) })));
  console.log('%c>> ' + 'Into BILTProducts Upsert Following object:', 'color: #42a5f5', newListItems);
  ___arguments.context.pageData['actionGram'] = 'Processing... Updating Product\'s Lot Info...';
  console.log((await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'NewBuildObjectID')),[`LotsOfLots`]: newListItems,[`BOMUnlocked`]: false }), true)));
  ___arguments.context.pageData['actionGram'] = 'Processing... Creating new Lot Activity Entry...';
  newLotActivityResponse = (await Backendless.Data.of('BILTLotActivity').deepSave( results ));
  console.log('%c>> ' + '### NEW LOT ACTIVITY RESPONSE ###', 'color: #42a5f5', newLotActivityResponse);
}

/**
 * Describe this function...
 */
async function RecalculateAssemblyLotTotals(ProcessingChildItems) {
  console.log('%c>> ' + '### Func: RecalculateAssemblyLotTotals ###', 'color: #ffee58', 'Executing Function...');
  lotTotalsResults = (await Backendless.Data.of('InventoryCalculator').find(Backendless.DataQueryBuilder.create().setWhereClause((['ItemSKU = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')),'\' AND Lot_Number = \'',(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.LotNumber')),'\''].join(''))).setPageSize(1)))[0];
  newGrandTotals = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.ItemSKU')), null, null));
  console.log('### Form-Build_SavedData ###');
  console.log(getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData'));
  console.log('### CALCULATED GRAND TOTALS ###');
  console.log(newGrandTotals);
  if (ProcessingChildItems == true) {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.Item')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  } else {
    updatedItem = (await Backendless.Data.of('BILTProducts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'Form-Build_SavedData.AssemblyObjectID')),[`QtyOnHand_Stored`]: (getObjectProperty(newGrandTotals, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(newGrandTotals, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(newGrandTotals, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(newGrandTotals, 'TotalQtyReserved')),[`QtyAvailable`]: (getObjectProperty(newGrandTotals, 'TotalQtyAvailable')) }), true));
  }
}

/**
 * Describe this function...
 */
async function Clean_Up() {
  ___arguments.context.pageData['ShowSpinner'] = false;
  ___arguments.context.pageData['MissingLotRequiredCount'] = 99;
  ___arguments.context.pageData['ShowCancelButton'] = true;
}

/**
 * Describe this function...
 */
async function DisableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = true;
  ___arguments.context.pageData['DisableSaveButton'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#B1B3B2';
}

/**
 * Describe this function...
 */
async function EnableSaveButton() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['disabled'] = false;
  ___arguments.context.pageData['DisableSaveButton'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17ac68113ea81dd96d6a6548ef68f81d'))['background-color'] = '#027142';
}

/**
 * Describe this function...
 */
async function ProcessBOMItems() {
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  var eachBuildBOMItem_list = (await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getRowsData() })('d8f847c3bd484258790d8ee2cdc78ffe'));
  for (var eachBuildBOMItem_index in eachBuildBOMItem_list) {
    eachBuildBOMItem = eachBuildBOMItem_list[eachBuildBOMItem_index];
    console.log('### BUILD BOM ###');
    console.log(eachBuildBOMItem);
    BOMTransactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    response_CreateNewLotAction = await ProcessBOMItems_CreateNewLotAction(eachBuildBOMItem);
    response_CreateNewLotActionRelation = await ProcessBOMItems_CreateNewLotActionRelation();
    BOMLotCalcTx = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    txResults = (await BOMTransactions.execute());
    await ProcessBOMItems_RecalculateLotTotals(eachBuildBOMItem);
    BOMLotCalcTxResults = (await BOMLotCalcTx.execute());
    console.log('%c>> ' + '### Tx Results ###', 'color: #ffee58', (txResults.getResults()));
    console.log('%c>> ' + '### BOM LotCalc Tx Results ###', 'color: #ffee58', (BOMLotCalcTxResults.getResults()));
  }
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotAction(pushedBuildBOMItem) {
  await ( async () => {
    const _uow = BOMTransactions;

    LotItemReference = (_uow.find('BILTLots', Backendless.DataQueryBuilder.create().setWhereClause((['Lot_Number = \'',(getObjectProperty(pushedBuildBOMItem, 'Lot')),'\''].join(''))).setPageSize(1)));

  })();

  results = (await BackendlessUI.Functions.Custom['fn_075fbe5213aec3d601f23091a4de25e4']((getObjectProperty(pushedBuildBOMItem, 'ItemType')), (getObjectProperty(pushedBuildBOMItem, 'Type')), (getObjectProperty(pushedBuildBOMItem, 'ItemSKU')), 'Item In Build', (getObjectProperty(LotItemReference, 'objectId')), (getObjectProperty(pushedBuildBOMItem, 'TotalInBuild')), null, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62c49618fc18f238f1b865f84dc6a851')), 'content')), (getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue'))));
  console.log('%c>> ' + '### LotAdjustment Function Return ###', 'color: #ffee58', results);
  stamp = (new Date());
  results['LotActivityDate'] = stamp;
  delete results['ItemSKU'];
  delete results['ItemType'];
  delete results['Type'];
  delete results['ExtraData'];
  results['ActionAutoNotes'] = (['Built: (',(getObjectProperty(eachBuildBOMItem, 'TotalInBuild')),') of Item: [',(getObjectProperty(eachBuildBOMItem, 'ItemSKU')),'] Of Lot: [',(getObjectProperty(eachBuildBOMItem, 'Lot')),'] On: (',(stamp.toLocaleDateString()),' @ ',(stamp.toLocaleTimeString()),')'].join(''));
  await ( async () => {
    const _uow = BOMTransactions;

    newBILTLotActivity = (_uow.upsert('BILTLotActivity', results));

  })();

  return newBILTLotActivity
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_CreateNewLotActionRelation() {
  await ( async () => {
    const _uow = BOMTransactions;

    _uow.setRelation('BILTLotActivity', newBILTLotActivity, '_Lot', LotItemReference);

  })();

}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ProcessBOMItems_RecalculateLotTotals(PushedBOMItem) {
  console.log('%c>> ' + '### NEW BOM ITEM CALL ###', 'color: #f06292', PushedBOMItem);
  console.log('%c>> ' + '### PushedBOMItem', 'color: #ffee58', PushedBOMItem);
  BOM_productItemList_Reference = (await Backendless.Data.of('BILTProducts').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(PushedBOMItem, 'Item')),'\''].join(''))).setPageSize(1)));
  console.log('%c>> ' + '### DEBUG: BOM_productItemReference_List ###', 'color: #ffee58', BOM_productItemList_Reference);
  await ( async () => {
    const _uow = BOMLotCalcTx;

    lotTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589'](null, null, (getObjectProperty(PushedBOMItem, 'Lot'))));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals Response ###', 'color: #ffee58', lotTotalsResults);
    SKUTotalsResults = (await BackendlessUI.Functions.Custom['fn_b9ba2194016bb7148a66b77804bdb589']((getObjectProperty(PushedBOMItem, 'ItemSKU')), null, null));
    console.log('%c>> ' + '### DEBUG: RecalculateLotTotals by SKU Response ###', 'color: #ffee58', SKUTotalsResults);
    if (true) {
      results = (await asyncListFilter((getObjectProperty((BOM_productItemList_Reference[0]), 'LotsOfLots')), async (LotsOfLotsItem) => {
         if ((getObjectProperty(LotsOfLotsItem, 'LotNumber')) == (getObjectProperty(PushedBOMItem, 'Lot'))) {
          LotsOfLotsItem['QtyReceived'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReceived'));
          LotsOfLotsItem['QtyOnHand'] = (getObjectProperty(lotTotalsResults, 'TotalQtyOnHand'));
          LotsOfLotsItem['QtyInLots'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInLots'));
          LotsOfLotsItem['QtyInAssemblies'] = (getObjectProperty(lotTotalsResults, 'TotalQtyInAssemblies'));
          LotsOfLotsItem['QtyReserved'] = (getObjectProperty(lotTotalsResults, 'TotalQtyReserved'));
          LotsOfLotsItem['QtyShipped'] = (getObjectProperty(lotTotalsResults, 'TotalQtyShipped'));
          LotsOfLotsItem['QtyAvailable'] = (getObjectProperty(lotTotalsResults, 'TotalQtyAvailable'));
          decision = true;
        } else {
          decision = true;
        }


       return decision;
      }));
    }
    _uow.upsert('BILTProducts', ({ [`objectId`]: (getObjectProperty(PushedBOMItem, 'Item')),[`LotsOfLots`]: results,[`QtyOnHand_Stored`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyOnHand')),[`QtyInLots`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInLots')),[`QtyInAssemblies`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyInAssemblies')),[`QtyReserved`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyReserved')),[`QtyShipped`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyShipped')),[`QtyAvailable`]: (getObjectProperty(SKUTotalsResults, 'TotalQtyAvailable')) }));

  })();

}


  await DisableSaveButton();
  ___arguments.context.pageData['Disable-Autocomplete'] = true;
  ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48')['LotNumber'] = (String('B') + String(getObjectProperty(___arguments.context.pageData, 'BuildNumberCounterCurrentValue')));
  ___arguments.context.pageData['Form-Build_SavedData'] = ___arguments.context.getComponentDataStoreByUid('9118095205f91bcf81d8c8c879374d48');
  ___arguments.context.pageData['ShowSpinner'] = true;
  ___arguments.context.pageData['ShowCancelButton'] = false;
  ___arguments.context.pageData['actionGram'] = 'Processing ...';
  await CreateNewBuild();
  ___arguments.context.pageData['actionGram'] = '>.. Creating New Assembly Lot...';
  CreateNewLotResponse = await CreateNewAssemblyLot();
  ___arguments.context.pageData['actionGram'] = '>>. Linking new Assembly Lot...';
  CreateNewLinkerObject = await CreateNewLinkerObjectFunc();
  if ((getObjectProperty(CreateNewLinkerObject, 'error')) == '') {
    console.log('%c>> ' + '### Func: CreateBuildLotAction ###', 'color: #4caf50', 'Executing Function');
    await CreateBuildLotAction();
  } else {
    console.log('%c>> ' + '### ERROR: Unable to create new linker object!!!', 'color: #ef5350', (getObjectProperty(CreateNewLinkerObject, 'error')));
  }
  ___arguments.context.pageData['actionGram'] = '>>> Creating Build Lot Activity...';
  ___arguments.context.pageData['actionGram'] = '>>> Recalculating Assembly Lot Totals...';
  await RecalculateAssemblyLotTotals(false);
  await ProcessBOMItems();
  await Clean_Up();
  await EnableSaveButton();
  ___arguments.context.pageData['ShowCancelButton'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var tempUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(tempUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'MissingLotRequiredCount')) > 0 || (getObjectProperty(___arguments.context.pageData, 'LotExists')) == true || (getObjectProperty(___arguments.context.pageData, 'DisableSaveButton')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/e70461f81e97f5027fd199c244ac05f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8')), 'content')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e70461f81e97f5027fd199c244ac05f8'))['background-color'] = '#000000';

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'ItemSKU')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0a949e54ed285d189093ada9c8e673c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(itemInnerText) {
  	// Select the element whose innerText you want to capture
  	// const itemElement = document.getElementById("ItemSKU");
  	
  	// Get the innerText of the selected element
  	let textToCopy = itemInnerText;
  	
  	// Use the Clipboard API to copy the text to the clipboard
  	navigator.clipboard.writeText(textToCopy).then(() => {
  	  console.log('Text copied to clipboard: ', textToCopy);
  	}).catch(err => {
  	  console.error('Failed to copy: ', err);
  	});

  })((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.objectId')));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#3A8A31';
  await new Promise(r => setTimeout(r, 500 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0a949e54ed285d189093ada9c8e673c8'))['color'] = '#728FED';

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/544ff122317824c8336a45d8f07fe428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2a18f6c82ac8815faf58889739e83a38');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/35f1dea8b99e1d9447fd2162f888c9e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var results, returnedSQL, deletedItem, ItemsList, rawResponse, newList, ModifiedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#820303';
  ___arguments.context.pageData['displayOnlyInactive'] = true;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  ;(function(whereClause) {
    const callback = async ModifiedItem => {
        console.log('### RT ITEM ###');
    console.log(ModifiedItem);
    newList = (replaceItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), ModifiedItem, 'objectId'));
    console.log('### UPDATED LIST ###');
    console.log(newList);
    returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))))));
      ___arguments.context.pageData['LoadedProducts'] = results;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));
    } else {
      rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage'))));
      ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    }

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Upsert_RT1', () => rtHandlers.removeUpsertListener(callback));

  })('');

  ;(function(whereClause) {
    const callback = async deletedItem => {
        deletedItem = (removeItemInList((getObjectProperty(___arguments.context.pageData, 'LoadedProducts')), deletedItem, 'objectId'));
    if (getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess')) {
      results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalAccess')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), returnedSQL));
    } else {
      results = (await BackendlessUI.Functions.Custom['fn_1435fbe7d0246cabf63e29b22d4bd3db']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), (getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), returnedSQL, false, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage')))));
    }
    ___arguments.context.pageData['LoadedProducts'] = results;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', (getObjectProperty(___arguments.context.pageData, 'LoadedProducts')));

    };

    const rtHandlers = Backendless.Data.of('BILTProducts').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('Products_Delete_RT1', () => rtHandlers.removeDeleteListener(callback));

  })('');

  },
  /* handler:onClick */
  /* handler:onDelete */
  async ['onDelete'](___arguments) {
    var ItemsList, results, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('35f1dea8b99e1d9447fd2162f888c9e5'))['background-color'] = '#32383F';
  ___arguments.context.pageData['displayOnlyInactive'] = false;
  ___arguments.context.pageData['pageCursor'] = 0;
  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly')) {
    results = (await BackendlessUI.Functions.Custom['fn_c2e3dff976fd4c1ef581428608612b72']((getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), (getObjectProperty(___arguments.context.pageData, 'changedSearchValue')), (getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalAccess')), returnedSQL));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', results);
  } else {
    rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27'](false, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 1), 50));
    ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
    ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
    ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
    ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
    ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
    console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));
    ___arguments.context.pageData['LoadedProducts'] = ItemsList;
  }

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/1bffd2f81bd89c1803bfd0b851076fb4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/a9222d78ce0e7e220a38f96f79388788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/ee38efabe87fe1b80e187cabec8bca63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? true : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/34d8fe69719c4888595644d82627f9b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.ItemType')) == 'Assembly') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ad294be4b9b84fb423f83bb82ab8fbcc'), 'QtyShipped'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9f81ec58a1a84a4855d82dd8c538355d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('QtyShipped: ') + String(getObjectProperty(___arguments.context.pageData, 'DebugData.QtyShipped')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/48b85d28e77878e51dd88168f488748c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer.QtyShipped'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f15a73fc80d1379c81047dfe249b6cb1/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'HasProblems')) {
    return ({ [`background-color`]: '#9C4306' });
  } else {
    return ({ [`background-color`]: '#282828' });
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/4af1c1386cc844e83938da682ef81081/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Page: ',(Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1,' Of ',(Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) == 0 ? (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))) + 1 : (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages')))),' Pages'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/b248d3ffbc257f55878c115804785498/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL, results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) > Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1) {
    ___arguments.context.pageData['pageCursor'] = (Math.ceil((getObjectProperty(___arguments.context.pageData, 'totalItems')) / (getObjectProperty(___arguments.context.pageData, 'perPage'))) - 1);
  } else {
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b248d3ffbc257f55878c115804785498'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/f178c3189dcc62e92da8263498480a48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) - 1);
  if ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) < 0) {
    ___arguments.context.pageData['pageCursor'] = 0;
  }
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, ((getObjectProperty(___arguments.context.pageData, 'pageCursor')) * (getObjectProperty(___arguments.context.pageData, 'perPage'))), (getObjectProperty(___arguments.context.pageData, 'perPage')), null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f178c3189dcc62e92da8263498480a48'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/7968c368cf181cc849b61cf8b1a82197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Bottom', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/52b62ec81584490555eb2dc85a28cd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('#Top', false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/aa4845861628f158f3f2d518845634a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/59c8248a56112a48c5866a586cc85a9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  ___arguments.context.pageData['pageCursor'] = 0;
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, 0, 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 <= 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('59c8248a56112a48c5866a586cc85a9a'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c1088deaefb8ef636c8696bc0935b758/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var ItemsList, rawResponse, returnedSQL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  returnedSQL = (await BackendlessUI.Functions.Custom['fn_d6b3febe14160053c0058b53a144c2b5']((getObjectProperty(___arguments.context.pageData, 'PageFilter'))));
  rawResponse = (await BackendlessUI.Functions.Custom['fn_2bd132e2c401295ea0df9b5461165e27']((getObjectProperty(___arguments.context.pageData, 'displayOnlyInactive')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c78a54c1345e91a95089218e9a5db89')), 'value')), returnedSQL, (((getObjectProperty(___arguments.context.pageData, 'numberOfPages')) - 1) * 50), 50, null));
  ItemsList = (getObjectProperty(rawResponse, 'ItemsList'));
  ___arguments.context.pageData['totalItems'] = (getObjectProperty(rawResponse, 'TotalMatchingItemsCount'));
  ___arguments.context.pageData['numberOfPages'] = (getObjectProperty(rawResponse, 'NumberOfPages'));
  ___arguments.context.pageData['pageCursor'] = ((getObjectProperty(rawResponse, 'NumberOfPages')) - 1);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', []);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c002d67b2c3add9efd7f3286754f6b0b', ItemsList);
  ___arguments.context.pageData['displayingItemsMessageStart'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b'))[0]), 'ItemName')));
  ___arguments.context.pageData['displayingItemsMessageEnd'] = (String(getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c002d67b2c3add9efd7f3286754f6b0b')).slice(-1)[0]), 'ItemName')));
  console.log(getObjectProperty((await Backendless.UserService.getCurrentUser(true)), 'CustomerPortalOnly'));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((Number((getObjectProperty(___arguments.context.pageData, 'pageCursor')))) + 1 >= (Number((getObjectProperty(___arguments.context.pageData, 'numberOfPages'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c1088deaefb8ef636c8696bc0935b758'))['background-color'] = '#7C0323';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d2b88fb854b98c18811833c87561e328/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'exportFileName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = (await (async function(downloadURL, userToken, fileName) {
  	const response = await fetch(downloadURL, {
  	  method: "GET",
  	  headers: {
  	    "user-token": userToken
  	  }
  	});
  	
  	if (!response.ok) {
  	  throw new Error("Download failed");
  	}
  	
  	const blob = await response.blob();
  	const url = URL.createObjectURL(blob);
  	
  	const a = document.createElement("a");
  	a.href = url;
  	a.download = fileName;
  	document.body.appendChild(a);
  	a.click();
  	
  	a.remove();
  	URL.revokeObjectURL(url);
  })((String('https://api.biltsolutions.com/api/files/') + String(getObjectProperty(___arguments.context.pageData, 'downloadCSV_URL'))), ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('BILTUserToken')), (getObjectProperty(___arguments.context.pageData, 'exportFileName'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/645aa6a86f9b41282ff86ec8ab085678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'exportFileName')) != null) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/86699b47abb4089889c86c58c39ba178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['exportFileName'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/6ea83c8639ba3ea8c22862485d835e98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if ((getObjectProperty(currentUser, 'DEBUG_ENABLED')) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer'))['HasProblems'] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')));
  ___arguments.context.pageData['NeedToSave'] = true;

  },
  /* handler:onClick */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord_Drawer')), 'HasProblems')) == true) {
    return 'Mark item as fixed';
  } else {
    return 'Mark item as having issues!';
  }

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/cfd299883458265a92a8c231eda8a20f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ShowCart'] = (!(getObjectProperty(___arguments.context.pageData, 'ShowCart')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/cf81ade8477916482eb81a62d2082aa7/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  ['isOpenLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ShowCart'))

  },
  /* handler:isOpenLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClose */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22d5d963acf823088e76aa73f108a308', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));
  console.log('Drawer: OnOpen Event');

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/865cc98e3e38458de22f7bf859feef01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['ShowCart'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d6889a6b5eb8318a8968dee881faf448/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'CreateNewOrderEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#054575';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d6889a6b5eb8318a8968dee881faf448'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: [(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),'_',(getObjectProperty(___arguments.context.pageData, 'NewOrderName'))].join(''),[`SelectedCustomer`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69657329ebf9b9e8d8d8ba6b548836f8'))['value'] = '';
    await Backendless.Data.of('BILTCarts').save(({ [`CartName`]: (getObjectProperty(___arguments.context.pageData, 'NewOrderName')),[`SelectedCustomer`]: 'BILT',[`CartPayload`]: [],[`CartID`]: (generateUUID().short()) }), true);
  }
  ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/69657329ebf9b9e8d8d8ba6b548836f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = true;
    ___arguments.context.pageData['NewOrderName'] = ___arguments.value;
  } else {
    ___arguments.context.pageData['CreateNewOrderEnabled'] = false;
    ___arguments.context.pageData['NewOrderName'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/44c1a7187418c1bd73f84f08a09842e8/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var item, listConstruct, options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Array.isArray((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')))) {
    return [({ [`groupLabel`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')),[`children`]: (await Promise.all((getObjectProperty(___arguments.context.pageData, 'authorizedCarts')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'CartID')),[`label`]: (getObjectProperty(item, 'CartName')) });}))) })];
  } else {
    return [];
  }

  },
  /* handler:optionsLogic */
  /* handler:disabledLogic */
  ['disabledLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'DisableCartSelector'))

  },
  /* handler:disabledLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var selectedCartObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SelectedCart'] = ___arguments['inputValue'];
  selectedCartObject = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['CartID = \'',(getObjectProperty(___arguments.context.pageData, 'SelectedCart')),'\''].join(''))).setPageSize(1)))[0];
  ___arguments.context.pageData['SelectedCartName'] = (getObjectProperty(selectedCartObject, 'CartName'));
  ___arguments.context.pageData['SelectedCartObjectId'] = (getObjectProperty(selectedCartObject, 'objectId'));
  ___arguments.context.pageData['SelectedCartPayload'] = (getObjectProperty(selectedCartObject, 'CartPayload'));
  console.log('%c>> ' + 'pageData.SelectedCart', 'color: null', ___arguments['inputValue']);
  console.log('%c>> ' + 'pageData.SelectedCartName', 'color: null', ___arguments['inputValue']);

  },
  /* handler:onChange */
  /* handler:onButtonClearClick */
  ['onButtonClearClick'](___arguments) {
      ___arguments.context.pageData['SelectedCartName'] = '';
  ___arguments.context.pageData['SelectedCartPayload'] = [];
  ___arguments.context.pageData['SelectedCartObjectId'] = null;

  },
  /* handler:onButtonClearClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2208db88c0c8e9a82168c0b87618241f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, CustomerPortalAccess, customerCharacterLength, item, response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ReturnCarts() {
  filteredList = [];
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = (await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  }
  return filteredList
}


  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'SelectedCartName')) === 'undefined')) {
    response = (await (async function(CartName) {
    	
    	if (confirm("Delete the selected shopping cart: " + CartName + " ?") == true) {
    	  return true;
    	} else {
    	  return false;
    	}
    })((getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))));
  }
  console.log('Response?');
  console.log(response);
  if (response) {
    await Backendless.Data.of('BILTCarts').remove( (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')) );
    ___arguments.context.pageData['SelectedCartName'] = null;
    ___arguments.context.pageData['authorizedCarts'] = (await ReturnCarts());
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/9db26dc819a8d4fba84800fece188518/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, decision, item, CustomerPortalAccess, customerCharacterLength;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    filteredList = [];
    CustomerPortalAccess = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess'));
    customerCharacterLength = getValueLength(CustomerPortalAccess);
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setWhereClause((['SelectedCustomer = \'',CustomerPortalAccess,'\''].join(''))).setPageSize(100))), async (item) => {
       if ((getObjectProperty(item, 'CartName')).slice(0, customerCharacterLength + 1) == String(CustomerPortalAccess) + String('_')) {
        decision = true;
      } else {
        decision = false;
      }


     return decision;
    }));
    console.log('%c>> ' + 'OUTPUT', 'color: #f06292', filteredList);
  } else {
    filteredList = [];
    filteredList = (await asyncListFilter((await Backendless.Data.of('BILTCarts').find(Backendless.DataQueryBuilder.create().setPageSize(100))), async (item) => {


     return decision;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/312b81a72a58af2348885e088ee83623/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/d928eef86158f33fda9875e8cce8fea8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/5ad85908f575f5a836d84d085688f326/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('%c>> ' + 'pageData.SelectedCartPayload', 'color: null', (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/0bb42898042812f843dab20885e8bb78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'ItemSKU'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/46a8a8a43e8841486bd84af83fe81218/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/8058313f72dae8874168e348237810f5/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    var selectedCartObject;


  console.log('Visibility Changed!!!');

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/22d5d963acf823088e76aa73f108a308/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/80fe5f82c39b790b057a1dd8502494df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return (!inList)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inList, j, list, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 1 });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), tempObject);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/68381206390881c8383c9d55d7944828/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var inList, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(j, 'ItemSKU'))) {
        inList = true;
      }
    }
  }

  return inList

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, tempObject, inList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  inList = false;
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'StoreEnabled')) == true) {
    tempObject = ({ [`ItemName`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemName')),[`ItemSKU`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')),[`Qty`]: 0 });
    ___arguments.context.pageData['SelectedCartPayload'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')), async (item) => {
       if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('621f81b8ed8ca50c4f6b35869e9e13e8'), 'ItemSKU')) == (getObjectProperty(item, 'ItemSKU'))) {
        return false;
      } else {
        return true;
      }


     return item;
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/df0bf8c87f4e57e8e007198bbf565bb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) + 1);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/2808462816ef88a8a068d93820187e28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) - 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32'), 'Qty')) < 0) {
    ___arguments.context.getComponentDataStoreByUid('f5d8326b37e807d86c68e728ddb2bc32')['Qty'] = 0;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inventory-assemblies_backup_10-02-26_MOD/components/c46998d93e6ae2681a4879d8bd7d1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('BILTCarts').save(({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartObjectId')),[`CartPayload`]: (getObjectProperty(___arguments.context.pageData, 'SelectedCartPayload')) }), true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, password, username, user, redirectData, redirectToPageName, stayLoggedIn, sendUserTokenAndId, redirectToUrl, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, true  ));

  } catch (error) {
    await setError(error);

  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    localStorage.setItem('BILTUserToken', JSON.stringify((getObjectProperty(user, 'user-token'))));
    ___arguments.context.appData['currentUser'] = user;
    ___arguments.context.appData['CustomerPortalAccess'] = (getObjectProperty(user, 'CustomerPortalAccess'));
    ___arguments.context.appData['ACCESSLOCK'] = (getObjectProperty(user, 'CustomerPortalOnly'));
    ___arguments.context.appData['PRODUCTIONMODE'] = (getObjectProperty(user, 'ProductionMode'));
    if ((getObjectProperty(___arguments.context.appData, 'ACCESSLOCK')) == true) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inventory-assemblies', undefined);
    } else {
      if (redirectToUrl) {
        (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (getObjectProperty(user, 'user-token')),[`userId`]: (getObjectProperty(user, 'objectId')),[`stayLoggedIn`]: stayLoggedIn }) : ''));
      } else if (redirectToPageName) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('processing_portal', undefined);
      }
    }
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var redirectData, redirectToPageName, currentUser, sendUserTokenAndId, redirectToUrl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  if (currentUser) {
    if (redirectToUrl) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (await (async function() {
      	return Backendless.UserService.getCurrentUserToken()
      })()),[`userId`]: (getObjectProperty(currentUser, 'objectId')),[`stayLoggedIn`]: true }) : ''));
    } else if (redirectToPageName) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
    } else {
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/processing_portal/components/0e619b428d73ef0f5c9163a74a278617/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/f9a5c6bb4a37659a40d9939c2c53afbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result;


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca'))['selected'] = 'null';
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  if (result) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    ___arguments.context.pageData['AssignEnabled'] = true;
    ___arguments.context.pageData['AssignPlusEnabled'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['AssignEnabled'] = false;
    ___arguments.context.pageData['AssignPlusEnabled'] = false;
  }
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/90e367b4f067ac5b85377b386be28b53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await (async function() {
  	location.reload()
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/d3bd969898549a22cb2382cde44812b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var currentUser, temp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  temp = (typeof (getObjectProperty(___arguments.context.appData, 'currentUser.CustomerPortalOnly')) === 'undefined');
  if (temp == true) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedRecord'] = '';
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/processing_portal/components/039d301f2eb51eb1b901b2ed18fbbe91/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;


  ___arguments.context.pageData['NewSpecimenID'] = ___arguments.value;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;
  console.log(result);

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['border'] = '4';

  },
  /* handler:onFocus */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')));
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/processing_portal/components/a00513ada6a71e7a7c0c29a983b996ca/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  async ['optionsLogic'](___arguments) {
    var rawProvidersList, item, ActiveProvidersList, j;


  rawProvidersList = (await Backendless.Data.of('Processing_Definitions').find(Backendless.DataQueryBuilder.create().setSortBy('ProviderName ASC').setPageSize(10)));

  return [({ [`key`]: '1',[`label`]: 'USWellness',[`data`]: 'USWhomekitorders',[`children`]: undefined })]

  },
  /* handler:optionsLogic */
  /* handler:onSelect */
  ['onSelect'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments['selectedItem']);
  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedTableName'] = (getObjectProperty(___arguments['selectedItem'], 'data'));
  ___arguments.context.pageData['SelectedProvider'] = (getObjectProperty(___arguments['selectedItem'], 'label'));
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;

  },
  /* handler:onSelect */
  /* handler:onUnselect */
  ['onUnselect'](___arguments) {
    var result;


  ___arguments.context.pageData['AssignEnabled'] = false;
  ___arguments.context.pageData['AssignPlusEnabled'] = false;
  ___arguments.context.pageData['SelectedTableName'] = '';
  ___arguments.context.pageData['SelectedRecord'] = '';
  ___arguments.context.pageData['UndoEnabled'] = false;
  ___arguments.context.pageData['SelectedProvider'] = 'NONE!!!';

  },
  /* handler:onUnselect */
  /* content */
}))

define('./pages/processing_portal/components/33dd734c62b7a0a58161c28a989b779c/bundle.js', [], () => ({
  /* content */
  /* handler:onTableNameAssignment */
  ['onTableNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))

  },
  /* handler:onTableNameAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var returnedCache, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.selectedRecord);
  ___arguments.context.pageData['SelectedRecord'] = ___arguments.selectedRecord;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  if (result) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    ___arguments.context.pageData['AssignEnabled'] = true;
    ___arguments.context.pageData['AssignPlusEnabled'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['AssignEnabled'] = false;
    ___arguments.context.pageData['AssignPlusEnabled'] = false;
  }
  if (await Backendless.Cache.contains((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')))) {
    returnedCache = (await Backendless.Cache.get((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId'))));
    ___arguments.context.pageData['StoredCache'] = returnedCache;
    ___arguments.context.pageData['UndoEnabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    ___arguments.context.pageData['UndoEnabled'] = false;
  }

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/processing_portal/components/2f8aa707a909ef31a0abc0a4399a9c34/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Selected Record: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'OrderID')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/processing_portal/components/078603bc91cf99ff8dfd00954ea8bb48/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AssignEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('078603bc91cf99ff8dfd00954ea8bb48'))['background-color'] = '#027142';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTracking'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    console.log(tempObject);
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTrackingID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['UndoEnabled'] = false;
    ___arguments.context.pageData['SelectedRecord'] = '';
  }
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/20dfed05e8a6876b990ad1da8c4e4e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject, storedCacheObjectID, storedCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = '';
    tempObject['InboundTracking'] = '';
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = '';
    tempObject['InboundTrackingID'] = '';
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
    ___arguments.context.pageData['UndoEnabled'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')) == '') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('20dfed05e8a6876b990ad1da8c4e4e48'))['background-color'] = '#8C093A';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/processing_portal/components/bed8ddd4e4e50db18d8d7f29f3471e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var result, tempObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Cache.put((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 'objectId')), (getObjectProperty(___arguments.context.pageData, 'SelectedRecord')), 7200);
  if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['SpecimenID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTracking'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    console.log(tempObject);
    ___arguments.context.pageData['SelectedRecord'] = '';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
    tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
    tempObject['kit_order_no'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')), 'value'));
    tempObject['InboundTrackingID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e')), 'value'));
    await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
    ___arguments.context.pageData['SelectedRecord'] = '';
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b85fdc7dfb2fe2e87b27b8d9bb1bf1e'))['value'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca'))['selected'] = 'null';
  ___arguments.context.pageData['UndoEnabled'] = false;
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f9a5c6bb4a37659a40d9939c2c53afbd')));
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('039d301f2eb51eb1b901b2ed18fbbe91')));
  ___arguments.context.pageData['NewSpecimenID'] = '';
  ___arguments.context.pageData['NewInboundTracking'] = '';
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'AssignPlusEnabled')) != true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#B1B3B2';
    return true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bed8ddd4e4e50db18d8d7f29f3471e1d'))['background-color'] = '#027142';
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/processing_portal/components/f0018178865dea330e04ce42134af1fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'UndoEnabled')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#9B9001';
    return false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f0018178865dea330e04ce42134af1fe'))['background-color'] = '#B1B3B2';
    return true;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempObject, storedCacheObjectID, storedCache;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  storedCache = (getObjectProperty(___arguments.context.pageData, 'StoredCache'));
  storedCacheObjectID = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'objectId'));
  if (storedCache != '') {
    if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'USWhomekitorders') {
      tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
      tempObject['SpecimenID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'SpecimenID'));
      tempObject['InboundTracking'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'InboundTracking'));
      await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
      console.log(tempObject);
      await Backendless.Cache.remove(storedCacheObjectID);
      ___arguments.context.pageData['UndoEnabled'] = false;
      ___arguments.context.pageData['SelectedRecord'] = '';
    } else if ((getObjectProperty(___arguments.context.pageData, 'SelectedTableName')) == 'LabSavvy') {
      tempObject = (getObjectProperty(___arguments.context.pageData, 'SelectedRecord'));
      tempObject['kit_order_no'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'kit_order_no'));
      tempObject['InboundTrackingID'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'StoredCache')), 'InboundTrackingID'));
      await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'SelectedTableName'))).save( tempObject );
      await Backendless.Cache.remove(storedCacheObjectID);
      ___arguments.context.pageData['UndoEnabled'] = false;
      ___arguments.context.pageData['SelectedRecord'] = '';
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/processing_portal/components/1b85fdc7dfb2fe2e87b27b8d9bb1bf1e/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  ['onKeyDown'](___arguments) {
      if (___arguments.keyCode == 13) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a00513ada6a71e7a7c0c29a983b996ca')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;


  ___arguments.context.pageData['NewInboundTracking'] = ___arguments.value;
  result = (await BackendlessUI.Functions.Custom['fn_a063ed0d1c0764c1ef1977f838bd4dd3'](___arguments.context.pageData));
  ___arguments.context.pageData['AssignEnabled'] = result;
  ___arguments.context.pageData['AssignPlusEnabled'] = result;
  console.log(result);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/processing_portal/components/ad62683f801568a5b40f7049a735d02b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewSpecimenID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/processing_portal/components/e608b9673b411332c4024c188e9a53d4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'NewInboundTracking'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/processing_portal/components/589ad40bb865f2b3d2952b0222bd2f04/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SelectedProvider'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/processing_portal/components/c002d67b2c3add9efd7f3286754f6b0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'DISABLEPAGE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/processing_portal/components/6ecf50789a51c268967b15a7b4c897f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'DISABLEPAGE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shipping_dash/components/0e619b428d73ef0f5c9163a74a278617/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SearchQuery'] = 'In-Transit';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/86bd57d860e1c2d61b310d2b28073787/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'SearchQuery')) == 'All') {
    return '';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SearchQuery')) == 'In-Transit') {
    return 'CurrentShippingStatus LIKE \'%Shipped\'';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SearchQuery')) == 'Delivered') {
    return 'CurrentShippingStatus LIKE \'%Delivered\' OR CurrentShippingStatus LIKE \'%Received\'';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SearchQuery')) == 'Delivery Exception') {
    return 'CurrentShippingStatus LIKE \'%Delayed\' OR CurrentShippingStatus LIKE \'%Lost\'';
  } else if ((getObjectProperty(___arguments.context.pageData, 'SearchQuery')) == 'Pending') {
    return 'CurrentShippingStatus LIKE \'%Pending\'';
  }

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/shipping_dash/components/f9a5c6bb4a37659a40d9939c2c53afbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SearchQuery'] = 'All';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/0cb4be4194ec917cfde9f0d9234265ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SearchQuery'] = 'Delivered';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/90e367b4f067ac5b85377b386be28b53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SearchQuery'] = 'Delivery Exception';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/d3bd969898549a22cb2382cde44812b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['SearchQuery'] = 'Pending';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/1764b19586f29de4904f53e82d84802c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var HTMLResults;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  HTMLResults = (await Backendless.Request.get(`${Backendless.appPath}/services/LabSavvy/USPS/${(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed13e34e2d362e8f927c3763a4c5b01d')), 'value'))}`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  ___arguments.context.pageData['HTMLResults'] = HTMLResults;
  console.log((getObjectProperty(___arguments.context.pageData, 'HTMLResults')).indexOf('"tb-status">') + 1);
  console.log(getObjectProperty(___arguments.context.pageData, 'HTMLResults'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shipping_dash/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) == true) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('customer-portal', undefined);
  } else {
    currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser')) ? (getObjectProperty(___arguments.context.appData, 'currentUser')) : (await Backendless.UserService.getCurrentUser(false));
    if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
      ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    }
    if ((getObjectProperty(___arguments.context.appData, 'currentUser')) == null) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/shipping_dash/components/cdae62c77b6da0b1a9b317616b1627c8/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      await (async function() {
  	alert("Boom!");
  })();

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./components/reusable/r_08064037f7c9ea55127f500a1f2ca592/logic/0928c1c4736fe3949e3c75684b3b7fee/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    
  },
  /* handler:onMouseOver */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Logout user: ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')),' | Customer Portal: ',(getObjectProperty(___arguments.context.appData, 'CustomerPortalAccess'))].join(''))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_08064037f7c9ea55127f500a1f2ca592/logic/a1328e0854189b182be8fa685c28ba21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.UserService.getCurrentUser(false));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/0928c1c4736fe3949e3c75684b3b7fee/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      console.log('%c>> ' + 'User Details: ', 'color: null', (await Backendless.UserService.getCurrentUser(false)));

  },
  /* handler:onMouseOver */
  /* handler:onTooltipTextAssignment */
  async ['onTooltipTextAssignment'](___arguments) {
    var results;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_3195e83b2ec43b1473c66d77d0fe9fdd'](['Logout user: ► ', (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')), '\n', (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')) ? ['Customer Portal: ► ', (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalAccess')), '\n'] : ['User Rights: ► ', (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'UserRights'))], null]))

  },
  /* handler:onTooltipTextAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/4ed87f68cb195108dc085f84ad32f083/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'ACCESSLOCK')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/ac1b7b02cc3b9b57717bc723094acfe5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'ACCESSLOCK')) != true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/56289f087dc82df867a84558e9e87a97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'DISABLEPAGE')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/5f881af844f6d6210604adc848a60e19/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/3a4f47ef20f860e88388812685c89388/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/f75838d845d8fe5897e861b8b57bced7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'CustomerPortalOnly')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_3189a4cd30f2f0a20853a8227947a50b/logic/8f0acd43fb1897a8d218598890787093/bundle.js', [], () => ({
  /* content */
  /* handler:onTooltipTextAssignment */
  ['onTooltipTextAssignment'](___arguments) {
      return (String('BILT Software Version: ') + String('071926_B1'))

  },
  /* handler:onTooltipTextAssignment */
  /* content */
}))

